var __typeError = (msg) => {
    throw TypeError(msg);
  },
  __accessCheck = (obj, member, msg) =>
    member.has(obj) || __typeError("Cannot " + msg),
  __privateGet = (obj, member, getter) => (
    __accessCheck(obj, member, "read from private field"),
    getter ? getter.call(obj) : member.get(obj)
  ),
  __privateAdd = (obj, member, value) =>
    member.has(obj)
      ? __typeError("Cannot add the same private member more than once")
      : member instanceof WeakSet
      ? member.add(obj)
      : member.set(obj, value),
  __privateSet = (obj, member, value, setter) => (
    __accessCheck(obj, member, "write to private field"),
    setter ? setter.call(obj, value) : member.set(obj, value),
    value
  ),
  __privateMethod = (obj, member, method) => (
    __accessCheck(obj, member, "access private method"), method
  ),
  CountrySelector = class extends HTMLElement {
    constructor() {
      super(),
        (this._onCountryChangedListener = this._onCountryChanged.bind(this));
    }
    connectedCallback() {
      (this.countryElement = this.querySelector('[name="address[country]"]')),
        (this.provinceElement = this.querySelector(
          '[name="address[province]"]'
        )),
        this.countryElement.addEventListener(
          "change",
          this._onCountryChangedListener
        ),
        this.hasAttribute("country") && this.getAttribute("country") !== ""
          ? ((this.countryElement.selectedIndex = Math.max(
              0,
              Array.from(this.countryElement.options).findIndex(
                (option) => option.textContent === this.getAttribute("country")
              )
            )),
            this.countryElement.dispatchEvent(new Event("change")))
          : this._onCountryChanged();
    }
    disconnectedCallback() {
      this.countryElement.removeEventListener(
        "change",
        this._onCountryChangedListener
      );
    }
    _onCountryChanged() {
      const option =
          this.countryElement.options[this.countryElement.selectedIndex],
        provinces = JSON.parse(option.getAttribute("data-provinces"));
      (this.provinceElement.parentElement.hidden = provinces.length === 0),
        provinces.length !== 0 &&
          ((this.provinceElement.innerHTML = ""),
          provinces.forEach((data) => {
            const selected = data[1] === this.getAttribute("province");
            this.provinceElement.options.add(
              new Option(data[1], data[0], selected, selected)
            );
          }));
    }
  };
window.customElements.get("country-selector") ||
  window.customElements.define("country-selector", CountrySelector);
var cachedMap = new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  return cachedMap.has(cacheKey)
    ? Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])))
    : fetch(url, options).then((response) => {
        if (response.status === 200) {
          const contentType = response.headers.get("Content-Type");
          contentType &&
            (contentType.match(/application\/json/i) ||
              contentType.match(/text\//i)) &&
            response
              .clone()
              .text()
              .then((content) => {
                cachedMap.set(cacheKey, content);
              });
        }
        return response;
      });
}
function extractSectionId(element) {
  return (
    (element = element.classList.contains("shopify-section")
      ? element
      : element.closest(".shopify-section")),
    element.id.replace("shopify-section-", "")
  );
}
function deepQuerySelector(root, selector) {
  let element = root.querySelector(selector);
  if (element) return element;
  for (const template2 of root.querySelectorAll("template"))
    if (((element = deepQuerySelector(template2.content, selector)), element))
      return element;
  return null;
}
function throttle(callback) {
  let requestId = null,
    lastArgs;
  const later = (context) => () => {
      (requestId = null), callback.apply(context, lastArgs);
    },
    throttled = (...args) => {
      (lastArgs = args),
        requestId === null && (requestId = requestAnimationFrame(later(this)));
    };
  return (
    (throttled.cancel = () => {
      cancelAnimationFrame(requestId), (requestId = null);
    }),
    throttled
  );
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer),
      (timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay));
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      event.target === element &&
        (element.removeEventListener(eventName, done), resolve(event));
    };
    element.addEventListener(eventName, done);
  });
}
var _callback,
  _duration,
  _remainingTime,
  _startTime,
  _timer,
  _state,
  _onVisibilityChangeListener,
  _Player_instances,
  onVisibilityChange_fn,
  Player = class extends EventTarget {
    constructor(durationInSec, stopOnVisibility = !0) {
      super(),
        __privateAdd(this, _Player_instances),
        __privateAdd(this, _callback),
        __privateAdd(this, _duration),
        __privateAdd(this, _remainingTime),
        __privateAdd(this, _startTime),
        __privateAdd(this, _timer),
        __privateAdd(this, _state, "paused"),
        __privateAdd(
          this,
          _onVisibilityChangeListener,
          __privateMethod(this, _Player_instances, onVisibilityChange_fn).bind(
            this
          )
        ),
        __privateSet(this, _callback, () =>
          this.dispatchEvent(new CustomEvent("player:end"))
        ),
        this.setDuration(durationInSec),
        stopOnVisibility &&
          document.addEventListener(
            "visibilitychange",
            __privateGet(this, _onVisibilityChangeListener)
          );
    }
    getDuration() {
      return __privateGet(this, _duration) / 1e3;
    }
    setDuration(durationInSec) {
      __privateSet(
        this,
        _duration,
        __privateSet(this, _remainingTime, durationInSec * 1e3)
      );
    }
    pause() {
      __privateGet(this, _state) === "started" &&
        (clearTimeout(__privateGet(this, _timer)),
        __privateSet(this, _state, "paused"),
        __privateSet(
          this,
          _remainingTime,
          __privateGet(this, _remainingTime) -
            (new Date().getTime() - __privateGet(this, _startTime))
        ),
        this.dispatchEvent(
          new CustomEvent("player:pause", {
            detail: {
              duration: __privateGet(this, _duration) / 1e3,
              remainingTime: __privateGet(this, _remainingTime) / 1e3,
            },
          })
        ));
    }
    resume(restartTimer = !1) {
      __privateGet(this, _state) !== "stopped" &&
        (restartTimer
          ? this.start()
          : (clearTimeout(__privateGet(this, _timer)),
            __privateSet(this, _startTime, new Date().getTime()),
            __privateSet(this, _state, "started"),
            __privateSet(
              this,
              _timer,
              setTimeout(
                __privateGet(this, _callback),
                __privateGet(this, _remainingTime)
              )
            ),
            this.dispatchEvent(
              new CustomEvent("player:resume", {
                detail: {
                  duration: __privateGet(this, _duration) / 1e3,
                  remainingTime: __privateGet(this, _remainingTime) / 1e3,
                },
              })
            )));
    }
    start() {
      clearTimeout(__privateGet(this, _timer)),
        __privateSet(this, _startTime, new Date().getTime()),
        __privateSet(this, _state, "started"),
        __privateSet(this, _remainingTime, __privateGet(this, _duration)),
        __privateSet(
          this,
          _timer,
          setTimeout(
            __privateGet(this, _callback),
            __privateGet(this, _remainingTime)
          )
        ),
        this.dispatchEvent(
          new CustomEvent("player:start", {
            detail: {
              duration: __privateGet(this, _duration) / 1e3,
              remainingTime: __privateGet(this, _remainingTime) / 1e3,
            },
          })
        );
    }
    stop() {
      clearTimeout(__privateGet(this, _timer)),
        __privateSet(this, _state, "stopped"),
        this.dispatchEvent(new CustomEvent("player:stop"));
    }
  };
(_callback = new WeakMap()),
  (_duration = new WeakMap()),
  (_remainingTime = new WeakMap()),
  (_startTime = new WeakMap()),
  (_timer = new WeakMap()),
  (_state = new WeakMap()),
  (_onVisibilityChangeListener = new WeakMap()),
  (_Player_instances = new WeakSet()),
  (onVisibilityChange_fn = function () {
    document.visibilityState === "hidden"
      ? this.pause()
      : document.visibilityState === "visible" && this.resume();
  });
var ConfirmButton = class extends HTMLButtonElement {
  constructor() {
    super(),
      this.addEventListener("click", (event) => {
        window.confirm(
          this.getAttribute("data-message") ??
            "Are you sure you wish to do this?"
        ) || event.preventDefault();
      });
  }
};
window.customElements.get("confirm-button") ||
  window.customElements.define("confirm-button", ConfirmButton, {
    extends: "button",
  });
var PageDots = class extends HTMLElement {
    connectedCallback() {
      (this._abortController = new AbortController()),
        (this.items = Array.from(this.children)),
        this.items.forEach((button, index) =>
          button.addEventListener("click", () => this.select(index), {
            signal: this._abortController.signal,
          })
        ),
        this.addEventListener("control:filter", this._filterItems, {
          signal: this._abortController.signal,
        }),
        this.controlledElement &&
          this.controlledElement.addEventListener(
            "carousel:change",
            (event) => this.select(event.detail.index, !1),
            { signal: this._abortController.signal }
          ),
        Shopify.designMode &&
          this.addEventListener("shopify:block:select", (event) =>
            this.select(this.items.indexOf(event.target))
          );
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get controlledElement() {
      return this.hasAttribute("aria-controls")
        ? document.getElementById(this.getAttribute("aria-controls"))
        : null;
    }
    get selectedIndex() {
      return this.items.findIndex(
        (button) => button.getAttribute("aria-current") === "true"
      );
    }
    select(selectedIndex, dispatchEvent = !0) {
      if (this.hasAttribute("align-selected")) {
        const scrollElement =
          this.getAttribute("align-selected") !== ""
            ? this.closest(this.getAttribute("align-selected"))
            : this;
        scrollElement.scrollTo({
          left:
            this.items[selectedIndex].offsetLeft -
            scrollElement.clientWidth / 2 +
            this.items[selectedIndex].clientWidth / 2,
          top:
            this.items[selectedIndex].offsetTop -
            scrollElement.clientHeight / 2 -
            this.items[selectedIndex].clientHeight / 2,
          behavior: window.matchMedia("(prefers-reduced-motion: no-preference)")
            .matches
            ? "smooth"
            : "auto",
        });
      }
      this.selectedIndex !== selectedIndex &&
        (this.items.forEach((button, index) =>
          button.setAttribute(
            "aria-current",
            selectedIndex === index ? "true" : "false"
          )
        ),
        dispatchEvent && this._dispatchEvent(selectedIndex));
    }
    _filterItems(event) {
      this.items.forEach(
        (item, index) =>
          (item.hidden = event.detail.filteredIndexes.includes(index))
      );
    }
    _dispatchEvent(index) {
      (this.controlledElement ?? this).dispatchEvent(
        new CustomEvent("control:select", {
          bubbles: !0,
          cancelable: !0,
          detail: { index },
        })
      );
    }
  },
  PrevButton = class extends HTMLButtonElement {
    connectedCallback() {
      (this._abortController = new AbortController()),
        this.addEventListener(
          "click",
          () =>
            (this.controlledElement ?? this).dispatchEvent(
              new CustomEvent("control:prev", { bubbles: !0, cancelable: !0 })
            ),
          { signal: this._abortController.signal }
        ),
        this.controlledElement &&
          (this.controlledElement.addEventListener(
            "scroll:edge-nearing",
            (event) => (this.disabled = event.detail.position === "start"),
            { signal: this._abortController.signal }
          ),
          this.controlledElement.addEventListener(
            "scroll:edge-leaving",
            (event) =>
              (this.disabled =
                event.detail.position === "start" ? !1 : this.disabled),
            { signal: this._abortController.signal }
          ));
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get controlledElement() {
      return this.hasAttribute("aria-controls")
        ? document.getElementById(this.getAttribute("aria-controls"))
        : null;
    }
  },
  NextButton = class extends HTMLButtonElement {
    connectedCallback() {
      (this._abortController = new AbortController()),
        this.addEventListener(
          "click",
          () =>
            (this.controlledElement ?? this).dispatchEvent(
              new CustomEvent("control:next", { bubbles: !0, cancelable: !0 })
            ),
          { signal: this._abortController.signal }
        ),
        this.controlledElement &&
          (this.controlledElement.addEventListener(
            "scroll:edge-nearing",
            (event) => (this.disabled = event.detail.position === "end"),
            { signal: this._abortController.signal }
          ),
          this.controlledElement.addEventListener(
            "scroll:edge-leaving",
            (event) =>
              (this.disabled =
                event.detail.position === "end" ? !1 : this.disabled),
            { signal: this._abortController.signal }
          ));
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get controlledElement() {
      return this.hasAttribute("aria-controls")
        ? document.getElementById(this.getAttribute("aria-controls"))
        : null;
    }
  };
window.customElements.get("page-dots") ||
  window.customElements.define("page-dots", PageDots),
  window.customElements.get("prev-button") ||
    window.customElements.define("prev-button", PrevButton, {
      extends: "button",
    }),
  window.customElements.get("next-button") ||
    window.customElements.define("next-button", NextButton, {
      extends: "button",
    });
import { timeline } from "vendor";
var CopyButton = class extends HTMLButtonElement {
  constructor() {
    super(),
      this.append(this.contentElement, this.animationElement),
      this.addEventListener("click", this._copyToClipboard.bind(this));
  }
  get contentElement() {
    return this._contentElement
      ? this._contentElement
      : ((this._contentElement = document.createElement("div")),
        this._contentElement.append(...this.childNodes),
        (this._contentElement =
          this._contentElement || document.createElement("div").append()));
  }
  get animationElement() {
    return (this._animationElement =
      this._animationElement ||
      document.createRange().createContextualFragment(`
      <span class="button__feedback">  
        <svg role="presentation" focusable="false" fill="none" width="18px" height="18px" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
          <path d="m6 9.8 2.63 2.8L14 7" stroke="currentColor" stroke-width="2"/>
        </svg>
      </span>
    `).firstElementChild);
  }
  async _copyToClipboard() {
    navigator.clipboard &&
      (await navigator.clipboard.writeText(
        this.getAttribute("data-text") || ""
      ),
      timeline([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [this.animationElement, { opacity: [0, 1] }, { duration: 0.15 }],
        [this.animationElement, { opacity: 0 }, { duration: 0.15, at: "+0.5" }],
        [this.contentElement, { opacity: 1 }, { duration: 0.15 }],
      ]));
  }
};
window.customElements.get("copy-button") ||
  window.customElements.define("copy-button", CopyButton, {
    extends: "button",
  });
import { animate, timeline as timeline2, stagger } from "vendor";
var CustomButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super(),
      this.type === "submit" &&
        this.form &&
        this.form.addEventListener("submit", () =>
          this.setAttribute("aria-busy", "true")
        ),
      this.append(this.contentElement, this.animationElement),
      window.addEventListener("pageshow", () =>
        this.removeAttribute("aria-busy")
      );
  }
  get contentElement() {
    return this._contentElement
      ? this._contentElement
      : ((this._contentElement = document.createElement("div")),
        this._contentElement.append(...this.childNodes),
        (this._contentElement =
          this._contentElement || document.createElement("div").append()));
  }
  get animationElement() {
    return (this._animationElement =
      this._animationElement ||
      document.createRange().createContextualFragment(`
      <span class="button__loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `).firstElementChild);
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    newValue === "true"
      ? (timeline2([
          [
            this.contentElement,
            { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 },
            { duration: 0.15 },
          ],
          [
            this.animationElement,
            { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 },
            { duration: 0.15 },
          ],
        ]),
        animate(
          this.animationElement.children,
          { opacity: [1, 0.1] },
          {
            duration: 0.35,
            delay: stagger(0.35 / 3),
            direction: "alternate",
            repeat: 1 / 0,
          }
        ))
      : timeline2([
          [
            this.animationElement,
            { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 },
            { duration: 0.15 },
          ],
          [
            this.contentElement,
            { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 },
            { duration: 0.15 },
          ],
        ]);
  }
};
window.customElements.get("custom-button") ||
  window.customElements.define("custom-button", CustomButton, {
    extends: "button",
  });
var ShareButton = class extends HTMLButtonElement {
  constructor() {
    super(),
      navigator.share && this.addEventListener("click", this._showSystemShare);
  }
  _showSystemShare() {
    navigator.share({
      title: this.hasAttribute("share-title")
        ? this.getAttribute("share-title")
        : document.title,
      url: this.hasAttribute("share-url")
        ? this.getAttribute("share-url")
        : window.location.href,
    });
  }
};
window.customElements.get("share-button") ||
  window.customElements.define("share-button", ShareButton, {
    extends: "button",
  });
import { stagger as stagger2 } from "vendor";
function getHeadingKeyframe(element, options = {}) {
  if (!element) return [];
  const splitLines = element.querySelector("split-lines")?.lines;
  if (
    window.themeVariables.settings.headingApparition === "fade" ||
    !splitLines
  )
    return [element, { opacity: [0, 1] }, { duration: 0.2, ...options }];
  switch (
    ((element.style.opacity = "1"),
    window.themeVariables.settings.headingApparition)
  ) {
    case "split_fade":
      return [
        splitLines,
        { transform: ["translateY(0.5em)", "translateY(0)"], opacity: [0, 1] },
        { duration: 0.3, delay: stagger2(0.1), ...options },
      ];
    case "split_clip":
      return [
        splitLines,
        {
          clipPath: ["inset(0 0 100% 0)", "inset(0 0 -0.3em 0)"],
          transform: ["translateY(100%)", "translateY(0)"],
          opacity: [0, 1],
        },
        {
          duration: 0.7,
          delay: stagger2(0.15),
          easing: [0.22, 1, 0.36, 1],
          ...options,
        },
      ];
    case "split_rotation":
      const rotatedSpans = splitLines.map((line) => line.querySelector("span"));
      return (
        rotatedSpans.forEach(
          (span) => (span.style.transformOrigin = "top left")
        ),
        splitLines.forEach(
          (line) => (line.style.clipPath = "inset(0 0 -0.3em 0)")
        ),
        [
          rotatedSpans,
          {
            transform: [
              "translateY(0.5em) rotateZ(5deg)",
              "translateY(0) rotateZ(0)",
            ],
            opacity: [0, 1],
          },
          { duration: 0.4, delay: stagger2(0.1), ...options },
        ]
      );
  }
}
import { animate as animate2, stagger as stagger3, inView } from "vendor";
var _RevealItems_instances,
  reveal_fn,
  RevealItems = class extends HTMLElement {
    constructor() {
      super(),
        __privateAdd(this, _RevealItems_instances),
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
          window.themeVariables.settings.staggerProductsApparition &&
          inView(
            this,
            __privateMethod(this, _RevealItems_instances, reveal_fn).bind(this),
            { margin: this.getAttribute("margin") ?? "-50px 0px" }
          );
    }
  };
(_RevealItems_instances = new WeakSet()),
  (reveal_fn = function () {
    (this.style.opacity = "1"),
      animate2(
        this.hasAttribute("selector")
          ? this.querySelectorAll(this.getAttribute("selector"))
          : this.children,
        { opacity: [0, 1], transform: ["translateY(15px)", "translateY(0)"] },
        {
          duration: 0.35,
          delay: stagger3(0.05, { easing: "ease-out" }),
          easing: "ease",
        }
      );
  }),
  window.customElements.get("reveal-items") ||
    window.customElements.define("reveal-items", RevealItems);
var _abortController,
  _CustomCursor_instances,
  onPointerLeave_fn,
  onPointerMove_fn,
  CustomCursor = class extends HTMLElement {
    constructor() {
      super(...arguments),
        __privateAdd(this, _CustomCursor_instances),
        __privateAdd(this, _abortController);
    }
    connectedCallback() {
      __privateSet(this, _abortController, new AbortController()),
        this.parentElement.addEventListener(
          "pointermove",
          __privateMethod(this, _CustomCursor_instances, onPointerMove_fn).bind(
            this
          ),
          { passive: !0, signal: __privateGet(this, _abortController).signal }
        ),
        this.parentElement.addEventListener(
          "pointerleave",
          __privateMethod(
            this,
            _CustomCursor_instances,
            onPointerLeave_fn
          ).bind(this),
          { signal: __privateGet(this, _abortController).signal }
        );
    }
    disconnectedCallback() {
      __privateGet(this, _abortController).abort();
    }
  };
(_abortController = new WeakMap()),
  (_CustomCursor_instances = new WeakSet()),
  (onPointerLeave_fn = function () {
    this.classList.remove("is-visible", "is-half-start", "is-half-end");
  }),
  (onPointerMove_fn = function (event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope"))
      return this.classList.remove("is-visible");
    const parentBoundingRect = this.parentElement.getBoundingClientRect(),
      parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2,
      isOnStartHalfPart = event.pageX < parentXCenter;
    this.classList.toggle("is-half-start", isOnStartHalfPart),
      this.classList.toggle("is-half-end", !isOnStartHalfPart),
      this.classList.add("is-visible");
    const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2,
      mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
    (this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`),
      (this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`);
  }),
  window.customElements.get("custom-cursor") ||
    window.customElements.define("custom-cursor", CustomCursor);
var _domElement,
  _thresholdDistance,
  _thresholdTime,
  _signal,
  _firstClientX,
  _tracking,
  _start,
  _GestureArea_instances,
  touchStart_fn,
  preventTouch_fn,
  gestureStart_fn,
  gestureMove_fn,
  gestureEnd_fn,
  GestureArea = class {
    constructor(
      domElement,
      { thresholdDistance = 80, thresholdTime = 500, signal = null } = {}
    ) {
      __privateAdd(this, _GestureArea_instances),
        __privateAdd(this, _domElement),
        __privateAdd(this, _thresholdDistance),
        __privateAdd(this, _thresholdTime),
        __privateAdd(this, _signal),
        __privateAdd(this, _firstClientX),
        __privateAdd(this, _tracking, !1),
        __privateAdd(this, _start, {}),
        __privateSet(this, _domElement, domElement),
        __privateSet(this, _thresholdDistance, thresholdDistance),
        __privateSet(this, _thresholdTime, thresholdTime),
        __privateSet(this, _signal, signal),
        __privateGet(this, _domElement).addEventListener(
          "touchstart",
          __privateMethod(this, _GestureArea_instances, touchStart_fn).bind(
            this
          ),
          { passive: !0, signal: __privateGet(this, _signal) }
        ),
        __privateGet(this, _domElement).addEventListener(
          "touchmove",
          __privateMethod(this, _GestureArea_instances, preventTouch_fn).bind(
            this
          ),
          { passive: !1, signal: __privateGet(this, _signal) }
        ),
        __privateGet(this, _domElement).addEventListener(
          "pointerdown",
          __privateMethod(this, _GestureArea_instances, gestureStart_fn).bind(
            this
          ),
          { signal: __privateGet(this, _signal) }
        ),
        __privateGet(this, _domElement).addEventListener(
          "pointermove",
          __privateMethod(this, _GestureArea_instances, gestureMove_fn).bind(
            this
          ),
          { passive: !1, signal: __privateGet(this, _signal) }
        ),
        __privateGet(this, _domElement).addEventListener(
          "pointerup",
          __privateMethod(this, _GestureArea_instances, gestureEnd_fn).bind(
            this
          ),
          { signal: __privateGet(this, _signal) }
        ),
        __privateGet(this, _domElement).addEventListener(
          "pointerleave",
          __privateMethod(this, _GestureArea_instances, gestureEnd_fn).bind(
            this
          ),
          { signal: __privateGet(this, _signal) }
        ),
        __privateGet(this, _domElement).addEventListener(
          "pointercancel",
          __privateMethod(this, _GestureArea_instances, gestureEnd_fn).bind(
            this
          ),
          { signal: __privateGet(this, _signal) }
        );
    }
  };
(_domElement = new WeakMap()),
  (_thresholdDistance = new WeakMap()),
  (_thresholdTime = new WeakMap()),
  (_signal = new WeakMap()),
  (_firstClientX = new WeakMap()),
  (_tracking = new WeakMap()),
  (_start = new WeakMap()),
  (_GestureArea_instances = new WeakSet()),
  (touchStart_fn = function (event) {
    __privateSet(this, _firstClientX, event.touches[0].clientX);
  }),
  (preventTouch_fn = function (event) {
    Math.abs(event.touches[0].clientX - __privateGet(this, _firstClientX)) >
      10 && event.preventDefault();
  }),
  (gestureStart_fn = function (event) {
    __privateSet(this, _tracking, !0),
      __privateSet(this, _start, {
        time: new Date().getTime(),
        x: event.clientX,
        y: event.clientY,
      });
  }),
  (gestureMove_fn = function (event) {
    __privateGet(this, _tracking) && event.preventDefault();
  }),
  (gestureEnd_fn = function (event) {
    if (!__privateGet(this, _tracking)) return;
    __privateSet(this, _tracking, !1);
    const now = new Date().getTime(),
      deltaTime = now - __privateGet(this, _start).time,
      deltaX = event.clientX - __privateGet(this, _start).x,
      deltaY = event.clientY - __privateGet(this, _start).y;
    if (deltaTime > __privateGet(this, _thresholdTime)) return;
    let matchedEvent;
    deltaX === 0 &&
    deltaY === 0 &&
    !event.target.matches("a, button, a :scope, button :scope")
      ? (matchedEvent = "tap")
      : deltaX > __privateGet(this, _thresholdDistance) &&
        Math.abs(deltaY) < __privateGet(this, _thresholdDistance)
      ? (matchedEvent = "swiperight")
      : -deltaX > __privateGet(this, _thresholdDistance) &&
        Math.abs(deltaY) < __privateGet(this, _thresholdDistance)
      ? (matchedEvent = "swipeleft")
      : deltaY > __privateGet(this, _thresholdDistance) &&
        Math.abs(deltaX) < __privateGet(this, _thresholdDistance)
      ? (matchedEvent = "swipedown")
      : -deltaY > __privateGet(this, _thresholdDistance) &&
        Math.abs(deltaX) < __privateGet(this, _thresholdDistance) &&
        (matchedEvent = "swipeup"),
      matchedEvent &&
        __privateGet(this, _domElement).dispatchEvent(
          new CustomEvent(matchedEvent, {
            bubbles: !0,
            composed: !0,
            detail: { originalEvent: event },
          })
        );
  });
var HeightObserver = class extends HTMLElement {
  constructor() {
    super(),
      window.ResizeObserver &&
        new ResizeObserver(this._updateCustomProperties.bind(this)).observe(
          this
        );
  }
  connectedCallback() {
    window.ResizeObserver ||
      document.documentElement.style.setProperty(
        `--${this.getAttribute("variable")}-height`,
        `${this.clientHeight.toFixed(1)}px`
      );
  }
  _updateCustomProperties(entries) {
    requestAnimationFrame(() => {
      entries.forEach((entry) => {
        if (entry.target === this) {
          const height = entry.borderBoxSize
            ? entry.borderBoxSize.length > 0
              ? entry.borderBoxSize[0].blockSize
              : entry.borderBoxSize.blockSize
            : entry.target.clientHeight;
          document.documentElement.style.setProperty(
            `--${this.getAttribute("variable")}-height`,
            `${Math.round(height)}px`
          );
        }
      });
    });
  }
};
window.customElements.get("height-observer") ||
  window.customElements.define("height-observer", HeightObserver);
import { inView as inView2 } from "vendor";
var _resizeObserver,
  _checkPositionListener,
  _initialTop,
  _lastKnownY,
  _currentTop,
  _position,
  _SafeSticky_instances,
  recalculateStyles_fn,
  checkPosition_fn,
  SafeSticky = class extends HTMLElement {
    constructor() {
      super(...arguments),
        __privateAdd(this, _SafeSticky_instances),
        __privateAdd(
          this,
          _resizeObserver,
          new ResizeObserver(
            __privateMethod(
              this,
              _SafeSticky_instances,
              recalculateStyles_fn
            ).bind(this)
          )
        ),
        __privateAdd(
          this,
          _checkPositionListener,
          throttle(
            __privateMethod(this, _SafeSticky_instances, checkPosition_fn).bind(
              this
            )
          )
        ),
        __privateAdd(this, _initialTop, 0),
        __privateAdd(this, _lastKnownY, 0),
        __privateAdd(this, _currentTop, 0),
        __privateAdd(this, _position, "relative");
    }
    connectedCallback() {
      inView2(
        this,
        () => (
          __privateGet(this, _resizeObserver).observe(this),
          window.addEventListener(
            "scroll",
            __privateGet(this, _checkPositionListener)
          ),
          () => {
            __privateGet(this, _resizeObserver).unobserve(this),
              window.removeEventListener(
                "scroll",
                __privateGet(this, _checkPositionListener)
              );
          }
        ),
        { margin: "500px" }
      );
    }
    disconnectedCallback() {
      window.removeEventListener(
        "scroll",
        __privateGet(this, _checkPositionListener)
      );
    }
  };
(_resizeObserver = new WeakMap()),
  (_checkPositionListener = new WeakMap()),
  (_initialTop = new WeakMap()),
  (_lastKnownY = new WeakMap()),
  (_currentTop = new WeakMap()),
  (_position = new WeakMap()),
  (_SafeSticky_instances = new WeakSet()),
  (recalculateStyles_fn = function () {
    this.style.removeProperty("top");
    const computedStyles = getComputedStyle(this);
    __privateSet(this, _initialTop, parseInt(computedStyles.top)),
      __privateSet(this, _position, computedStyles.position),
      __privateMethod(this, _SafeSticky_instances, checkPosition_fn).call(this);
  }),
  (checkPosition_fn = function () {
    if (__privateGet(this, _position) !== "sticky")
      return this.style.removeProperty("top");
    let bounds = this.getBoundingClientRect(),
      maxTop =
        bounds.top +
        window.scrollY -
        this.offsetTop +
        __privateGet(this, _initialTop),
      minTop = this.clientHeight - window.innerHeight + 20;
    window.scrollY < __privateGet(this, _lastKnownY)
      ? __privateSet(
          this,
          _currentTop,
          __privateGet(this, _currentTop) -
            (window.scrollY - __privateGet(this, _lastKnownY))
        )
      : __privateSet(
          this,
          _currentTop,
          __privateGet(this, _currentTop) +
            (__privateGet(this, _lastKnownY) - window.scrollY)
        ),
      __privateSet(
        this,
        _currentTop,
        Math.min(
          Math.max(__privateGet(this, _currentTop), -minTop),
          maxTop,
          __privateGet(this, _initialTop)
        )
      ),
      __privateSet(this, _lastKnownY, window.scrollY),
      (this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`);
  }),
  window.customElements.get("safe-sticky") ||
    window.customElements.define("safe-sticky", SafeSticky);
var ScrollArea = class {
    constructor(element, abortController2 = null) {
      (this._element = element),
        (this._allowTriggerNearingStartEvent = !1),
        (this._allowTriggerLeavingStartEvent = !0),
        (this._allowTriggerNearingEndEvent = !0),
        (this._allowTriggerLeavingEndEvent = !1),
        new ResizeObserver(this._checkIfScrollable.bind(this)).observe(element),
        this._element.addEventListener(
          "scroll",
          throttle(this._onScroll.bind(this)),
          { signal: abortController2?.signal }
        );
    }
    get scrollNearingThreshold() {
      return 125;
    }
    get scrollDirection() {
      return this._element.scrollWidth > this._element.clientWidth
        ? "inline"
        : this._element.scrollHeight - this._element.clientHeight > 1
        ? "block"
        : "none";
    }
    _checkIfScrollable() {
      this._element.classList.toggle(
        "is-scrollable",
        this.scrollDirection !== "none"
      );
    }
    _onScroll() {
      clearTimeout(this._scrollTimeout),
        (this._lastScrollPosition =
          this._lastScrollPosition ??
          (this.scrollDirection === "inline"
            ? Math.abs(this._element.scrollLeft)
            : Math.abs(this._element.scrollTop)));
      let direction;
      this.scrollDirection === "inline"
        ? ((direction =
            this._lastScrollPosition > Math.abs(this._element.scrollLeft)
              ? "start"
              : "end"),
          (this._lastScrollPosition = Math.abs(this._element.scrollLeft)))
        : ((direction =
            this._lastScrollPosition > Math.abs(this._element.scrollTop)
              ? "start"
              : "end"),
          (this._lastScrollPosition = Math.abs(this._element.scrollTop)));
      const scrollPosition = Math.round(
          Math.abs(
            this.scrollDirection === "inline"
              ? this._element.scrollLeft
              : this._element.scrollTop
          )
        ),
        scrollMinusSize = Math.round(
          this.scrollDirection === "inline"
            ? this._element.scrollWidth - this._element.clientWidth
            : this._element.scrollHeight - this._element.clientHeight
        );
      direction === "start" &&
      this._allowTriggerNearingStartEvent &&
      scrollPosition <= this.scrollNearingThreshold
        ? ((this._allowTriggerNearingStartEvent = !1),
          (this._allowTriggerLeavingStartEvent = !0),
          this._element.dispatchEvent(
            new CustomEvent("scroll:edge-nearing", {
              bubbles: !0,
              detail: { position: "start" },
            })
          ))
        : direction === "end" &&
          scrollPosition > this.scrollNearingThreshold &&
          ((this._allowTriggerNearingStartEvent = !0),
          this._allowTriggerLeavingStartEvent &&
            ((this._allowTriggerLeavingStartEvent = !1),
            this._element.dispatchEvent(
              new CustomEvent("scroll:edge-leaving", {
                bubbles: !0,
                detail: { position: "start" },
              })
            ))),
        direction === "end" &&
        this._allowTriggerNearingEndEvent &&
        scrollMinusSize <= scrollPosition + this.scrollNearingThreshold
          ? ((this._allowTriggerNearingEndEvent = !1),
            (this._allowTriggerLeavingEndEvent = !0),
            this._element.dispatchEvent(
              new CustomEvent("scroll:edge-nearing", {
                bubbles: !0,
                detail: { position: "end" },
              })
            ))
          : direction === "start" &&
            scrollMinusSize > scrollPosition + this.scrollNearingThreshold &&
            ((this._allowTriggerNearingEndEvent = !0),
            this._allowTriggerLeavingEndEvent &&
              ((this._allowTriggerLeavingEndEvent = !1),
              this._element.dispatchEvent(
                new CustomEvent("scroll:edge-leaving", {
                  bubbles: !0,
                  detail: { position: "end" },
                })
              ))),
        window.onscrollend === void 0 &&
          (this._scrollTimeout = setTimeout(() => {
            this._element.dispatchEvent(
              new CustomEvent("scrollend", { bubbles: !0, composed: !0 })
            );
          }, 75));
    }
  },
  ScrollProgress = class extends HTMLElement {
    connectedCallback() {
      this.scrolledElement.addEventListener(
        "scroll",
        throttle(this._updateScrollProgress.bind(this))
      ),
        window.ResizeObserver &&
          new ResizeObserver(this._updateScrollProgress.bind(this)).observe(
            this.scrolledElement
          );
    }
    get scrolledElement() {
      return (this._scrolledElement =
        this._scrolledElement ||
        document.getElementById(this.getAttribute("observes")));
    }
    _updateScrollProgress() {
      const scrollLeft =
          document.dir === "ltr"
            ? this.scrolledElement.scrollLeft
            : Math.abs(this.scrolledElement.scrollLeft),
        advancement =
          (scrollLeft + this.scrolledElement.clientWidth) /
          this.scrolledElement.scrollWidth;
      this.style.setProperty(
        "--scroll-progress",
        Math.max(0, Math.min(advancement, 1)).toFixed(6)
      );
    }
  };
window.customElements.get("scroll-progress") ||
  window.customElements.define("scroll-progress", ScrollProgress);
var template = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, linear-gradient(to bottom, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-bottom, linear-gradient(to top, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-left, linear-gradient(to right, rgb(var(--background)), rgb(var(--background) / 0))),
        var(--scroll-shadow-right, linear-gradient(to left, rgb(var(--background)), rgb(var(--background) / 0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`,
  Updater = class {
    constructor(targetElement) {
      (this.scheduleUpdate = throttle(() =>
        this.update(targetElement, getComputedStyle(targetElement))
      )),
        (this.resizeObserver = new ResizeObserver(
          this.scheduleUpdate.bind(this)
        ));
    }
    start(element) {
      this.element && this.stop(),
        element &&
          (element.addEventListener("scroll", this.scheduleUpdate),
          this.resizeObserver.observe(element),
          (this.element = element));
    }
    stop() {
      this.element &&
        (this.element.removeEventListener("scroll", this.scheduleUpdate),
        this.resizeObserver.unobserve(this.element),
        (this.element = null));
    }
    update(targetElement, style) {
      if (!this.element) return;
      const maxSize = style.getPropertyValue("--scroll-shadow-size")
          ? parseInt(style.getPropertyValue("--scroll-shadow-size"))
          : 0,
        scroll5 = {
          top: Math.max(this.element.scrollTop, 0),
          bottom: Math.max(
            this.element.scrollHeight -
              this.element.offsetHeight -
              this.element.scrollTop,
            0
          ),
          left: Math.max(this.element.scrollLeft, 0),
          right: Math.max(
            this.element.scrollWidth -
              this.element.offsetWidth -
              this.element.scrollLeft,
            0
          ),
        };
      requestAnimationFrame(() => {
        for (const position of ["top", "bottom", "left", "right"])
          targetElement.style.setProperty(
            `--${position}`,
            `${scroll5[position] > maxSize ? maxSize : scroll5[position]}px`
          );
      });
    }
  },
  ScrollShadow = class extends HTMLElement {
    constructor() {
      super(),
        (this.attachShadow({ mode: "open" }).innerHTML = template),
        (this.updater = new Updater(this.shadowRoot.lastElementChild));
    }
    connectedCallback() {
      this.shadowRoot
        .querySelector("slot")
        .addEventListener("slotchange", this.start),
        this.start();
    }
    disconnectedCallback() {
      this.updater.stop();
    }
    start() {
      this.firstElementChild && this.updater.start(this.firstElementChild);
    }
  };
"ResizeObserver" in window &&
  !window.customElements.get("scroll-shadow") &&
  window.customElements.define("scroll-shadow", ScrollShadow);
var _requireSplit,
  _lastScreenWidth,
  _SplitLines_instances,
  split_fn,
  onWindowResized_fn,
  SplitLines = class extends HTMLElement {
    constructor() {
      super(),
        __privateAdd(this, _SplitLines_instances),
        __privateAdd(this, _requireSplit, !0),
        __privateAdd(this, _lastScreenWidth, window.innerWidth),
        this.attachShadow({ mode: "open" }),
        this.shadowRoot.appendChild(
          document.createRange().createContextualFragment("<slot></slot>")
        ),
        window.addEventListener(
          "resize",
          throttle(
            __privateMethod(
              this,
              _SplitLines_instances,
              onWindowResized_fn
            ).bind(this)
          )
        ),
        new MutationObserver(
          __privateMethod(this, _SplitLines_instances, split_fn).bind(this, !0)
        ).observe(this, {
          characterData: !0,
          attributes: !1,
          childList: !1,
          subtree: !0,
        });
    }
    connectedCallback() {
      __privateMethod(this, _SplitLines_instances, split_fn).call(this);
    }
    get lines() {
      return Array.from(this.shadowRoot.children);
    }
  };
(_requireSplit = new WeakMap()),
  (_lastScreenWidth = new WeakMap()),
  (_SplitLines_instances = new WeakSet()),
  (split_fn = function (force = !1) {
    if (!__privateGet(this, _requireSplit) && !force) return;
    this.shadowRoot.innerHTML = this.textContent
      .replace(/./g, "<span>$&</span>")
      .replace(/\s/g, " ");
    const bounds = new Map();
    Array.from(this.shadowRoot.children).forEach((letter) => {
      const key = Math.round(letter.getBoundingClientRect().top);
      bounds.set(key, (bounds.get(key) || "").concat(letter.textContent));
    }),
      this.shadowRoot.replaceChildren(
        ...Array.from(bounds.values(), (line) =>
          document.createRange().createContextualFragment(`
      <span style="display: inline-block;">
        <span style="display: block">${line}</span>
      </span>
    `)
        )
      ),
      __privateSet(this, _requireSplit, !1);
  }),
  (onWindowResized_fn = function () {
    __privateGet(this, _lastScreenWidth) !== window.innerWidth &&
      (__privateMethod(this, _SplitLines_instances, split_fn).call(this, !0),
      __privateSet(this, _lastScreenWidth, window.innerWidth));
  }),
  window.customElements.get("split-lines") ||
    window.customElements.define("split-lines", SplitLines);
import { timeline as timeline3, inView as inView3 } from "vendor";
var BaseCarousel = class extends HTMLElement {
    connectedCallback() {
      (this._abortController = new AbortController()),
        (this._reloaded = !1),
        Shopify.designMode &&
          this.closest(".shopify-section")?.addEventListener(
            "shopify:section:select",
            (event) => (this._reloaded = event.detail.load)
          ),
        this.items.length > 1 &&
          (Shopify.designMode &&
            this.addEventListener("shopify:block:select", (event) =>
              this.select(this.items.indexOf(event.target), {
                animate: !event.detail.load,
              })
            ),
          this.hasAttribute("adaptive-height") &&
            (this.addEventListener("carousel:settle", this._adjustHeight),
            this._adjustHeight()),
          this.addEventListener("carousel:select", this._preloadImages, {
            signal: this._abortController.signal,
          }),
          this.addEventListener("carousel:filter", this._filterItems, {
            signal: this._abortController.signal,
          }),
          this.addEventListener("control:prev", this.previous, {
            signal: this._abortController.signal,
          }),
          this.addEventListener("control:next", this.next, {
            signal: this._abortController.signal,
          }),
          this.addEventListener(
            "control:select",
            (event) => this.select(event.detail.index),
            { signal: this._abortController.signal }
          )),
        this.selectedIndex === 0
          ? (this.selectedSlide.classList.add("is-selected"),
            this._dispatchEvent("carousel:select", 0))
          : this.select(this.selectedIndex, { animate: !1, force: !0 });
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get items() {
      return this.hasAttribute("reversed")
        ? (this._items =
            this._items ||
            Array.from(
              this.hasAttribute("selector")
                ? this.querySelectorAll(this.getAttribute("selector"))
                : this.children
            ).reverse())
        : (this._items =
            this._items ||
            Array.from(
              this.hasAttribute("selector")
                ? this.querySelectorAll(this.getAttribute("selector"))
                : this.children
            ));
    }
    get visibleItems() {
      return this.items.filter((item) => item.offsetParent !== null);
    }
    get selectedIndex() {
      return (this._selectedIndex =
        this._selectedIndex ??
        parseInt(this.getAttribute("initial-index") || 0));
    }
    get selectedIndexAmongVisible() {
      return this.visibleItems.indexOf(this.selectedSlide);
    }
    get loop() {
      return !1;
    }
    get selectedSlide() {
      return this.items[this.selectedIndex];
    }
    get previousSlide() {
      return this.visibleItems[
        this.loop
          ? (this.selectedIndexAmongVisible - 1 + this.visibleItems.length) %
            this.visibleItems.length
          : Math.max(this.selectedIndexAmongVisible - 1, 0)
      ];
    }
    get nextSlide() {
      return this.visibleItems[
        this.loop
          ? (this.selectedIndexAmongVisible + 1 + this.visibleItems.length) %
            this.visibleItems.length
          : Math.min(
              this.selectedIndexAmongVisible + 1,
              this.visibleItems.length - 1
            )
      ];
    }
    previous(animate19 = !0) {
      this.select(this.items.indexOf(this.previousSlide), {
        direction: "previous",
        animate: animate19,
      });
    }
    next(animate19 = !0) {
      this.select(this.items.indexOf(this.nextSlide), {
        direction: "next",
        animate: animate19,
      });
    }
    _transitionTo(fromSlide, toSlide, options = {}) {}
    _adjustHeight() {
      this.hasAttribute("adaptive-height") &&
        this.selectedSlide.clientHeight !== this.clientHeight &&
        (this.style.maxHeight = `${this.selectedSlide.clientHeight}px`);
    }
    _filterItems(event) {
      this.items.forEach(
        (item, index) =>
          (item.hidden = event.detail.filteredIndexes.includes(index))
      );
    }
    _preloadImages() {
      requestAnimationFrame(() => {
        [this.previousSlide, this.nextSlide].forEach((item) => {
          item &&
            Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach(
              (img) => img.removeAttribute("loading")
            );
        });
      });
    }
    _dispatchEvent(eventName, index) {
      this.dispatchEvent(
        new CustomEvent(eventName, {
          bubbles: !0,
          detail: { slide: this.items[index], index },
        })
      );
    }
  },
  EffectCarousel = class extends BaseCarousel {
    connectedCallback() {
      this.items.length > 1 &&
        this.hasAttribute("autoplay") &&
        ((this._player = new Player(this.getAttribute("autoplay"))),
        this._player.addEventListener("player:end", this.next.bind(this)),
        inView3(this, () => this._player.resume(!0)),
        Shopify.designMode &&
          (this.addEventListener("shopify:block:select", () =>
            this._player.stop()
          ),
          this.addEventListener("shopify:block:deselect", () =>
            this._player.start()
          ))),
        super.connectedCallback(),
        this.items.length > 1 &&
          this.swipeable &&
          (new GestureArea(this, { signal: this._abortController.signal }),
          this.addEventListener("swipeleft", this.next, {
            signal: this._abortController.signal,
          }),
          this.addEventListener("swiperight", this.previous, {
            signal: this._abortController.signal,
          }));
    }
    get player() {
      return this._player;
    }
    get loop() {
      return !0;
    }
    get swipeable() {
      return this.getAttribute("swipeable") !== "false";
    }
    async select(index, { direction, animate: animate19 = !0 } = {}) {
      const indexBeforeChange = this.selectedIndex;
      if (
        ((this._selectedIndex = index),
        this._dispatchEvent("carousel:select", index),
        direction ||
          (direction = index > indexBeforeChange ? "next" : "previous"),
        index !== indexBeforeChange)
      ) {
        const [fromSlide, toSlide] = [
          this.items[indexBeforeChange],
          this.items[index],
        ];
        this._dispatchEvent("carousel:change", index),
          this.player?.pause(),
          await this._transitionTo(fromSlide, toSlide, {
            direction,
            animate: animate19,
          }),
          this.player?.resume(!0),
          this._dispatchEvent("carousel:settle", index);
      }
    }
    _transitionTo(
      fromSlide,
      toSlide,
      { direction = "next", animate: animate19 = !0 } = {}
    ) {
      return (
        fromSlide.classList.remove("is-selected"),
        toSlide.classList.add("is-selected"),
        timeline3(
          [
            [
              fromSlide,
              { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 },
              { zIndex: { easing: "step-end" } },
            ],
            [
              toSlide,
              { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 },
              { at: "<", zIndex: { easing: "step-end" } },
            ],
          ],
          { duration: animate19 ? 0.3 : 0 }
        ).finished
      );
    }
  };
window.customElements.get("effect-carousel") ||
  window.customElements.define("effect-carousel", EffectCarousel);
var ScrollCarousel = class extends BaseCarousel {
  constructor() {
    super(),
      window.ResizeObserver &&
        new ResizeObserver(throttle(this._adjustHeight.bind(this))).observe(
          this
        );
  }
  connectedCallback() {
    (this._hasPendingProgrammaticScroll = !1),
      (this._scrollArea = new ScrollArea(this, this._abortController)),
      super.connectedCallback(),
      this.addEventListener(
        "scroll",
        throttle(this._onCarouselScroll.bind(this)),
        { signal: this._abortController.signal }
      ),
      this.addEventListener("scrollend", this._onScrollSettled, {
        signal: this._abortController.signal,
      });
  }
  get itemOffset() {
    return this.visibleItems.length < 2
      ? 0
      : this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
  }
  get slidesPerPage() {
    return this.visibleItems.length < 2
      ? 1
      : Math.floor(
          (this.clientWidth - this.visibleItems[0].offsetLeft) /
            (Math.abs(this.itemOffset) -
              (parseInt(getComputedStyle(this).gap) || 0))
        );
  }
  get totalPages() {
    return this.visibleItems.length < 2
      ? 1
      : this.visibleItems.length - this.slidesPerPage + 1;
  }
  select(index, { animate: animate19 = !0, force = !1 } = {}) {
    const indexBeforeChange = this.selectedIndex;
    if (!this.offsetParent || this._scrollArea.scrollDirection === "none")
      return (this._selectedIndex = index);
    const indexAmongVisible = this.visibleItems.indexOf(this.items[index]);
    if (
      ((index = this.items.indexOf(
        this.visibleItems[Math.min(this.totalPages, indexAmongVisible)]
      )),
      (this._selectedIndex = index),
      this._dispatchEvent("carousel:select", index),
      index !== indexBeforeChange || force)
    ) {
      const [fromSlide, toSlide] = [
        this.items[indexBeforeChange],
        this.items[index],
      ];
      this._dispatchEvent("carousel:change", index),
        this._transitionTo(fromSlide, toSlide, { animate: animate19 });
    }
  }
  _transitionTo(fromSlide, toSlide, { animate: animate19 = !0 } = {}) {
    fromSlide.classList.remove("is-selected"),
      toSlide.classList.add("is-selected");
    let slideAlign = this._extractSlideAlign(toSlide),
      scrollAmount = 0;
    switch (slideAlign) {
      case "start":
        scrollAmount = this.itemOffset * this.visibleItems.indexOf(toSlide);
        break;
      case "center":
        scrollAmount =
          toSlide.offsetLeft -
          (this.clientWidth / 2 -
            (parseInt(getComputedStyle(this).scrollPaddingInline) || 0)) +
          toSlide.clientWidth / 2;
        break;
    }
    (this._hasPendingProgrammaticScroll = animate19),
      this.scrollTo({
        left: scrollAmount,
        behavior: animate19 ? "smooth" : "auto",
      });
  }
  _onCarouselScroll() {
    if (
      this._hasPendingProgrammaticScroll ||
      this._scrollArea.scrollDirection === "none"
    )
      return;
    const newIndex = this.items.indexOf(
      this.visibleItems[Math.round(this.scrollLeft / this.itemOffset)]
    );
    newIndex !== this.selectedIndex &&
      ((this._selectedIndex = newIndex),
      this._dispatchEvent("carousel:select", this.selectedIndex),
      this._dispatchEvent("carousel:change", this.selectedIndex));
  }
  _onScrollSettled() {
    this.items.forEach((item) => item.classList.remove("is-selected")),
      this.selectedSlide.classList.add("is-selected"),
      (this._hasPendingProgrammaticScroll = !1),
      this._dispatchEvent("carousel:settle", this.selectedIndex);
  }
  _adjustHeight() {
    (this.style.maxHeight = null),
      this._scrollArea?.scrollDirection !== "none" && super._adjustHeight();
  }
  _extractSlideAlign(slide) {
    return getComputedStyle(slide).scrollSnapAlign === "center"
      ? "center"
      : "start";
  }
};
window.customElements.get("scroll-carousel") ||
  window.customElements.define("scroll-carousel", ScrollCarousel);
import { animate as animate3 } from "vendor";
var usesDSCart = () => window.themeVariables.settings.cartType === "drawer" &&
    window.themeVariables.settings.cartDrawerVersion === "ds",
  createCartPromise = () => usesDSCart()
    ? import("ds-cart-ajax").then(async ({ cartAdapter }) => {
        await cartAdapter.ready;
        return cartAdapter.cart;
      })
    : fetch(`${Shopify.routes.root}cart.js`).then((response) => response.json()),
  fetchCart = createCartPromise();
document.addEventListener("cart:refresh", () => {
  if (!usesDSCart()) fetchCart = createCartPromise();
}),
  document.addEventListener("cart:change", (event) => {
    fetchCart = event.detail.cart;
  }),
  window.addEventListener("pageshow", (event) => {
    event.persisted && (fetchCart = createCartPromise());
  });
var CartCount = class extends HTMLElement {
  constructor() {
    super(),
      this.attachShadow({ mode: "open" }).appendChild(
        document
          .createRange()
          .createContextualFragment("<span><slot></slot></span>")
      );
  }
  connectedCallback() {
    (this._abortController = new AbortController()),
      document.addEventListener(
        "cart:change",
        (event) => (this.itemCount = event.detail.cart.item_count),
        { signal: this._abortController.signal }
      ),
      document.addEventListener(
        "cart:refresh",
        this._updateFromServer.bind(this),
        { signal: this._abortController.signal }
      ),
      window.addEventListener("pageshow", this._updateFromServer.bind(this));
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  async _updateFromServer() {
    //console.log('🔄 [CartCount] Updating from server');
    try {
      const cart = await fetchCart;
      //console.log('📦 [CartCount] Fetched cart data:', cart);

      if (cart?.item_count !== undefined) {
        this.itemCount = cart.item_count;
      } else {
        console.warn("⚠️ [CartCount] Missing item_count in fetched cart");
      }
    } catch (error) {
      console.error("❌ [CartCount] Error updating from server:", error);
    }
  }

  get itemCount() {
    return parseInt(this.innerText);
  }
  set itemCount(count) {
    //console.log(`🔢 [CartCount] Setting item count to: ${count}`);

    // Ensure count is a valid number
    if (count === undefined || count === null) {
      console.warn("⚠️ [CartCount] Attempted to set invalid count:", count);
      return;
    }

    const currentCount = this.itemCount;
    if (currentCount === count) return;

    if (count === 0) {
      animate3(this, { opacity: 0 }, { duration: 0.1 });
      this.innerText = count;
    } else if (currentCount === 0) {
      animate3(this, { opacity: 1 }, { duration: 0.1 });
      this.innerText = count;
    } else {
      (async () => {
        try {
          await animate3(
            this.shadowRoot.firstElementChild,
            { transform: ["translateY(-50%)"], opacity: 0 },
            { duration: 0.25, easing: [1, 0, 0, 1] }
          ).finished;

          this.innerText = count;

          animate3(
            this.shadowRoot.firstElementChild,
            { transform: ["translateY(50%)", "translateY(0)"], opacity: 1 },
            { duration: 0.25, easing: [1, 0, 0, 1] }
          );
        } catch (error) {
          console.error("❌ [CartCount] Animation error:", error);
          // Fallback update without animation
          this.innerText = count;
        }
      })();
    }
  }
};
window.customElements.get("cart-count") ||
  window.customElements.define("cart-count", CartCount);

// js/common/cart/cart-discount.js
var AbstractCartDiscount = class extends HTMLElement {
  async getDiscountCodes() {
    return (await fetchCart)["discount_codes"].filter((discount) => discount.applicable).map((discount) => discount.code.toLowerCase());
  }
  async toggleDiscount(event) {
    let target = event.currentTarget;
    const discountInput = target.querySelector("input");
    discountInput?.removeAttribute("aria-invalid");
    const discountBanner = target
      .closest(".cart-discount")
      ?.querySelector("cart-discount-banner");
    if (discountBanner) discountBanner.hidden = true;
    const discountStatus = target
      .closest("cart-drawer")
      ?.querySelector("#cart-drawer-discount-status");
    if (discountStatus) discountStatus.textContent = "";
    target.setAttribute("aria-busy", "true");
    const submitButton = target.querySelector('button[type="submit"]');
    submitButton?.setAttribute("aria-busy", "true");
    let discountCodes = await this.getDiscountCodes();
    if (target.hasAttribute("discount-code")) {
      discountCodes = discountCodes.filter((discount2) => discount2 !== target.getAttribute("discount-code").toLowerCase());
    }
    let discount = (discountCodes.length > 0 ? discountCodes.join(",") + "," : "") + (target.querySelector("input")?.value || "");
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount })
    });
    target.setAttribute("aria-busy", "false");
    submitButton?.setAttribute("aria-busy", "false");
    if (!response.ok) {
      this.dispatchEvent(new CustomEvent("cart:discount:error", { bubbles: true }));
      return;
    }
    const responseJson = await response.json();
    const enteredCode = (target.querySelector("input")?.value || "").trim().toLowerCase();
    const enteredEntry = enteredCode ? responseJson.discount_codes.find((obj) => obj.code.toLowerCase() === enteredCode) : null;
    if (enteredEntry?.applicable === false) {
      const reason = responseJson.discount_codes.some((obj) => obj.applicable) ? "not_combinable" : "invalid";
      this.dispatchEvent(new CustomEvent("cart:discount:error", { bubbles: true, detail: { reason } }));
      return;
    }
    this.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: {
        restoreFocus: Boolean(target.closest("cart-drawer")),
        announcement: window.themeVariables.strings.discountUpdated,
      },
    }));
    if (window.themeVariables.settings.pageType == "cart") {
      window.location.reload();
    }
  }
};
var _abortController2, _CartDiscountBanner_instances, onCartDiscountError_fn;
var CartDiscountBanner = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartDiscountBanner_instances);
    __privateAdd(this, _abortController2);
  }
  connectedCallback() {
    __privateSet(this, _abortController2, new AbortController());
    document.addEventListener("cart:discount:error", __privateMethod(this, _CartDiscountBanner_instances, onCartDiscountError_fn).bind(this), { signal: __privateGet(this, _abortController2).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController2).abort();
  }
};
_abortController2 = new WeakMap();
_CartDiscountBanner_instances = new WeakSet();
onCartDiscountError_fn = function(event) {
  this.closest(".cart-discount")
    ?.querySelector("input")
    ?.setAttribute("aria-invalid", "true");
  const reason = event.detail?.reason || "invalid";
  this.querySelectorAll("[data-discount-error]").forEach((el) => {
    el.hidden = el.dataset.discountError !== reason;
  });
  this.hidden = false;
};
var CartDiscountField = class extends AbstractCartDiscount {
  #abortController;
  static get observedAttributes() {
    return ["aria-busy"];
  }
  constructor() {
    super();
    this.addEventListener("change", this.toggleDiscount.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest('button[type="submit"]')) {
        event.preventDefault();
        this.toggleDiscount(event);
      }
    });
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    document.addEventListener("cart:discount:error", () => {
      this.classList.add("cart-discount-field--error");
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "aria-busy" && oldValue !== newValue) {
      const eventName = newValue === "true" ? "cart:discount:loading:start" : "cart:discount:loading:end";
      document.documentElement.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
    }
  }
};
var CartDiscountRemoveButton = class extends AbstractCartDiscount {
  constructor() {
    super();
    this.addEventListener("click", this.toggleDiscount.bind(this));
  }
};
if (!window.customElements.get("cart-discount-field")) {
  window.customElements.define("cart-discount-field", CartDiscountField);
}
if (!window.customElements.get("cart-discount-remove-button")) {
  window.customElements.define("cart-discount-remove-button", CartDiscountRemoveButton);
}
if (!window.customElements.get("cart-discount-banner")) {
  window.customElements.define("cart-discount-banner", CartDiscountBanner);
}

import { animate as animate4 } from "vendor";
import { FocusTrap, Delegate } from "vendor";
var DialogElement = class _DialogElement extends HTMLElement {
    static get observedAttributes() {
      return ["id", "open"];
    }
    static #lockLayerCount = 0;
    #isLocked = !1;
    constructor() {
      super(),
        this.addEventListener("dialog:force-close", (event) => {
          this.hide(), event.stopPropagation();
        });
    }
    connectedCallback() {
      this.id &&
        this.delegate
          .off()
          .on(
            "click",
            `[aria-controls="${this.id}"]`,
            this._onToggleClicked.bind(this)
          ),
        (this._abortController = new AbortController()),
        this.setAttribute("role", "dialog"),
        Shopify.designMode &&
          (this.addEventListener(
            "shopify:block:select",
            (event) => this.show(!event.detail.load),
            { signal: this._abortController.signal }
          ),
          this.addEventListener("shopify:block:deselect", this.hide, {
            signal: this._abortController.signal,
          }),
          (this._shopifySection =
            this._shopifySection || this.closest(".shopify-section")),
          this._shopifySection &&
            (this.hasAttribute("handle-section-events") &&
              (this._shopifySection.addEventListener(
                "shopify:section:select",
                (event) => this.show(!event.detail.load),
                { signal: this._abortController.signal }
              ),
              this._shopifySection.addEventListener(
                "shopify:section:deselect",
                this.hide.bind(this),
                { signal: this._abortController.signal }
              )),
            this._shopifySection.addEventListener(
              "shopify:section:unload",
              () => this.remove(),
              { signal: this._abortController.signal }
            )));
    }
    disconnectedCallback() {
      this._abortController.abort(),
        this.delegate.off(),
        this.focusTrap?.deactivate({ onDeactivate: () => {} }),
        this.#isLocked &&
          ((this.#isLocked = !1),
          document.documentElement.classList.toggle(
            "lock",
            --_DialogElement.#lockLayerCount > 0
          ));
    }
    show(animate19 = !0) {
      if (!this.open)
        return (
          this.setAttribute("open", animate19 ? "" : "immediate"),
          waitForEvent(this, "dialog:after-show")
        );
    }
    hide() {
      if (this.open)
        return (
          this.removeAttribute("open"), waitForEvent(this, "dialog:after-hide")
        );
    }
    get delegate() {
      return (this._delegate = this._delegate || new Delegate(document.body));
    }
    get controls() {
      return Array.from(
        this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`)
      );
    }
    get open() {
      return this.hasAttribute("open");
    }
    get shouldTrapFocus() {
      return !0;
    }
    get shouldLock() {
      return !1;
    }
    get shouldAppendToBody() {
      return !1;
    }
    get initialFocus() {
      return this.hasAttribute("initial-focus")
        ? this.getAttribute("initial-focus")
        : this.hasAttribute("tabindex")
        ? this
        : this.querySelector('input:not([type="hidden"])') || !1;
    }
    get preventScrollWhenTrapped() {
      return !0;
    }
    get focusTrap() {
      return (this._focusTrap =
        this._focusTrap ||
        new FocusTrap.createFocusTrap(this, {
          onDeactivate: this.hide.bind(this),
          allowOutsideClick: this._allowOutsideClick.bind(this),
          initialFocus: this.hasAttribute("tabindex") ||
            window.matchMedia("screen and (pointer: fine)").matches
            ? this.initialFocus
            : !1,
          fallbackFocus: this,
          tabbableOptions: { getShadowRoot: !0 },
          preventScroll: this.preventScrollWhenTrapped,
        }));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case "id":
          newValue &&
            this.delegate
              .off()
              .on(
                "click",
                `[aria-controls="${this.id}"]`,
                this._onToggleClicked.bind(this)
              );
          break;
        case "open":
          if (
            (this.controls.forEach((toggle) =>
              toggle.setAttribute(
                "aria-expanded",
                newValue === null ? "false" : "true"
              )
            ),
            oldValue === null && (newValue === "" || newValue === "immediate"))
          ) {
            this.removeAttribute("inert"),
              (this._originalParentBeforeAppend = null),
              this.shouldAppendToBody &&
                this.parentElement !== document.body &&
                ((this._originalParentBeforeAppend = this.parentElement),
                document.body.append(this));
            const showTransitionPromise =
              this._showTransition(newValue !== "immediate") ||
              Promise.resolve();
            showTransitionPromise.then(() => {
              this.dispatchEvent(
                new CustomEvent("dialog:after-show", { bubbles: !0 })
              );
            }),
              this.shouldTrapFocus &&
                this.focusTrap.activate({
                  checkCanFocusTrap: () => showTransitionPromise,
                }),
              this.shouldLock &&
                ((_DialogElement.#lockLayerCount += 1),
                (this.#isLocked = !0),
                document.documentElement.classList.add("lock"));
          } else if (oldValue !== null && newValue === null) {
            this.setAttribute("inert", "");
            const hideTransitionPromise =
              this._hideTransition() || Promise.resolve();
            hideTransitionPromise.then(() => {
              this.parentElement === document.body &&
                this._originalParentBeforeAppend &&
                (this._originalParentBeforeAppend.appendChild(this),
                (this._originalParentBeforeAppend = null)),
                this.dispatchEvent(
                  new CustomEvent("dialog:after-hide", { bubbles: !0 })
                );
            }),
              this.focusTrap?.deactivate({
                checkCanReturnFocus: () => hideTransitionPromise,
              }),
              this.shouldLock &&
                ((this.#isLocked = !1),
                document.documentElement.classList.toggle(
                  "lock",
                  --_DialogElement.#lockLayerCount > 0
                ));
          }
          this.dispatchEvent(new CustomEvent("toggle", { bubbles: !0 }));
          break;
      }
    }
    _showTransition(animate19 = !0) {}
    _hideTransition() {}
    _allowOutsideClick(event) {
      return "TouchEvent" in window && event instanceof TouchEvent
        ? this._allowOutsideClickTouch(event)
        : this._allowOutsideClickMouse(event);
    }
    _allowOutsideClickTouch(event) {
      return (
        event.target.addEventListener(
          "touchend",
          (subEvent) => {
            const endTarget = document.elementFromPoint(
              subEvent.changedTouches.item(0).clientX,
              subEvent.changedTouches.item(0).clientY
            );
            this.contains(endTarget) || this.hide();
          },
          { once: !0 }
        ),
        !1
      );
    }
    _allowOutsideClickMouse(event) {
      if (event.type !== "click") return !1;
      this.contains(event.target) || this.hide();
      let target = event.target,
        closestControl = event.target.closest("[aria-controls]");
      return (
        closestControl &&
          closestControl.getAttribute("aria-controls") === this.id &&
          (target = closestControl),
        this.id !== target.getAttribute("aria-controls")
      );
    }
    _onToggleClicked(event) {
      event?.preventDefault(), this.open ? this.hide() : this.show();
    }
  },
  CloseButton = class extends HTMLButtonElement {
    constructor() {
      super(),
        this.addEventListener("click", () =>
          this.dispatchEvent(
            new CustomEvent("dialog:force-close", {
              bubbles: !0,
              cancelable: !0,
              composed: !0,
            })
          )
        );
    }
  };
window.customElements.get("dialog-element") ||
  window.customElements.define("dialog-element", DialogElement),
  window.customElements.get("close-button") ||
    window.customElements.define("close-button", CloseButton, {
      extends: "button",
    });
import { animate as motionAnimate, timeline as motionTimeline } from "vendor";
var reduceDrawerAnimation =
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    window.themeVariables.settings.reduceDrawerAnimation,
  Drawer = class extends DialogElement {
    constructor() {
      super();
      const template2 = document
        .getElementById(this.template)
        .content.cloneNode(!0);
      this.attachShadow({ mode: "open" }).appendChild(template2),
        this.shadowRoot.addEventListener("slotchange", (event) =>
          this._updateSlotVisibility(event.target)
        );
    }
    connectedCallback() {
      super.connectedCallback(),
        this.setAttribute("aria-modal", "true"),
        this.shadowRoot
          .querySelector('[part="overlay"]')
          ?.addEventListener("click", this.hide.bind(this), {
            signal: this._abortController.signal,
          }),
        Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) =>
          this._updateSlotVisibility(slot)
        );
    }
    get template() {
      return this.getAttribute("template") || "drawer-default-template";
    }
    get shouldLock() {
      return !0;
    }
    get shouldAppendToBody() {
      return !0;
    }
    get openFrom() {
      return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`)
        .matches
        ? "bottom"
        : this.getAttribute("open-from") || "right";
    }
    _getClipPathProperties() {
      switch (this.openFrom) {
        case "left":
          return document.dir === "ltr"
            ? ["inset(0 100% 0 0 round 0", "inset(0 0 0 0 round 0"]
            : ["inset(0 0 0 100% round 0", "inset(0 0 0 0 round 0"];
        case "right":
          return document.dir === "ltr"
            ? ["inset(0 0 0 100% round 0", "inset(0 0 0 0 round 0"]
            : ["inset(0 100% 0 0 round 0", "inset(0 0 0 0 round 0"];
        case "bottom":
          return ["inset(100% 0 0 0 round 0", "inset(0 0 0 0 round 0"];
        case "top":
          return ["inset(0 0 100% 0 round 0", "inset(0 0 0 0 round 0"];
      }
    }
    _setInitialPosition() {
      (this.style.left =
        (document.dir === "ltr" && this.openFrom === "left") ||
        (document.dir === "rtl" && this.openFrom === "right")
          ? "0px"
          : "auto"),
        (this.style.right = this.style.left === "auto" ? "0px" : "auto"),
        (this.style.bottom = this.openFrom === "bottom" ? "0px" : null),
        (this.style.top = this.style.bottom === "" ? "0px" : null);
    }
    _showTransition(animate19 = !0) {
      let animationControls;
      if ((this._setInitialPosition(), reduceDrawerAnimation))
        animationControls = motionAnimate(
          this,
          { opacity: [0, 1], visibility: ["hidden", "visible"] },
          { duration: 0.2 }
        );
      else {
        let content = this.shadowRoot.querySelector('[part="content"]'),
          closeButton = this.shadowRoot.querySelector(
            '[part="outside-close-button"]'
          );
        animationControls = motionTimeline([
          [
            this,
            { opacity: [0, 1], visibility: ["hidden", "visible"] },
            { duration: 0.15 },
          ],
          [
            content,
            { clipPath: this._getClipPathProperties() },
            { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
          ],
          [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
          [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
        ]);
      }
      return (
        animate19 ? animationControls.play() : animationControls.finish(),
        animationControls.finished.then(() =>
          this.classList.add("show-close-cursor")
        )
      );
    }
    _hideTransition() {
      let animationControls;
      if (reduceDrawerAnimation)
        animationControls = motionAnimate(
          this,
          { opacity: [1, 0], visibility: ["visibility", "hidden"] },
          { duration: 0.2 }
        );
      else {
        let content = this.shadowRoot.querySelector('[part="content"]'),
          closeButton = this.shadowRoot.querySelector(
            '[part="outside-close-button"]'
          );
        animationControls = motionTimeline([
          [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
          [
            content.children,
            { opacity: [null, 0] },
            { at: "<", duration: 0.15 },
          ],
          [
            content,
            { clipPath: this._getClipPathProperties().reverse() },
            { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
          ],
          [
            this,
            { opacity: [null, 0], visibility: ["visible", "hidden"] },
            { duration: 0.15 },
          ],
        ]);
      }
      return animationControls.finished.then(() =>
        this.classList.remove("show-close-cursor")
      );
    }
    _updateSlotVisibility(slot) {
      ["header", "footer", "body"].includes(slot.name) &&
        (slot.parentElement.hidden =
          slot.assignedElements({ flatten: !0 }).length === 0);
    }
  };
window.customElements.get("x-drawer") ||
  window.customElements.define("x-drawer", Drawer);
import { animate as motionAnimate2, timeline as motionTimeline2 } from "vendor";
var Popover = class extends DialogElement {
  constructor() {
    super(),
      this.attachShadow({ mode: "open" }).appendChild(
        document.getElementById(this.template).content.cloneNode(!0)
      );
  }
  connectedCallback() {
    super.connectedCallback(),
      this.shadowRoot
        .querySelector('[part="overlay"]')
        ?.addEventListener("click", this.hide.bind(this), {
          signal: this._abortController.signal,
        }),
      this.controls.forEach((control) =>
        control.setAttribute("aria-haspopup", "dialog")
      ),
      this.hasAttribute("close-on-listbox-select") &&
        (this.querySelector("x-listbox")
          ? this.addEventListener("listbox:select", this.hide, {
              signal: this._abortController.signal,
            })
          : this.addEventListener("change", this.hide, {
              signal: this._abortController.signal,
            }));
  }
  get template() {
    return this.getAttribute("template") || "popover-default-template";
  }
  get shouldLock() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get shouldAppendToBody() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get anchor() {
    return {
      vertical: this.getAttribute("anchor-vertical") || "start",
      horizontal: this.getAttribute("anchor-horizontal") || "end",
    };
  }
  _showTransition(animate19 = !0) {
    let animationControls,
      content = this.shadowRoot.querySelector('[part="content"]'),
      closeButton = this.shadowRoot.querySelector(
        '[part="outside-close-button"]'
      );
    if (
      ((this.style.display = "block"),
      window.matchMedia("screen and (max-width: 999px)").matches)
    )
      (this.style.left = "0px"),
        (this.style.right = null),
        (this.style.bottom = "0px"),
        (this.style.top = null),
        (animationControls = motionTimeline2([
          [
            this,
            { opacity: [0, 1], visibility: ["hidden", "visible"] },
            { duration: 0.15 },
          ],
          [
            content,
            {
              clipPath: [
                "inset(100% 0 0 0 round 8px)",
                "inset(0 0 0 0 round 8px",
              ],
            },
            { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
          ],
          [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
          [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
        ]));
    else {
      let spacingBlockValue = "var(--popover-anchor-block-spacing)",
        spacingInlineValue = "var(--popover-anchor-inline-spacing)";
      (this.style.left =
        this.anchor.horizontal === "start" ? spacingInlineValue : null),
        (this.style.right =
          this.anchor.horizontal === "end" ? spacingInlineValue : null),
        this.anchor.vertical === "center"
          ? ((this.style.top = `calc(50% - ${parseInt(
              this.clientHeight / 2
            )}px)`),
            (this.style.bottom = null))
          : ((this.style.top =
              this.anchor.vertical === "end"
                ? `calc(100% + ${spacingBlockValue})`
                : null),
            (this.style.bottom =
              this.anchor.vertical === "start"
                ? `calc(100% + ${spacingBlockValue})`
                : null)),
        (animationControls = motionTimeline2([
          [
            this,
            { opacity: [0, 1], visibility: ["hidden", "visible"] },
            { duration: 0.15 },
          ],
          [content, { clipPath: "none" }, { at: "<", duration: 0 }],
          [content.children, { opacity: 1 }, { at: "<", duration: 0 }],
        ]));
    }
    return (
      animate19 ? animationControls.play() : animationControls.finish(),
      animationControls.finished
    );
  }
  _hideTransition() {
    let animationControls;
    if (window.matchMedia("screen and (max-width: 999px)").matches) {
      let content = this.shadowRoot.querySelector('[part="content"]'),
        closeButton = this.shadowRoot.querySelector(
          '[part="outside-close-button"]'
        );
      animationControls = motionTimeline2([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [
          content,
          { clipPath: [null, "inset(100% 0 0 0 round 8px)"] },
          { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
        ],
        [
          this,
          { opacity: [null, 0], visibility: ["visible", "hidden"] },
          { duration: 0.15 },
        ],
      ]);
    } else
      animationControls = motionAnimate2(
        this,
        { opacity: [null, 0], visibility: ["visible", "hidden"] },
        { duration: 0.15 }
      );
    return animationControls.finished.then(() => (this.style.display = "none"));
  }
};
window.customElements.get("x-popover") ||
  window.customElements.define("x-popover", Popover);
import { Delegate as Delegate2 } from "vendor";
var PrivacyBar = class extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this._delegate = new Delegate2(this)),
      window.Shopify.loadFeatures([
        {
          name: "consent-tracking-api",
          version: "0.1",
          onLoad: this._onConsentLibraryLoaded.bind(this),
        },
      ]),
      Shopify.designMode)
    ) {
      const section = this.closest(".shopify-section");
      section.addEventListener("shopify:section:select", this.show.bind(this)),
        section.addEventListener(
          "shopify:section:deselect",
          this.hide.bind(this)
        );
    }
  }
  connectedCallback() {
    this._delegate.on(
      "click",
      '[data-action="accept"]',
      this._acceptPolicy.bind(this)
    ),
      this._delegate.on(
        "click",
        '[data-action="decline"]',
        this._declinePolicy.bind(this)
      ),
      this._delegate.on("click", '[data-action="close"]', this.hide.bind(this));
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  show() {
    this.hidden = !1;
  }
  hide() {
    this.hidden = !0;
  }
  _onConsentLibraryLoaded() {
    window.Shopify.customerPrivacy?.shouldShowBanner() && this.show();
  }
  _acceptPolicy() {
    window.Shopify.customerPrivacy?.setTrackingConsent(
      !0,
      this.hide.bind(this)
    );
  }
  _declinePolicy() {
    window.Shopify.customerPrivacy?.setTrackingConsent(
      !1,
      this.hide.bind(this)
    );
  }
};
window.customElements.get("privacy-bar") ||
  window.customElements.define("privacy-bar", PrivacyBar);
var CartDrawer = class extends Drawer {
    constructor() {
      super(),
        (this._onPrepareBundledSectionsListener =
          this._onPrepareBundledSections.bind(this)),
        (this._onCartChangedListener = this._onCartChanged.bind(this)),
        (this._onCartRefreshListener = this._onCartRefresh.bind(this)),
        (this._onVariantAddedListener = this._onVariantAdded.bind(this)),
        window.addEventListener("pageshow", this._onPageShow.bind(this));
    }
    connectedCallback() {
      super.connectedCallback(),
        document.addEventListener(
          "cart:prepare-bundled-sections",
          this._onPrepareBundledSectionsListener
        ),
        document.addEventListener("cart:change", this._onCartChangedListener),
        document.addEventListener("cart:refresh", this._onCartRefreshListener),
        document.addEventListener("variant:add", this._onVariantAddedListener);
    }
    disconnectedCallback() {
      super.disconnectedCallback(),
        document.removeEventListener(
          "cart:prepare-bundled-sections",
          this._onPrepareBundledSectionsListener
        ),
        document.removeEventListener(
          "cart:change",
          this._onCartChangedListener
        ),
        document.removeEventListener(
          "cart:refresh",
          this._onCartRefreshListener
        ),
        document.removeEventListener(
          "variant:add",
          this._onVariantAddedListener
        );
    }
    get shouldAppendToBody() {
      return !1;
    }
    get openFrom() {
      return "right";
    }
    get _hiddenSideTransform() {
      return document.dir === "rtl" ? "translateX(-100%)" : "translateX(100%)";
    }
    _showTransition(animate19 = !0) {
      if (reduceDrawerAnimation) return super._showTransition(animate19);
      this._setInitialPosition();
      const content = this.shadowRoot.querySelector('[part="content"]'),
        overlay = this.shadowRoot.querySelector('[part="overlay"]'),
        closeButton = this.shadowRoot.querySelector(
          '[part="outside-close-button"]'
        ),
        animationControls = motionTimeline([
          [
            this,
            { opacity: 1, visibility: "visible" },
            { duration: 0 },
          ],
          [overlay, { opacity: [0, 1] }, { duration: 0.3 }],
          [
            content,
            {
              transform: [this._hiddenSideTransform, "translateX(0%)"],
            },
            { at: "<", duration: 0.3, easing: [0.16, 1, 0.3, 1] },
          ],
          [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
        ]);
      return (
        animate19 ? animationControls.play() : animationControls.finish(),
        animationControls.finished.then(() =>
          this.classList.add("show-close-cursor")
        )
      );
    }
    _hideTransition() {
      if (reduceDrawerAnimation) return super._hideTransition();
      const content = this.shadowRoot.querySelector('[part="content"]'),
        overlay = this.shadowRoot.querySelector('[part="overlay"]'),
        closeButton = this.shadowRoot.querySelector(
          '[part="outside-close-button"]'
        ),
        animationControls = motionTimeline([
          [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
          [overlay, { opacity: [null, 0] }, { at: "<", duration: 0.3 }],
          [
            content,
            {
              transform: ["translateX(0%)", this._hiddenSideTransform],
            },
            { at: "<", duration: 0.3, easing: [0.7, 0, 0.84, 0] },
          ],
        ]);
      return animationControls.finished.then(() => {
        this.style.opacity = "0";
        this.style.visibility = "hidden";
        this.classList.remove("show-close-cursor");
      });
    }
    _onPrepareBundledSections(event) {
      event.detail.sections.push(extractSectionId(this));
    }
    async _onCartChanged(event) {
      const updatedDrawerContent = new DOMParser().parseFromString(
        event.detail.cart.sections[extractSectionId(this)],
        "text/html"
      );
      if (event.detail.cart.item_count > 0) {
        const currentInner = this.querySelector(".cart-drawer__inner"),
          updatedInner = updatedDrawerContent.querySelector(
            ".cart-drawer__inner"
          );
        currentInner
          ? (() => {
            const currentTop = currentInner.querySelector(":scope > .cart-drawer__top"),
              updatedTop = updatedInner.querySelector(":scope > .cart-drawer__top"),
              currentShippingBar = currentTop?.querySelector("free-shipping-bar"),
              updatedShippingBar = updatedTop?.querySelector("free-shipping-bar"),
              currentContent = currentInner.querySelector(":scope > .v-stack"),
              updatedContent = updatedInner.querySelector(":scope > .v-stack");

            if (
              currentShippingBar &&
              updatedShippingBar &&
              currentContent &&
              updatedContent
            ) {
              // Keep the existing bar connected. Its cart:change listener updates
              // total-price and animates from the previous progress value.
              currentContent.replaceWith(updatedContent);
            } else {
              currentInner.innerHTML = updatedInner.innerHTML;
            }

            this.querySelector('[slot="footer"]').replaceChildren(
              ...updatedDrawerContent.querySelector('[slot="footer"]')
                .childNodes
            );
          })()
          : this.replaceChildren(
              document
                .createRange()
                .createContextualFragment(
                  updatedDrawerContent.querySelector(".cart-drawer").innerHTML
                )
            );
      } else
        await animate4(this.children, { opacity: 0 }, { duration: 0.15 })
          .finished,
          this.replaceChildren(
            ...updatedDrawerContent.querySelector(".cart-drawer").childNodes
          ),
          animate4(
            this.querySelector(".empty-state"),
            {
              opacity: [0, 1],
              transform: ["translateY(20px)", "translateY(0)"],
            },
            { duration: 0.15 }
          );
      const status = this.querySelector("#cart-drawer-status");
      if (status && event.detail.announcement) {
        status.textContent = "";
        requestAnimationFrame(() => {
          status.textContent = event.detail.announcement;
        });
      }
      if (event.detail.focusLineKey) {
        const quantityInput = event.detail.cart.item_count > 0
          ? this.querySelector(
              `[data-line-key="${CSS.escape(String(event.detail.focusLineKey))}"]`
            )
          : null;
        const focusTarget = event.detail.cart.item_count === 0
          ? this.querySelector(".empty-state a, .empty-state button")
          : event.detail.targetQuantity === 0
            ? this.querySelector(".line-item__title, .drawer__close-icon")
            : quantityInput
                ?.closest("line-item-quantity")
                ?.querySelector(
                  event.detail.focusAction === "decrement"
                    ? ".ds-line-item__quantity-remove"
                    : ".ds-line-item__quantity-add"
                );
        focusTarget?.focus();
      }
    }
    _onPageShow(event) {
      event.persisted && this._onCartRefresh();
    }
    _onVariantAdded(event) {
      window.themeVariables.settings.cartType !== "drawer" ||
        event.detail?.blockCartDrawerOpening ||
        this.show();
    }
    async _onCartRefresh(event) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = await (
        await fetch(
          `${window.Shopify.routes.root}?section_id=${extractSectionId(this)}`
        )
      ).text();
      const updatedDrawer = tempDiv.querySelector("#cart-drawer");
      if (!updatedDrawer) return;

      this.replaceChildren(...updatedDrawer.children);

      if (event?.detail?.restoreFocus && this.open) {
        const status = this.querySelector("#cart-drawer-discount-status")
          || this.querySelector("#cart-drawer-status");
        if (status && event.detail.announcement) {
          status.textContent = event.detail.announcement;
        }

        requestAnimationFrame(() => {
          const focusTarget = this.querySelector('cart-discount-field input[name="discount"]')
            || this.querySelector("cart-discount-remove-button button")
            || this.querySelector('[name="checkout"], a[href*="/cart"], .drawer__close-icon');
          focusTarget?.focus();
        });
      }
    }
  },
  CartNotificationDrawer = class extends Drawer {
    constructor() {
      super(), (this._onVariantAddedListener = this._onVariantAdded.bind(this));
    }
    connectedCallback() {
      super.connectedCallback(),
        document.addEventListener("variant:add", this._onVariantAddedListener);
    }
    disconnectedCallback() {
      super.disconnectedCallback(),
        document.removeEventListener(
          "variant:add",
          this._onVariantAddedListener
        );
    }
    async show() {
      return (this.style.display = "block"), super.show();
    }
    async hide() {
      super.hide()?.then(() => {
        this.style.display = "none";
      });
    }
    _onVariantAdded(event) {
      if (
        window.themeVariables.settings.cartType !== "popover" ||
        event.detail?.blockCartDrawerOpening
      )
        return;
      const tempContent = document.createElement("div");
      (tempContent.innerHTML = event.detail.cart.sections["variant-added"]),
        this.replaceChildren(
          ...tempContent.querySelector(".shopify-section").children
        ),
        this.show();
    }
  },
  LineItem = class extends HTMLElement {
    connectedCallback() {
      (this.pillLoaderElement = this.querySelector("pill-loader")),
        this.addEventListener(
          "line-item:will-change",
          this._onWillChange.bind(this)
        ),
        this.addEventListener("line-item:change", this._onChanged.bind(this));
    }
    _onWillChange() {
      this.pillLoaderElement.setAttribute("aria-busy", "true");
    }
    async _onChanged(event) {
      if (
        (this.pillLoaderElement.removeAttribute("aria-busy"),
        event.detail.cart.item_count === 0 || event.detail.quantity !== 0)
      )
        return;
      let marginCompensation = 0;
      this.nextElementSibling &&
        (marginCompensation = `-${
          getComputedStyle(this.nextElementSibling).paddingTop
        }`),
        await animate4(
          this,
          {
            height: [`${this.clientHeight}px`, 0],
            marginBottom: [0, marginCompensation],
            overflow: "hidden",
            opacity: [1, 0],
          },
          { duration: 0.2, easing: "ease" }
        ).finished,
        this.remove();
    }
  };
window.customElements.get("cart-drawer") ||
  window.customElements.define("cart-drawer", CartDrawer),
  window.customElements.get("cart-notification-drawer") ||
    window.customElements.define(
      "cart-notification-drawer",
      CartNotificationDrawer
    ),
  window.customElements.get("line-item") ||
    window.customElements.define("line-item", LineItem);
var CartNote = class extends HTMLElement {
    constructor() {
      super(),
        this.addEventListener("change", this._onNoteChanged),
        this.addEventListener("click", this._onSaveClicked);
    }
    _onNoteChanged(event) {
      if (
        event.target.getAttribute("name") === "note" &&
        !this.closest("cart-note-dialog")
      ) {
        this._saveNote(event.target.value).catch((error) => {
          console.error("Failed to save cart note:", error);
        });
      }
    }
    async _onSaveClicked(event) {
      const saveButton = event.target.closest(".cart-note__save");
      if (!saveButton || !this.contains(saveButton)) return;

      const noteInput = this.querySelector('[name="note"]');
      const errorElement = this.querySelector(".cart-note__error");
      const dialog = this.closest("cart-note-dialog");
      if (!noteInput || !dialog) return;

      saveButton.disabled = true;
      saveButton.setAttribute("aria-busy", "true");
      noteInput.removeAttribute("aria-invalid");
      if (errorElement) errorElement.hidden = true;

      try {
        await this._saveNote(noteInput.value);
        dialog.updateControlText(noteInput.value);

        const status = document.getElementById("cart-drawer-status");
        if (status) {
          status.textContent = "";
          requestAnimationFrame(() => {
            status.textContent = window.themeVariables.strings.orderNoteSaved;
          });
        }

        await dialog.hide();
        saveButton.disabled = false;
        saveButton.removeAttribute("aria-busy");
      } catch (error) {
        console.error("Failed to save cart note:", error);
        saveButton.disabled = false;
        saveButton.removeAttribute("aria-busy");
        noteInput.setAttribute("aria-invalid", "true");
        if (errorElement) {
          errorElement.textContent = window.themeVariables.strings.orderNoteError;
          errorElement.hidden = false;
        }
        saveButton.focus();
      }
    }
    async _saveNote(value) {
      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: value }),
        keepalive: !0,
      });
      if (!response.ok) throw new Error("Cart note update failed");
    }
  },
  CartNoteDialog = class extends DialogElement {
    updateControlText(value) {
      value === ""
        ? this.controls.forEach(
            (control) =>
              (control.innerHTML = `<span class="link text-sm text-subdued">${window.themeVariables.strings.addOrderNote}</span>`)
          )
        : this.controls.forEach(
            (control) =>
              (control.innerHTML = `<span class="link text-sm text-subdued">${window.themeVariables.strings.editOrderNote}</span>`)
          );
    }
  };
window.customElements.get("cart-note") ||
  window.customElements.define("cart-note", CartNote),
  window.customElements.get("cart-note-dialog") ||
    window.customElements.define("cart-note-dialog", CartNoteDialog);
var FreeShippingBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["threshold", "total-price", "gift-threshold", "gift-total-price"];
  }
  constructor() {
    super(),
      (this._onCartChangedListener = this._onCartChanged.bind(this)),
      (this._currencyFormatter = new Intl.NumberFormat(Shopify.locale, {
        style: "currency",
        currency: Shopify.currency.active,
      }));
  }
  async connectedCallback() {
    document.addEventListener("cart:change", this._onCartChangedListener),
      this._updateStage();
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", this._onCartChangedListener);
  }
  get threshold() {
    return this._convertedThreshold("threshold");
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    // console.log(`💵 [FreeShippingBar] Setting total price: ${value}`);
    this.setAttribute("total-price", value);
  }
  get giftThreshold() {
    return this._convertedThreshold("gift-threshold");
  }
  get giftTotalPrice() {
    return parseFloat(this.getAttribute("gift-total-price"));
  }
  set giftTotalPrice(value) {
    this.setAttribute("gift-total-price", value);
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    // console.log(`🔄 [FreeShippingBar] Attribute changed: ${attribute}, from: ${oldValue} to: ${newValue}`);
    await window.customElements.whenDefined("progress-bar");
    this._updateStage();
  }
  _convertedThreshold(attribute) {
    const baseThreshold = parseFloat(this.getAttribute(attribute));
    return Number.isFinite(baseThreshold)
      ? Math.round(baseThreshold * (Shopify.currency.rate || 1))
      : Number.NaN;
  }
  _activeStage() {
    const stages = [];
    if (
      this.getAttribute("shipping-enabled") === "true" &&
      Number.isFinite(this.threshold)
    )
      stages.push({
        name: "shipping",
        threshold: this.threshold,
        totalPrice: this.totalPrice,
        reachedMessage: this.getAttribute("reached-message") || "",
        unreachedMessage: this.getAttribute("unreached-message") || "",
        progressLabel: this.querySelector("progress-bar")?.getAttribute("aria-label") || "",
      });
    if (
      this.getAttribute("gift-enabled") === "true" &&
      Number.isFinite(this.giftThreshold)
    )
      stages.push({
        name: "gift",
        threshold: this.giftThreshold,
        totalPrice: this.giftTotalPrice,
        reachedMessage: this.getAttribute("gift-reached-message") || "",
        unreachedMessage: this.getAttribute("gift-unreached-message") || "",
        progressLabel: "Fortschritt zum Gratisgeschenk",
      });
    if (stages.length === 0) return null;
    const nextStage = stages
      .filter((stage) => stage.totalPrice < stage.threshold)
      .sort((stageA, stageB) => stageA.threshold - stageB.threshold)[0];
    return nextStage || stages.find((stage) => stage.name === "gift") || stages[0];
  }
  _replaceRemainingAmount(message, stage) {
    const replacement = `<span class="bold text-accent ds-text-accent">${this._currencyFormatter
      .format(Math.max(0, stage.threshold - stage.totalPrice) / 100)
      .replace(/\$/g, "$$$$")}</span>`;
    return message.replace(new RegExp("({{.*}})", "g"), replacement);
  }
  _updateStage() {
    const stage = this._activeStage();
    const messageElement = this.querySelector(".progress-bar__placeholder");
    const progressBar = this.querySelector("progress-bar");
    if (!stage || !messageElement || !progressBar) return;
    progressBar.setAttribute("aria-valuemax", stage.threshold);
    progressBar.setAttribute("aria-valuenow", stage.totalPrice);
    progressBar.setAttribute("aria-label", stage.progressLabel);
    messageElement.innerHTML = stage.totalPrice >= stage.threshold
      ? stage.reachedMessage
      : this._replaceRemainingAmount(stage.unreachedMessage, stage);
    progressBar.setAttribute("aria-valuetext", messageElement.textContent.trim());
    const thresholdAmount = this.querySelector(".ds-free-shipping-bar__amount");
    if (thresholdAmount)
      thresholdAmount.textContent = this._currencyFormatter.format(stage.threshold / 100);
    this.dataset.activeStage = stage.name;
  }
  _onCartChanged(event) {
    // console.log('🛒 [FreeShippingBar] Cart changed event details:', event.detail);

    const shippingItems = event.detail.cart.items.filter(
      (item) => item.requires_shipping
    );
    // console.log('📦 [FreeShippingBar] Shipping items:', shippingItems);

    const priceForItems = shippingItems.reduce(
      (sum, item) => sum + item.final_line_price,
      0
    );
    // console.log('💰 [FreeShippingBar] Price for items:', priceForItems);

    // Use total_discount from cart directly instead of calculating from applications
    const cartDiscount = event.detail.cart.total_discount || 0;
    // console.log('🏷️ [FreeShippingBar] Cart discount:', cartDiscount);

    const finalTotal = priceForItems - cartDiscount;
    // console.log('🧮 [FreeShippingBar] Final total before setting:', finalTotal);

    this.totalPrice = finalTotal;
    const managedGiftTotal = event.detail.cart.items
      .filter((item) => item.properties?._free_gift)
      .reduce((sum, item) => sum + item.final_line_price, 0);
    this.giftTotalPrice = Math.max(0, event.detail.cart.total_price - managedGiftTotal);
  }
};
window.customElements.get("free-shipping-bar") ||
  window.customElements.define("free-shipping-bar", FreeShippingBar);
// js/common/cart/line-item-quantity.js
var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this._onQuantityChanged);

    this.deleteAnchor = this.querySelector(".ds-remove-line");
    this.deleteAnchor?.addEventListener("click", (event) => {
      this._onRemoveLinkClicked(event, this.deleteAnchor.getAttribute("href"));
    });

    //Change with buttons
    this.quantityInput = this.querySelector(".ds-line-item__quantity-input");
    this.buttonIncrement = this.querySelector(".ds-line-item__quantity-add");
    this.buttonDecrement = this.querySelector(".ds-line-item__quantity-remove");

    this.buttonIncrement?.addEventListener("click", () => {
      this.focusAction = "increment";
      this._stepQuantity(1);
    });
    this.buttonDecrement?.addEventListener("click", () => {
      this.focusAction = "decrement";
      this._stepQuantity(-1);
    });
  }
  _stepQuantity(delta) {
    let newQuantity = Math.max(0, parseInt(this.quantityInput.value) + delta);
    const max = parseInt(this.quantityInput.getAttribute("max"));
    if (!isNaN(max)) newQuantity = Math.min(newQuantity, max);
    this.quantityInput.value = newQuantity;
    clearTimeout(this._debounceTimer);
    // ponytail: 300ms debounce bundles rapid clicks into one cart/change.js request
    this._debounceTimer = setTimeout(() => {
      this._changeLineItemQuantity(
        this.quantityInput.getAttribute("data-line-key"),
        newQuantity
      );
    }, 300);
  }
  _onQuantityChanged(event) {
    if (!event.target.hasAttribute("data-line-key")) {
      return;
    }
    this._changeLineItemQuantity(
      event.target.getAttribute("data-line-key"),
      parseInt(event.target.value)
    );
  }
  _onRemoveLinkClicked(event, href) {
    event.preventDefault();
    const url = new URL(window.location.origin + href);
    this._changeLineItemQuantity(
      url.searchParams.get("id"),
      parseInt(url.searchParams.get("quantity"))
    );
  }
  async _changeLineItemQuantity(lineKey, targetQuantity) {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
    } else {
      const announcement = targetQuantity === 0
        ? this.dataset.removeAnnouncement
        : `${this.dataset.quantityAnnouncement}: ${this.dataset.productTitle}, ${targetQuantity}`;
      const lineItem = this.closest("line-item");
      lineItem?.dispatchEvent(
        new CustomEvent("line-item:will-change", {
          bubbles: true,
          detail: { targetQuantity },
        })
      );
      this.setAttribute("aria-busy", "true");
      const errorElement = lineItem?.querySelector(".line-item__quantity-error");
      if (errorElement) errorElement.hidden = true;
      this.buttonIncrement?.setAttribute("disabled", "");
      this.buttonDecrement?.setAttribute("disabled", "");
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      try {
        const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: targetQuantity,
            sections: sectionsToBundle,
          }),
        });
        const cartContent = await response.json();
        if (!response.ok || cartContent.errors) {
          throw new Error(cartContent.description || cartContent.message || "Cart update failed");
        }
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "line-item:change",
              cart: cartContent,
              announcement,
              focusLineKey: lineKey,
              focusAction: this.focusAction,
              targetQuantity,
            },
          })
        );
      } catch (error) {
        console.error("Failed to update cart quantity:", error);
        this.quantityInput.value = this.quantityInput.defaultValue;
        this.removeAttribute("aria-busy");
        lineItem?.querySelector("pill-loader")?.removeAttribute("aria-busy");
        this.buttonIncrement?.removeAttribute("disabled");
        this.buttonDecrement?.removeAttribute("disabled");
        if (errorElement) {
          errorElement.textContent = window.themeVariables.strings.cartUpdateError;
          errorElement.hidden = false;
        }

        const status = document.getElementById("cart-drawer-status");
        if (status) {
          status.textContent = "";
          requestAnimationFrame(() => {
            status.textContent = window.themeVariables.strings.cartUpdateError;
          });
        }

        const focusTarget = this.focusAction === "decrement"
          ? this.buttonDecrement
          : this.buttonIncrement;
        focusTarget?.focus();
      }
    }
  }
};
if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}
var ShippingEstimator = class extends HTMLElement {
  constructor() {
    super(),
      (this._estimateShippingListener = this._estimateShipping.bind(this));
  }
  connectedCallback() {
    (this.submitButton = this.querySelector('[type="submit"]')),
      (this.resultsElement = this.lastElementChild),
      this.submitButton.addEventListener(
        "click",
        this._estimateShippingListener
      );
  }
  disconnectedCallback() {
    this.submitButton.removeEventListener(
      "click",
      this._estimateShippingListener
    );
  }
  async _estimateShipping(event) {
    event.preventDefault();
    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true");
    const prepareResponse = await fetch(
      `${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
      { method: "POST" }
    );
    if (prepareResponse.ok) {
      const shippingRates = await this._getAsyncShippingRates(
        zip,
        country,
        province
      );
      this._formatShippingRates(shippingRates);
    } else {
      const jsonError = await prepareResponse.json();
      this._formatError(jsonError);
    }
    (this.resultsElement.hidden = !1),
      this.submitButton.removeAttribute("aria-busy");
  }
  async _getAsyncShippingRates(zip, country, province) {
    const responseAsText = await (
      await fetch(
        `${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
      )
    ).text();
    return responseAsText === "null"
      ? this._getAsyncShippingRates(zip, country, province)
      : JSON.parse(responseAsText).shipping_rates;
  }
  _formatShippingRates(shippingRates) {
    let formattedShippingRates = shippingRates.map(
      (shippingRate) =>
        `<li>${shippingRate.presentment_name}: ${shippingRate.currency} ${shippingRate.price}</li>`
    );
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${
          shippingRates.length === 0
            ? window.themeVariables.strings.shippingEstimatorNoResults
            : shippingRates.length === 1
            ? window.themeVariables.strings.shippingEstimatorOneResult
            : window.themeVariables.strings.shippingEstimatorMultipleResults
        }</p>
        ${
          formattedShippingRates === ""
            ? ""
            : `<ul class="list-disc" role="list">${formattedShippingRates.join(
                ""
              )}</ul>`
        }
      </div>
    `;
  }
  _formatError(errors) {
    let formattedShippingRates = Object.keys(errors).map(
      (errorKey) => `<li>${errors[errorKey]}</li>`
    );
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="list-disc" role="list">${formattedShippingRates}</ul>
      </div>
    `;
  }
};
window.customElements.get("shipping-estimator") ||
  window.customElements.define("shipping-estimator", ShippingEstimator);
var FacetApplyButton = class extends HTMLButtonElement {
  constructor() {
    super(),
      this.addEventListener("click", this._closeDrawer),
      this.form.addEventListener("change", this._updateCount.bind(this)),
      (this.filterCountElement = document.createElement("span")),
      this.appendChild(this.filterCountElement);
  }
  connectedCallback() {
    this._updateCount();
  }
  _updateCount() {
    const form = new FormData(this.form);
    this.filterCountElement.innerText = ` (${
      Array.from(form.values()).filter((item) => item !== "").length
    })`;
  }
  async _closeDrawer() {
    this.closest("facet-drawer").hide();
  }
};
window.customElements.get("facet-apply-button") ||
  window.customElements.define("facet-apply-button", FacetApplyButton, {
    extends: "button",
  });
var FacetDialog = class extends DialogElement {
  get initialFocus() {
    return !1;
  }
};
window.customElements.get("facet-dialog") ||
  window.customElements.define("facet-dialog", FacetDialog);
var FacetDrawer = class extends Drawer {
  constructor() {
    super(), this.addEventListener("dialog:after-hide", this._submitForm);
  }
  _submitForm() {
    const form = this.querySelector("#facet-form");
    HTMLFormElement.prototype.requestSubmit
      ? form.requestSubmit()
      : form.dispatchEvent(new Event("submit", { cancelable: !0 }));
  }
};
window.customElements.get("facet-drawer") ||
  window.customElements.define("facet-drawer", FacetDrawer);
import { animate as animate5 } from "vendor";
var FacetFloatingFilter = class extends HTMLElement {
  connectedCallback() {
    new IntersectionObserver(this._onFooterVisibilityChanged.bind(this), {
      rootMargin: "50px 0px",
    }).observe(document.querySelector(".shopify-section--footer"));
  }
  _onFooterVisibilityChanged(entries) {
    entries[0].isIntersecting
      ? animate5(
          this,
          {
            opacity: 0,
            transform: [null, "translateY(15px)"],
            visibility: "hidden",
          },
          { duration: 0.15 }
        )
      : animate5(
          this,
          {
            opacity: 1,
            transform: [null, "translateY(0)"],
            visibility: "visible",
          },
          { duration: 0.15 }
        );
  }
};
window.customElements.get("facet-floating-filter") ||
  window.customElements.define("facet-floating-filter", FacetFloatingFilter);
var abortController = null,
  openElements = new Set();
document.addEventListener("facet:update", async (event) => {
  abortController && abortController.abort(),
    (abortController = new AbortController());
  const url = event.detail.url,
    shopifySection = document.getElementById(
      `shopify-section-${url.searchParams.get("section_id")}`
    );
  shopifySection.classList.add("is-loading");
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id"),
    history.replaceState({}, "", clonedUrl.toString());
  try {
    const tempContent = new DOMParser().parseFromString(
      await (
        await cachedFetch(url.toString(), { signal: abortController.signal })
      ).text(),
      "text/html"
    );
    Array.from(tempContent.querySelectorAll("details, facet-dialog")).forEach(
      (item) => {
        openElements.has(item.id) && item.setAttribute("open", "");
      }
    ),
      shopifySection.replaceChildren(
        ...document.importNode(
          tempContent.querySelector(".shopify-section"),
          !0
        ).childNodes
      ),
      shopifySection.classList.remove("is-loading");
    const scrollToElement = window.matchMedia(
      "(min-width: 700px) and (max-width: 999px)"
    ).matches
      ? shopifySection.querySelector(".collection__results")
      : shopifySection.querySelector(".collection__results product-list");
    scrollToElement.getBoundingClientRect().top <
      parseInt(getComputedStyle(scrollToElement).scrollPaddingTop || 0) &&
      scrollToElement.scrollIntoView({ block: "start", behavior: "smooth" });
  } catch {}
});
var FacetForm = class extends HTMLFormElement {
  constructor() {
    super(),
      (this._isDirty = !1),
      this.addEventListener("change", this._onFormChanged),
      this.addEventListener("submit", this._onFormSubmitted);
  }
  connectedCallback() {
    Array.from(this.querySelectorAll("details, facet-dialog")).forEach(
      (disclosureElement) => {
        disclosureElement.open && openElements.add(disclosureElement.id),
          disclosureElement.addEventListener("toggle", () => {
            disclosureElement.open
              ? openElements.add(disclosureElement.id)
              : openElements.delete(disclosureElement.id);
          });
      }
    );
  }
  _buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this)),
      url = new URL(this.action);
    return (
      (url.search = ""),
      searchParams.forEach((value, key) => url.searchParams.append(key, value)),
      ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach(
        (optionToClear) => {
          url.searchParams.get(optionToClear) === "" &&
            url.searchParams.delete(optionToClear);
        }
      ),
      url.searchParams.set("section_id", this.getAttribute("section-id")),
      url
    );
  }
  _onFormChanged() {
    (this._isDirty = !0),
      this.hasAttribute("update-on-change")
        ? HTMLFormElement.prototype.requestSubmit
          ? this.requestSubmit()
          : this.dispatchEvent(new Event("submit", { cancelable: !0 }))
        : cachedFetch(this._buildUrl().toString());
  }
  _onFormSubmitted(event) {
    event.preventDefault(),
      this._isDirty &&
        (this.dispatchEvent(
          new CustomEvent("facet:update", {
            bubbles: !0,
            detail: { url: this._buildUrl() },
          })
        ),
        (this._isDirty = !1));
  }
};
window.customElements.get("facet-form") ||
  window.customElements.define("facet-form", FacetForm, { extends: "form" });
var FacetLink = class extends HTMLAnchorElement {
  constructor() {
    super(), this.addEventListener("click", this._onFacetUpdate);
  }
  _onFacetUpdate(event) {
    event.preventDefault();
    const sectionId = event.target
        .closest(".shopify-section")
        .id.replace("shopify-section-", ""),
      url = new URL(this.href);
    url.searchParams.set("section_id", sectionId),
      this.dispatchEvent(
        new CustomEvent("facet:update", { bubbles: !0, detail: { url } })
      );
  }
};
window.customElements.get("facet-link") ||
  window.customElements.define("facet-link", FacetLink, { extends: "a" });
var FacetSortBy = class extends HTMLElement {
  constructor() {
    super(), this.addEventListener("listbox:change", this._onValueChanged);
  }
  _onValueChanged(event) {
    const url = new URL(location.href),
      sectionId = event.target
        .closest(".shopify-section")
        .id.replace("shopify-section-", "");
    url.searchParams.set("sort_by", event.detail.value),
      url.searchParams.set("section_id", sectionId),
      url.searchParams.delete("page"),
      this.dispatchEvent(
        new CustomEvent("facet:update", { bubbles: !0, detail: { url } })
      );
  }
};
window.customElements.get("facet-sort-by") ||
  window.customElements.define("facet-sort-by", FacetSortBy);
import {
  animate as animate6,
  timeline as timeline4,
  stagger as stagger4,
} from "vendor";
var PillLoader = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-busy"];
  }
  connectedCallback() {
    this.innerHTML = `
      <div class="loader-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <svg class="loader-checkmark" fill="none" width="9" height="8" viewBox="0 0 9 8">
        <path d="M1 3.5 3.3 6 8 1" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    newValue === "true"
      ? (timeline4([
          [
            this,
            {
              opacity: [0, 1],
              visibility: "visible",
              transform: ["translateY(5px)", "translateY(0)"],
            },
            { duration: 0.15 },
          ],
          [
            this.firstElementChild,
            { opacity: 1, transform: ["translateY(0)"] },
            { duration: 0.15, at: "<" },
          ],
          [this.lastElementChild, { opacity: 0 }, { duration: 0, at: "<" }],
        ]),
        animate6(
          this.firstElementChild.querySelectorAll("span"),
          { opacity: [1, 0.1] },
          {
            duration: 0.35,
            delay: stagger4(0.35 / 3),
            direction: "alternate",
            repeat: 1 / 0,
          }
        ))
      : timeline4([
          [
            this.firstElementChild,
            { opacity: 0, transform: ["translateY(0)", "translateY(-2px)"] },
            { duration: 0.15 },
          ],
          [
            this.lastElementChild,
            { opacity: 1, transform: ["translateY(2px)", "translateY(0)"] },
            { duration: 0.15 },
          ],
          [
            this,
            {
              opacity: 0,
              transform: ["translateY(0)", "translateY(-5px)"],
              visibility: "hidden",
            },
            { duration: 0.15, at: "+0.8" },
          ],
        ]);
  }
};
window.customElements.get("pill-loader") ||
  window.customElements.define("pill-loader", PillLoader);
var ProgressBar = class extends HTMLElement {
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    this.style.setProperty(
      "--progress",
      `${Math.min(
        1,
        this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax")
      )}`
    );
  }
};
window.customElements.get("progress-bar") ||
  window.customElements.define("progress-bar", ProgressBar);
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    (this._abortController = new AbortController()),
      (this.rangeLowerBound = this.querySelector(
        'input[type="range"]:first-child'
      )),
      (this.rangeHigherBound = this.querySelector(
        'input[type="range"]:last-child'
      )),
      (this.textInputLowerBound = this.querySelector(
        'input[name="filter.v.price.gte"]'
      )),
      (this.textInputHigherBound = this.querySelector(
        'input[name="filter.v.price.lte"]'
      )),
      this.textInputLowerBound.addEventListener(
        "focus",
        () => this.textInputLowerBound.select(),
        { signal: this._abortController.signal }
      ),
      this.textInputHigherBound.addEventListener(
        "focus",
        () => this.textInputHigherBound.select(),
        { signal: this._abortController.signal }
      ),
      this.textInputLowerBound.addEventListener(
        "change",
        (event) => {
          event.preventDefault(),
            (event.target.value = Math.max(
              Math.min(
                parseInt(event.target.value),
                parseInt(this.textInputHigherBound.value || event.target.max) -
                  1
              ),
              event.target.min
            )),
            (this.rangeLowerBound.value = event.target.value),
            this.rangeLowerBound.parentElement.style.setProperty(
              "--range-min",
              `${
                (parseInt(this.rangeLowerBound.value) /
                  parseInt(this.rangeLowerBound.max)) *
                100
              }%`
            );
        },
        { signal: this._abortController.signal }
      ),
      this.textInputHigherBound.addEventListener(
        "change",
        (event) => {
          event.preventDefault(),
            (event.target.value = Math.min(
              Math.max(
                parseInt(event.target.value),
                parseInt(this.textInputLowerBound.value || event.target.min) + 1
              ),
              event.target.max
            )),
            (this.rangeHigherBound.value = event.target.value),
            this.rangeHigherBound.parentElement.style.setProperty(
              "--range-max",
              `${
                (parseInt(this.rangeHigherBound.value) /
                  parseInt(this.rangeHigherBound.max)) *
                100
              }%`
            );
        },
        { signal: this._abortController.signal }
      ),
      this.rangeLowerBound.addEventListener(
        "change",
        (event) => {
          event.stopPropagation(),
            (this.textInputLowerBound.value = event.target.value),
            this.textInputLowerBound.dispatchEvent(
              new Event("change", { bubbles: !0 })
            );
        },
        { signal: this._abortController.signal }
      ),
      this.rangeHigherBound.addEventListener(
        "change",
        (event) => {
          event.stopPropagation(),
            (this.textInputHigherBound.value = event.target.value),
            this.textInputHigherBound.dispatchEvent(
              new Event("change", { bubbles: !0 })
            );
        },
        { signal: this._abortController.signal }
      ),
      this.rangeLowerBound.addEventListener(
        "input",
        (event) => {
          (event.target.value = Math.min(
            parseInt(event.target.value),
            parseInt(this.textInputHigherBound.value || event.target.max) - 1
          )),
            event.target.parentElement.style.setProperty(
              "--range-min",
              `${
                (parseInt(event.target.value) / parseInt(event.target.max)) *
                100
              }%`
            ),
            (this.textInputLowerBound.value = event.target.value);
        },
        { signal: this._abortController.signal }
      ),
      this.rangeHigherBound.addEventListener(
        "input",
        (event) => {
          (event.target.value = Math.max(
            parseInt(event.target.value),
            parseInt(this.textInputLowerBound.value || event.target.min) + 1
          )),
            event.target.parentElement.style.setProperty(
              "--range-max",
              `${
                (parseInt(event.target.value) / parseInt(event.target.max)) *
                100
              }%`
            ),
            (this.textInputHigherBound.value = event.target.value);
        },
        { signal: this._abortController.signal }
      );
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
window.customElements.get("price-range") ||
  window.customElements.define("price-range", PriceRange);
var QuantitySelector = class extends HTMLElement {
    connectedCallback() {
      (this._abortController = new AbortController()),
        (this.inputElement = this.querySelector("input")),
        this.querySelector("button:first-of-type").addEventListener(
          "click",
          this.stepDown.bind(this),
          { signal: this._abortController.signal }
        ),
        this.querySelector("button:last-of-type").addEventListener(
          "click",
          this.stepUp.bind(this),
          { signal: this._abortController.signal }
        );
    }
    stepDown() {
      this.inputElement.stepDown(),
        this.inputElement.dispatchEvent(new Event("change", { bubbles: !0 }));
    }
    stepUp() {
      this.inputElement.stepUp(),
        this.inputElement.dispatchEvent(new Event("change", { bubbles: !0 }));
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
  },
  QuantityInput = class extends HTMLInputElement {
    constructor() {
      super(),
        this.addEventListener("input", this._onValueInput),
        this.addEventListener("change", this._onValueChanged),
        this.addEventListener("focus", this.select);
    }
    disconnectedCallback() {
      this._abortController?.abort();
    }
    get quantity() {
      return parseInt(this.value);
    }
    set quantity(quantity) {
      const isNumeric =
        (typeof quantity == "number" ||
          (typeof quantity == "string" && quantity.trim() !== "")) &&
        !isNaN(quantity);
      quantity !== "" &&
        ((!isNumeric || quantity < 0) && (quantity = parseInt(quantity) || 1),
        (this.value = Math.max(
          this.min || 1,
          Math.min(quantity, this.max || Number.MAX_VALUE)
        ).toString()),
        this.checkValidity() || this.stepDown());
    }
    _onValueInput() {
      (this.quantity = this.value),
        this.style.setProperty(
          "--quantity-input-characters-count",
          `${this.value.toString().length}ch`
        );
    }
    _onValueChanged() {
      this.value === "" && (this.quantity = this.min || 1),
        this.checkValidity() || this.stepDown(),
        this.style.setProperty(
          "--quantity-input-characters-count",
          `${this.value.toString().length}ch`
        );
    }
  };
window.customElements.get("quantity-selector") ||
  window.customElements.define("quantity-selector", QuantitySelector),
  window.customElements.get("quantity-input") ||
    window.customElements.define("quantity-input", QuantityInput, {
      extends: "input",
    });
var ResizableTextarea = class extends HTMLTextAreaElement {
  constructor() {
    super(), this.addEventListener("input", this._onInput);
  }
  _onInput() {
    (this.style.height = "auto"),
      (this.style.height = this.scrollHeight + 2 + "px");
  }
};
window.customElements.get("resizable-textarea") ||
  window.customElements.define("resizable-textarea", ResizableTextarea, {
    extends: "textarea",
  });
var _accessibilityInitialized,
  _hiddenInput,
  _Listbox_instances,
  onOptionClicked_fn,
  onInputChanged_fn,
  onKeyDown_fn,
  Listbox = class extends HTMLElement {
    constructor() {
      super(),
        __privateAdd(this, _Listbox_instances),
        __privateAdd(this, _accessibilityInitialized, !1),
        __privateAdd(this, _hiddenInput),
        this.addEventListener(
          "keydown",
          __privateMethod(this, _Listbox_instances, onKeyDown_fn)
        );
    }
    static get observedAttributes() {
      return ["aria-activedescendant"];
    }
    connectedCallback() {
      __privateGet(this, _accessibilityInitialized) ||
        (this.setAttribute("role", "listbox"),
        __privateSet(
          this,
          _hiddenInput,
          this.querySelector('input[type="hidden"]')
        ),
        __privateGet(this, _hiddenInput)?.addEventListener(
          "change",
          __privateMethod(this, _Listbox_instances, onInputChanged_fn).bind(
            this
          )
        ),
        Array.from(this.querySelectorAll('[role="option"]')).forEach(
          (option) => {
            option.addEventListener(
              "click",
              __privateMethod(
                this,
                _Listbox_instances,
                onOptionClicked_fn
              ).bind(this)
            ),
              (option.id =
                "option-" +
                (crypto.randomUUID
                  ? crypto.randomUUID()
                  : Math.floor(Math.random() * 1e4))),
              option.getAttribute("aria-selected") === "true" &&
                this.setAttribute("aria-activedescendant", option.id);
          }
        ),
        __privateSet(this, _accessibilityInitialized, !0));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      name === "aria-activedescendant" &&
        oldValue !== null &&
        newValue !== oldValue &&
        Array.from(this.querySelectorAll('[role="option"]')).forEach(
          (option) => {
            option.id === newValue
              ? (option.setAttribute("aria-selected", "true"),
                __privateGet(this, _hiddenInput) &&
                  __privateGet(this, _hiddenInput).value !== option.value &&
                  ((__privateGet(this, _hiddenInput).value = option.value),
                  __privateGet(this, _hiddenInput).dispatchEvent(
                    new Event("change", { bubbles: !0 })
                  )),
                this.hasAttribute("aria-owns") &&
                  this.getAttribute("aria-owns")
                    .split(" ")
                    .forEach((boundId) => {
                      document.getElementById(boundId).textContent =
                        option.getAttribute("title") ||
                        option.innerText ||
                        option.value;
                    }),
                option.dispatchEvent(
                  new CustomEvent("listbox:change", {
                    bubbles: !0,
                    detail: { value: option.value },
                  })
                ))
              : option.setAttribute("aria-selected", "false");
          }
        );
    }
  };
(_accessibilityInitialized = new WeakMap()),
  (_hiddenInput = new WeakMap()),
  (_Listbox_instances = new WeakSet()),
  (onOptionClicked_fn = function (event) {
    this.setAttribute("aria-activedescendant", event.currentTarget.id),
      event.currentTarget.dispatchEvent(
        new CustomEvent("listbox:select", {
          bubbles: !0,
          detail: { value: event.currentTarget.value },
        })
      );
  }),
  (onInputChanged_fn = function (event) {
    this.setAttribute(
      "aria-activedescendant",
      this.querySelector(
        `[role="option"][value="${CSS.escape(event.target.value)}"]`
      ).id
    );
  }),
  (onKeyDown_fn = function (event) {
    event.key === "ArrowUp"
      ? (event.target.previousElementSibling?.focus(), event.preventDefault())
      : event.key === "ArrowDown" &&
        (event.target.nextElementSibling?.focus(), event.preventDefault());
  }),
  window.customElements.get("x-listbox") ||
    window.customElements.define("x-listbox", Listbox);
function imageLoaded(imageOrArray) {
  return imageOrArray
    ? ((imageOrArray =
        imageOrArray instanceof Element
          ? [imageOrArray]
          : Array.from(imageOrArray)),
      Promise.all(
        imageOrArray.map(
          (image) =>
            new Promise((resolve) => {
              (image.tagName === "IMG" && image.complete) || !image.offsetParent
                ? resolve()
                : (image.onload = () => resolve());
            })
        )
      ))
    : Promise.resolve();
}
function generateSrcset(imageObjectOrString, widths = []) {
  let imageUrl, maxWidth;
  return (
    typeof imageObjectOrString == "string"
      ? ((imageUrl = new URL(
          imageObjectOrString.startsWith("//")
            ? `https:${imageObjectOrString}`
            : imageObjectOrString
        )),
        (maxWidth = parseInt(imageUrl.searchParams.get("width"))))
      : ((imageUrl = new URL(
          imageObjectOrString.src.startsWith("//")
            ? `https:${imageObjectOrString.src}`
            : imageObjectOrString.src
        )),
        (maxWidth = imageObjectOrString.width)),
    widths
      .filter((width) => width <= maxWidth)
      .map(
        (width) => (
          imageUrl.searchParams.set("width", width.toString()),
          `${imageUrl.href} ${width}w`
        )
      )
      .join(", ")
  );
}
function createMediaImg(media, widths = [], properties = {}) {
  const image = new Image(
      media.preview_image.width,
      media.preview_image.height
    ),
    src = media.preview_image.src,
    featuredMediaUrl = new URL(src.startsWith("//") ? `https:${src}` : src);
  for (const propertyKey in properties)
    image.setAttribute(propertyKey, properties[propertyKey]);
  return (
    (image.alt = media.alt),
    (image.src = featuredMediaUrl.href),
    (image.srcset = generateSrcset(media.preview_image, widths)),
    image
  );
}
var _recipientCheckbox,
  _recipientOtherProperties,
  _recipientSendOnProperty,
  _offsetProperty,
  _recipientFieldsContainer,
  _GiftCardRecipient_instances,
  synchronizeProperties_fn,
  formatDate_fn,
  GiftCardRecipient = class extends HTMLElement {
    constructor() {
      super(...arguments),
        __privateAdd(this, _GiftCardRecipient_instances),
        __privateAdd(this, _recipientCheckbox),
        __privateAdd(this, _recipientOtherProperties, []),
        __privateAdd(this, _recipientSendOnProperty),
        __privateAdd(this, _offsetProperty),
        __privateAdd(this, _recipientFieldsContainer);
    }
    connectedCallback() {
      const properties = Array.from(
          this.querySelectorAll('[name*="properties"]')
        ),
        checkboxPropertyName =
          "properties[__shopify_send_gift_card_to_recipient]";
      __privateSet(
        this,
        _recipientCheckbox,
        properties.find((input) => input.name === checkboxPropertyName)
      ),
        __privateSet(
          this,
          _recipientOtherProperties,
          properties.filter((input) => input.name !== checkboxPropertyName)
        ),
        __privateSet(
          this,
          _recipientFieldsContainer,
          this.querySelector(".gift-card-recipient__fields")
        ),
        __privateSet(
          this,
          _offsetProperty,
          this.querySelector('[name="properties[__shopify_offset]"]')
        ),
        __privateGet(this, _offsetProperty) &&
          (__privateGet(this, _offsetProperty).value = new Date()
            .getTimezoneOffset()
            .toString()),
        __privateSet(
          this,
          _recipientSendOnProperty,
          this.querySelector('[name="properties[Send on]"]')
        );
      const minDate = new Date(),
        maxDate = new Date();
      maxDate.setDate(minDate.getDate() + 90),
        __privateGet(this, _recipientSendOnProperty)?.setAttribute(
          "min",
          __privateMethod(
            this,
            _GiftCardRecipient_instances,
            formatDate_fn
          ).call(this, minDate)
        ),
        __privateGet(this, _recipientSendOnProperty)?.setAttribute(
          "max",
          __privateMethod(
            this,
            _GiftCardRecipient_instances,
            formatDate_fn
          ).call(this, maxDate)
        ),
        __privateGet(this, _recipientCheckbox)?.addEventListener(
          "change",
          __privateMethod(
            this,
            _GiftCardRecipient_instances,
            synchronizeProperties_fn
          ).bind(this)
        ),
        __privateMethod(
          this,
          _GiftCardRecipient_instances,
          synchronizeProperties_fn
        ).call(this);
    }
  };
(_recipientCheckbox = new WeakMap()),
  (_recipientOtherProperties = new WeakMap()),
  (_recipientSendOnProperty = new WeakMap()),
  (_offsetProperty = new WeakMap()),
  (_recipientFieldsContainer = new WeakMap()),
  (_GiftCardRecipient_instances = new WeakSet()),
  (synchronizeProperties_fn = function () {
    __privateGet(this, _recipientOtherProperties).forEach(
      (property) =>
        (property.disabled = !__privateGet(this, _recipientCheckbox).checked)
    ),
      __privateGet(this, _recipientFieldsContainer).toggleAttribute(
        "hidden",
        !__privateGet(this, _recipientCheckbox).checked
      );
  }),
  (formatDate_fn = function (date) {
    const offset = date.getTimezoneOffset();
    return new Date(date.getTime() - offset * 60 * 1e3)
      .toISOString()
      .split("T")[0];
  }),
  window.customElements.get("gift-card-recipient") ||
    window.customElements.define("gift-card-recipient", GiftCardRecipient);
import { Delegate as Delegate3 } from "vendor";
var ProductCard = class extends HTMLElement {
  constructor() {
    super(), (this._delegate = new Delegate3(this));
  }
  connectedCallback() {
    this._delegate.on(
      "change",
      '.product-card__swatch-list [type="radio"], .product-card__variant-list [type="radio"]',
      this._onSwatchChanged.bind(this)
    ),
      this._delegate.on(
        "pointerover",
        '.product-card__swatch-list [type="radio"] + label, .product-card__variant-list [type="radio"] + label',
        this._onSwatchHovered.bind(this),
        !0
      );
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  async _onSwatchHovered(event, target) {
    const control = target.control,
      primaryMediaElement = this.querySelector(".product-card__image--primary");
    control.hasAttribute("data-variant-media") &&
      this._createImageElement(
        JSON.parse(control.getAttribute("data-variant-media")),
        primaryMediaElement.className,
        primaryMediaElement.sizes
      );
  }
  async _onSwatchChanged(event, target) {
    if (
      (target.hasAttribute("data-variant-id") &&
        this.querySelectorAll(
          `a[href^="${Shopify.routes.root}products/${this.getAttribute(
            "handle"
          )}"`
        ).forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set(
            "variant",
            target.getAttribute("data-variant-id")
          ),
            (link.href = `${url.pathname}${url.search}${url.hash}`);
        }),
      !target.hasAttribute("data-variant-media"))
    )
      return;
    const newMedia = JSON.parse(target.getAttribute("data-variant-media")),
      primaryMediaElement = this.querySelector(".product-card__image--primary"),
      newPrimaryMediaElement = this._createImageElement(
        newMedia,
        primaryMediaElement.className,
        primaryMediaElement.sizes
      );
    primaryMediaElement.src !== newPrimaryMediaElement.src &&
      (await primaryMediaElement.animate(
        { opacity: [1, 0] },
        { duration: 150, easing: "ease-in", fill: "forwards" }
      ).finished,
      await new Promise((resolve) =>
        newPrimaryMediaElement.complete
          ? resolve()
          : (newPrimaryMediaElement.onload = () => resolve())
      ),
      primaryMediaElement.replaceWith(newPrimaryMediaElement),
      newPrimaryMediaElement.animate(
        { opacity: [0, 1] },
        { duration: 150, easing: "ease-in" }
      ));
  }
  _createImageElement(media, classes, sizes) {
    return createMediaImg(
      media,
      [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800],
      { class: classes, sizes }
    );
  }
};
window.customElements.get("product-card") ||
  window.customElements.define("product-card", ProductCard);
var ProductForm = class extends HTMLFormElement {
  #submitting = !1;
  constructor() {
    super(), this.addEventListener("submit", this._onSubmit);
  }
  connectedCallback() {
    this.id.disabled = !1;
  }
  async _onSubmit(event) {
    if ((event.preventDefault(), this.#submitting)) return;
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const submitButtons = Array.from(this.elements).filter(
      (button) => button.type === "submit"
    );
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("aria-busy", "true");
    });
    if (
      window.themeVariables.settings.cartType === "drawer" &&
      window.themeVariables.settings.cartDrawerVersion === "ds" &&
      window.themeVariables.settings.pageType !== "cart"
    ) {
      this.#submitting = !0;
      try {
        const { cartAdapter } = await import("ds-cart-ajax");
        await cartAdapter.add(new FormData(this), { initiator: this });
      } catch (error) {
        this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: !0, detail: { error: error.message }
        }));
      } finally {
        submitButtons.forEach((button) => button.removeAttribute("aria-busy"));
        this.#submitting = !1;
      }
      return;
    }
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: !0,
        detail: { sections: sectionsToBundle },
      })
    );
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(",")),
      formData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${this.id.value}`
      ),
      (this.#submitting = !0);
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("aria-busy");
    }),
      (this.#submitting = !1);
    const responseJson = await response.json();
    if (response.ok) {
      if (
        window.themeVariables.settings.cartType === "page" ||
        window.themeVariables.settings.pageType === "cart"
      )
        return (window.location.href = `${Shopify.routes.root}cart`);
      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart.js`)
      ).json();
      (cartContent.sections = responseJson.sections),
        this.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: !0,
            detail: {
              items: responseJson.hasOwnProperty("items")
                ? responseJson.items
                : [responseJson],
              cart: cartContent,
            },
          })
        ),
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: !0,
            detail: { baseEvent: "variant:add", cart: cartContent },
          })
        );
    } else
      this.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: !0,
          detail: { error: responseJson.description },
        })
      ),
        document.dispatchEvent(new CustomEvent("cart:refresh"));
  }
};
window.customElements.get("product-form") ||
  window.customElements.define("product-form", ProductForm, {
    extends: "form",
  });
var BuyButtons = class extends HTMLElement {
  constructor() {
    super(), (this._onCartErrorListener = this._onCartError.bind(this));
  }
  connectedCallback() {
    (this._productForm = document.forms[this.getAttribute("form")]),
      this._productForm?.addEventListener(
        "cart:error",
        this._onCartErrorListener
      );
  }
  disconnectedCallback() {
    this._productForm?.removeEventListener(
      "cart:error",
      this._onCartErrorListener
    );
  }
  _onCartError(event) {
    const errorBanner = document.createElement("div");
    errorBanner.classList.add("banner", "banner--error", "justify-center"),
      errorBanner.setAttribute("role", "alert"),
      (errorBanner.style.gridColumn = "1/-1"),
      (errorBanner.style.marginBottom = "1rem"),
      (errorBanner.innerHTML = `
      <svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
        <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
      </svg>
      
      <p>${event.detail.error}</p>
    `),
      this.before(errorBanner),
      setTimeout(async () => {
        await errorBanner.animate(
          { opacity: [1, 0] },
          { duration: 250, fill: "forwards" }
        ).finished,
          errorBanner.remove();
      }, 5e3);
  }
};
window.customElements.get("buy-buttons") ||
  window.customElements.define("buy-buttons", BuyButtons);
import { PhotoSwipeLightbox } from "vendor";
var ProductGallery = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      const form = document.forms[this.getAttribute("form")];
      form?.addEventListener(
        "product:rerender",
        this._onSectionRerender.bind(this),
        { signal: this._abortController.signal }
      ),
        form?.addEventListener(
          "variant:change",
          this._onVariantChanged.bind(this),
          { signal: this._abortController.signal }
        ),
        (this._carousels = Array.from(this.querySelectorAll("media-carousel"))),
        (this._pageDots = Array.from(this.querySelectorAll("page-dots"))),
        (this._viewInSpaceButton = this.querySelector("[data-shopify-xr]")),
        (this._customCursor = this.querySelector(".product-gallery__cursor")),
        this.addEventListener("carousel:change", this._onCarouselChanged),
        this._viewInSpaceButton &&
          this.addEventListener(
            "carousel:settle",
            this._updateViewInSpaceButton
          ),
        this.hasAttribute("allow-zoom") &&
          this.addEventListener("lightbox:open", (event) =>
            this.openZoom(event.detail.index)
          );
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get filteredIndexes() {
      return JSON.parse(this.getAttribute("filtered-indexes")).map(
        (index) => parseInt(index) - 1
      );
    }
    get photoswipe() {
      if (this._photoswipe) return this._photoswipe;
      const photoswipe = new PhotoSwipeLightbox({
        pswpModule: () => import("photoswipe"),
        bgOpacity: 1,
        maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
        closeTitle: window.themeVariables.strings.closeGallery,
        zoomTitle: window.themeVariables.strings.zoomGallery,
        errorMsg: window.themeVariables.strings.errorGallery,
        arrowPrev: !1,
        arrowNext: !1,
        counter: !1,
        zoom: !1,
        closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
        <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
        <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
        <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
      </svg>`,
      });
      return (
        photoswipe.addFilter(
          "thumbEl",
          (thumbEl, data) => data.thumbnailElement
        ),
        photoswipe.on("uiRegister", () => {
          photoswipe.pswp.ui.registerElement({
            name: "bottom-bar",
            order: 5,
            appendTo: "wrapper",
            html: `
          <div class="pagination">
            <button class="pagination__item group" rel="prev">
              <span class="animated-arrow animated-arrow--reverse"></span>
            </button>
            
            <span class="pagination__current text-sm">
              <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
            </span>
            
            <button class="pagination__item group" rel="next">
              <span class="animated-arrow"></span>
            </button>
          </div>
        `,
            onInit: (el, pswp) => {
              (el.querySelector(".pagination__page-count").innerText =
                pswp.getNumItems()),
                el
                  .querySelector('[rel="prev"]')
                  ?.addEventListener("click", () => pswp.prev()),
                el
                  .querySelector('[rel="next"]')
                  ?.addEventListener("click", () => pswp.next()),
                pswp.on("change", () => {
                  el.querySelector(".pagination__current-page").innerText =
                    pswp.currIndex + 1;
                });
            },
          });
        }),
        photoswipe.init(),
        (this._photoswipe = photoswipe)
      );
    }
    openZoom(index = 0) {
      const dataSource = Array.from(
        this.querySelectorAll(
          '.product-gallery__media[data-media-type="image"]:not([hidden]) > img'
        )
      ).map((image) => ({
        thumbnailElement: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt: image.alt,
        thumbCropped: !0,
      }));
      this.photoswipe.loadAndOpen(index, dataSource);
    }
    _updateViewInSpaceButton(event) {
      event.detail.slide.getAttribute("data-media-type") === "model"
        ? this._viewInSpaceButton.setAttribute(
            "data-shopify-model3d-id",
            event.detail.slide.getAttribute("data-media-id")
          )
        : this._viewInSpaceButton.setAttribute(
            "data-shopify-model3d-id",
            this._viewInSpaceButton.getAttribute(
              "data-shopify-model3d-default-id"
            )
          );
    }
    _onCarouselChanged(event) {
      this._customCursor &&
        this._customCursor.toggleAttribute(
          "hidden",
          event.detail.slide.getAttribute("data-media-type") !== "image"
        );
    }
    _onVariantChanged(event) {
      if (!event.detail.variant) return;
      let newMediaPosition;
      (event.detail.previousVariant === null ||
        (event.detail.variant.featured_media &&
          event.detail.previousVariant.featured_media &&
          event.detail.previousVariant.featured_media.id !==
            event.detail.variant.featured_media.id) ||
        (!event.detail.previousVariant.featured_media &&
          event.detail.variant.featured_media)) &&
        (newMediaPosition = event.detail.variant.featured_media.position - 1),
        newMediaPosition !== void 0 &&
          this._carousels.forEach((carousel) =>
            carousel.select(newMediaPosition, { animate: !1 })
          );
    }
    _onSectionRerender(event) {
      const galleryMarkup = deepQuerySelector(
        event.detail.htmlFragment,
        `${this.tagName}[form="${this.getAttribute("form")}"]`
      );
      if (
        galleryMarkup &&
        galleryMarkup.filteredIndex !== this.filteredIndexes
      ) {
        this.setAttribute(
          "filtered-indexes",
          galleryMarkup.getAttribute("filtered-indexes")
        );
        const filteredIndexes = this.filteredIndexes;
        this._carousels.forEach((carousel) =>
          carousel.dispatchEvent(
            new CustomEvent("carousel:filter", { detail: { filteredIndexes } })
          )
        ),
          this._pageDots.forEach((pageDots) =>
            pageDots.dispatchEvent(
              new CustomEvent("control:filter", { detail: { filteredIndexes } })
            )
          );
      }
    }
  },
  MediaCarousel = class extends ScrollCarousel {
    connectedCallback() {
      super.connectedCallback(),
        (this._onGestureChangedListener = this._onGestureChanged.bind(this)),
        this.addEventListener("gesturestart", this._onGestureStart, {
          capture: !1,
          signal: this._abortController.signal,
        }),
        this.addEventListener("carousel:settle", this._onMediaSettled, {
          signal: this._abortController.signal,
        }),
        this.addEventListener("click", this._onGalleryClick);
    }
    _onMediaSettled(event) {
      const media = event.detail.slide;
      switch (
        (this.items
          .filter((item) =>
            ["video", "external_video", "model"].includes(
              item.getAttribute("data-media-type")
            )
          )
          .forEach((item) => item.firstElementChild.pause()),
        media.getAttribute("data-media-type"))
      ) {
        case "external_video":
        case "video":
          this.hasAttribute("autoplay") && media.firstElementChild.play();
          break;
        case "model":
          window.matchMedia("(min-width: 1000px)").matches &&
            media.firstElementChild.play();
          break;
      }
    }
    _onGalleryClick(event) {
      if (
        event.target.matches(
          "button, a[href], button :scope, a[href] :scope"
        ) ||
        !window.matchMedia("screen and (pointer: fine)").matches ||
        this.selectedSlide.getAttribute("data-media-type") !== "image"
      )
        return;
      const rect = event.currentTarget.getBoundingClientRect();
      event.clientX - rect.left > this.clientWidth / 2
        ? this.next()
        : this.previous();
    }
    _onGestureStart(event) {
      event.preventDefault(),
        this.addEventListener("gesturechange", this._onGestureChangedListener, {
          capture: !1,
          signal: this._abortController.signal,
        });
    }
    _onGestureChanged(event) {
      if ((event.preventDefault(), event.scale > 1.5)) {
        const visibleImages = this.visibleItems.filter(
            (item) => item.getAttribute("data-media-type") === "image"
          ),
          openIndex = visibleImages.indexOf(this.selectedSlide);
        this.dispatchEvent(
          new CustomEvent("lightbox:open", {
            bubbles: !0,
            detail: { index: openIndex },
          })
        ),
          this.removeEventListener(
            "gesturechange",
            this._onGestureChangedListener
          );
      }
    }
  },
  ProductZoomButton = class extends HTMLButtonElement {
    constructor() {
      super(), this.addEventListener("click", this._onButtonClicked);
    }
    _onButtonClicked() {
      let media = this.closest(".product-gallery__media"),
        openIndex;
      if (media)
        openIndex = this.closest("media-carousel")
          .visibleItems.filter(
            (item) => item.getAttribute("data-media-type") === "image"
          )
          .indexOf(media);
      else {
        const carousel = this.closest(
          ".product-gallery__media-list-wrapper"
        ).querySelector("media-carousel");
        openIndex = carousel.visibleItems
          .filter((item) => item.getAttribute("data-media-type") === "image")
          .indexOf(carousel.selectedSlide);
      }
      this.dispatchEvent(
        new CustomEvent("lightbox:open", {
          bubbles: !0,
          detail: { index: openIndex },
        })
      );
    }
  };
window.customElements.get("product-gallery") ||
  window.customElements.define("product-gallery", ProductGallery),
  window.customElements.get("product-zoom-button") ||
    window.customElements.define("product-zoom-button", ProductZoomButton, {
      extends: "button",
    }),
  window.customElements.get("media-carousel") ||
    window.customElements.define("media-carousel", MediaCarousel);
var ProductLoader = class {
    static loadedProducts = {};
    static load(productHandle) {
      if (productHandle)
        return this.loadedProducts[productHandle]
          ? this.loadedProducts[productHandle]
          : ((this.loadedProducts[productHandle] = new Promise(
              async (resolve, reject) => {
                const response = await fetch(
                  `${Shopify.routes.root}products/${productHandle}.js`
                );
                if (response.ok) {
                  const responseAsJson = await response.json();
                  resolve(responseAsJson);
                } else
                  reject(`
          Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
              }
            )),
            this.loadedProducts[productHandle]);
    }
  },
  ProductQuickAdd = class extends HTMLElement {
    #scopeFromPassed = !1;
    #scopeToReached = !1;
    #intersectionObserver = new IntersectionObserver(
      this._onObserved.bind(this)
    );
    connectedCallback() {
      (this._scopeFrom = document.getElementById(this.getAttribute("form"))),
        (this._scopeTo = document.querySelector(".footer")),
        !(!this._scopeFrom || !this._scopeTo) &&
          (this.#intersectionObserver.observe(this._scopeFrom),
          this.#intersectionObserver.observe(this._scopeTo));
    }
    disconnectedCallback() {
      this.#intersectionObserver.disconnect();
    }
    _onObserved(entries) {
      entries.forEach((entry) => {
        entry.target === this._scopeFrom &&
          (this.#scopeFromPassed = entry.boundingClientRect.bottom < 0),
          entry.target === this._scopeTo &&
            (this.#scopeToReached = entry.isIntersecting);
      }),
        this.classList.toggle(
          "is-visible",
          this.#scopeFromPassed && !this.#scopeToReached
        );
        document.documentElement.classList.toggle(
          "ds-quick-add-open",
          this.#scopeFromPassed && !this.#scopeToReached
        );
    }
  };
window.customElements.get("product-quick-add") ||
  window.customElements.define("product-quick-add", ProductQuickAdd);
var _productRerenderAbortController,
  _ProductRerender_instances,
  onRerender_fn,
  ProductRerender = class extends HTMLElement {
    constructor() {
      super(...arguments),
        __privateAdd(this, _ProductRerender_instances),
        __privateAdd(this, _productRerenderAbortController);
    }
    connectedCallback() {
      __privateSet(this, _productRerenderAbortController, new AbortController()),
        (!this.id || !this.hasAttribute("observe-form")) &&
          console.warn(
            'The <product-rerender> requires an ID to identify the element to re-render, and an "observe-form" attribute referencing to the form to monitor.'
          ),
        document.forms[this.getAttribute("observe-form")].addEventListener(
          "product:rerender",
          __privateMethod(this, _ProductRerender_instances, onRerender_fn).bind(
            this
          ),
          { signal: __privateGet(this, _productRerenderAbortController).signal }
        );
    }
    disconnectedCallback() {
      __privateGet(this, _productRerenderAbortController).abort();
    }
  };
(_productRerenderAbortController = new WeakMap()),
  (_ProductRerender_instances = new WeakSet()),
  (onRerender_fn = function (event) {
    const matchingElement = deepQuerySelector(
      event.detail.htmlFragment,
      `#${this.id}`
    );
    if (!matchingElement) return;
    const focusedElement = document.activeElement;
    if (
      (!this.hasAttribute("allow-partial-rerender") ||
      event.detail.productChange
        ? this.replaceWith(matchingElement)
        : [
            "sku",
            "badges",
            "price",
            "payment-terms",
            "variant-picker",
            "quantity-selector",
            "volume-pricing",
            "inventory",
            "buy-buttons",
            "pickup-availability",
            "liquid",
          ].forEach((blockType) => {
            this.querySelectorAll(`[data-block-type="${blockType}"]`).forEach(
              (element) => {
                const matchingBlock = matchingElement.querySelector(
                  `[data-block-type="${blockType}"][data-block-id="${element.getAttribute(
                    "data-block-id"
                  )}"]`
                );
                if (matchingBlock)
                  if (
                    (matchingBlock
                      .querySelectorAll("noscript")
                      .forEach((noscript) => {
                        noscript.remove();
                      }),
                    blockType === "buy-buttons")
                  )
                    element
                      .querySelector("buy-buttons")
                      .replaceWith(matchingBlock.querySelector("buy-buttons"));
                  else if (blockType === "quantity-selector") {
                    const existingQuantity = element.querySelector(
                      ".quantity-selector__input"
                    )?.quantity;
                    element.replaceWith(matchingBlock);
                    const newSelector = matchingBlock.querySelector(
                      ".quantity-selector__input"
                    );
                    newSelector && (newSelector.quantity = existingQuantity);
                  } else element.replaceWith(matchingBlock);
              }
            );
          }),
      focusedElement.id)
    ) {
      const element = document.getElementById(focusedElement.id);
      this.contains(element) && element.focus();
    }
  }),
  window.customElements.get("product-rerender") ||
    window.customElements.define("product-rerender", ProductRerender);
import { animate as animate7, timeline as timeline5 } from "vendor";
var quickBuyResponseCache = new Map(),
  preloadQuickBuyResponse = (handle) => {
    if (!handle) return Promise.resolve(null);
    const url = `${window.Shopify.routes.root}products/${handle}`;
    if (!quickBuyResponseCache.has(url)) {
      const responsePromise = fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Quick Buy request failed (${response.status})`);
          return response.text();
        })
        .catch((error) => {
          quickBuyResponseCache.delete(url);
          throw error;
        });
      quickBuyResponseCache.set(url, responsePromise);
      setTimeout(() => {
        if (quickBuyResponseCache.get(url) === responsePromise) quickBuyResponseCache.delete(url);
      }, 1e3 * 60 * 5);
    }
    return quickBuyResponseCache.get(url);
  };
var QuickBuyDrawer = class extends Drawer {
  constructor() {
    super(),
      (this._hasLoaded = !1),
      (this._initialProductPicker = null),
      this.addEventListener("variant:add", this._onVariantAdded.bind(this));
  }
  get _isDesktopDialog() {
    return !reduceDrawerAnimation && !window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`).matches;
  }
  // ponytail: desktop shows this as a centered dialog (grow/fade), not a slide-in drawer;
  // mobile keeps the inherited bottom-sheet slide untouched
  _showTransition(animate19 = !0) {
    if (!this._isDesktopDialog) return super._showTransition(animate19);
    this._setInitialPosition();
    const content = this.shadowRoot.querySelector('[part="content"]'),
      closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]'),
      animationControls = timeline5([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { opacity: [0, 1], scale: [0.92, 1] }, { duration: 0.25, easing: [0.16, 1, 0.3, 1] }],
        [content.children, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
      ]);
    return (
      animate19 ? animationControls.play() : animationControls.finish(),
      animationControls.finished.then(() => this.classList.add("show-close-cursor"))
    );
  }
  _hideTransition() {
    if (!this._isDesktopDialog) return super._hideTransition();
    const content = this.shadowRoot.querySelector('[part="content"]'),
      closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]'),
      animationControls = timeline5([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { opacity: [null, 0], scale: [1, 0.92] }, { at: "<", duration: 0.2, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }],
      ]);
    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
  connectedCallback() {
    // ponytail: same product can render into multiple hidden/visible tabs (e.g. nav_collections),
    // producing duplicate ids that make one click open two stacked drawers. Liquid can't dedupe this
    // (render-scoped {% increment %} resets per call), so re-key the later duplicate here instead.
    if (this.id) {
      const dupes = document.querySelectorAll(`[id="${this.id}"]`);
      if (dupes.length > 1 && dupes[dupes.length - 1] === this) {
        const button = this.parentElement?.querySelector(
          `[aria-controls="${this.id}"]`
        );
        let suffix = 0,
          newId;
        do {
          newId = `${this.id}--${suffix++}`;
        } while (document.getElementById(newId));
        button?.setAttribute("aria-controls", newId);
        this.id = newId;
      }
    }
    super.connectedCallback();
  }
  preload(handles = []) {
    handles.filter(Boolean).forEach((handle) => {
      preloadQuickBuyResponse(handle).catch(() => {});
    });
  }
  async show() {
    if (((this.style.display = "block"), !this._hasLoaded)) {
      const requestedHandle = this.getAttribute("handle");
      [this, ...this.controls].forEach((control) =>
        control.setAttribute("aria-busy", "true")
      );
      const responseContent = await preloadQuickBuyResponse(requestedHandle);
      if (requestedHandle !== this.getAttribute("handle")) return this.show();
      [this, ...this.controls].forEach((control) =>
        control.setAttribute("aria-busy", "false")
      );
      const quickBuyContent = new DOMParser()
        .parseFromString(responseContent, "text/html")
        .getElementById("quick-buy-content").content;
      const incomingProductPicker = quickBuyContent
          .querySelector(".ds-product-quick-buy__variants")
          ?.closest(".product-info__product-picker"),
        requestedUrl = new URL(requestedHandle, window.location.origin),
        requestedProductHandle = requestedUrl.pathname.split("/").filter(Boolean).pop(),
        requestedVariantId = requestedUrl.searchParams.get("variant");
      if (!this._initialProductPicker && incomingProductPicker) {
        this._initialProductPicker = incomingProductPicker.cloneNode(!0);
      } else if (this._initialProductPicker) {
        const stableProductPicker = this._initialProductPicker.cloneNode(!0);
        if (incomingProductPicker) {
          incomingProductPicker.replaceWith(stableProductPicker);
        } else {
          quickBuyContent.querySelector(".quick-buy-drawer__info")?.append(stableProductPicker);
        }
      }
      quickBuyContent
        .querySelectorAll(".ds-product-quick-buy__variant[data-product-handle][data-variant-id]")
        .forEach((option) => {
          option.classList.toggle(
            "is-selected",
            option.getAttribute("data-product-handle") === requestedProductHandle &&
              option.getAttribute("data-variant-id") === requestedVariantId
          );
        });
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach(
        (noScript) => noScript.remove()
      ),
        this.replaceChildren(quickBuyContent),
        Shopify.PaymentButton?.init(),
        (this._hasLoaded = !0),
        this.preload(
          Array.from(
            this.querySelectorAll(".ds-product-quick-buy__variant[data-product-handle][data-variant-id]")
          ).map(
            (option) =>
              `${option.getAttribute("data-product-handle")}?variant=${option.getAttribute("data-variant-id")}`
          )
        );
    }
    return super.show();
  }
  async hide() {
    return super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded(event) {
    if (event.detail.dsCart) {
      event.detail.returnFocusTo = this.controls.find((control) => control.getClientRects().length);
      event.detail.quickBuyClosed = this.hide();
      return;
    }
    // ponytail: when the theme is configured to use the cart drawer, close Quick Buy
    // and let the global variant:add listener open the updated cart drawer. Only show
    // the "added to cart" confirmation here when the confirmation popover is enabled.
    if (
      this.hasAttribute("skip-variant-added") ||
      window.themeVariables.settings.cartType === "drawer" ||
      document.getElementById("cart-drawer")?.open
    ) {
      this.hide();
      return;
    }
    event.detail.blockCartDrawerOpening = !0;
    const contentShadow = this.shadowRoot.querySelector('[part="content"]'),
      fromHeight = contentShadow.clientHeight;
    animate7(
      contentShadow.children,
      { opacity: 0, visibility: "hidden" },
      { duration: 0.15 }
    ),
      this.replaceChildren(
        ...new DOMParser()
          .parseFromString(
            event.detail.cart.sections["variant-added"],
            "text/html"
          )
          .querySelector(".shopify-section").children
      ),
      requestAnimationFrame(async () => {
        await timeline5([
          [
            contentShadow,
            { height: [`${fromHeight}px`, `${contentShadow.clientHeight}px`] },
            { duration: 0.35, easing: [0.86, 0, 0.07, 1] },
          ],
          [
            contentShadow.children,
            { opacity: [0, 1], visibility: "visible" },
            { duration: 0.15 },
          ],
        ]).finished,
          (contentShadow.style.height = null);
      }),
      (this._hasLoaded = !1);
  }
};
window.customElements.get("quick-buy-drawer") ||
  window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
import { Delegate as Delegate4 } from "vendor";
var CACHE_EVICTION_TIME = 1e3 * 60 * 5,
  _preloadedHtml,
  _delegate,
  _intersectionObserver,
  _form,
  _selectedVariant,
  _VariantPicker_instances,
  getActiveOptionValues_fn,
  getOptionValuesFromOption_fn,
  onOptionChanged_fn,
  onOptionPreload_fn,
  onIntersection_fn,
  renderForCombination_fn,
  createHashKeyForHtml_fn,
  _VariantPicker = class extends HTMLElement {
    constructor() {
      super(...arguments),
        __privateAdd(this, _VariantPicker_instances),
        __privateAdd(this, _delegate, new Delegate4(document.body)),
        __privateAdd(
          this,
          _intersectionObserver,
          new IntersectionObserver(
            __privateMethod(
              this,
              _VariantPicker_instances,
              onIntersection_fn
            ).bind(this)
          )
        ),
        __privateAdd(this, _form),
        __privateAdd(this, _selectedVariant);
    }
    async connectedCallback() {
      __privateSet(
        this,
        _selectedVariant,
        JSON.parse(
          this.querySelector("script[data-variant]")?.textContent || "{}"
        )
      ),
        __privateSet(this, _form, document.forms[this.getAttribute("form-id")]),
        __privateGet(this, _delegate).on(
          "change",
          `input[data-option-position][form="${this.getAttribute("form-id")}"]`,
          __privateMethod(
            this,
            _VariantPicker_instances,
            onOptionChanged_fn
          ).bind(this)
        ),
        __privateGet(this, _delegate).on(
          "pointerenter",
          `input[data-option-position][form="${this.getAttribute(
            "form-id"
          )}"]:not(:checked) + label`,
          __privateMethod(
            this,
            _VariantPicker_instances,
            onOptionPreload_fn
          ).bind(this),
          !0
        ),
        __privateGet(this, _delegate).on(
          "touchstart",
          `input[data-option-position][form="${this.getAttribute(
            "form-id"
          )}"]:not(:checked) + label`,
          __privateMethod(
            this,
            _VariantPicker_instances,
            onOptionPreload_fn
          ).bind(this),
          !0
        ),
        __privateGet(this, _intersectionObserver).observe(this);
    }
    disconnectedCallback() {
      __privateGet(this, _delegate).off(),
        __privateGet(this, _intersectionObserver).unobserve(this);
    }
    get selectedVariant() {
      return __privateGet(this, _selectedVariant);
    }
    get productHandle() {
      return this.getAttribute("handle");
    }
    get updateUrl() {
      return this.hasAttribute("update-url");
    }
    async selectCombination({ optionValues, productChange }) {
      const previousVariant = this.selectedVariant,
        newContent = document
          .createRange()
          .createContextualFragment(
            await __privateMethod(
              this,
              _VariantPicker_instances,
              renderForCombination_fn
            ).call(this, optionValues)
          );
      if (!productChange) {
        const newVariantPicker = deepQuerySelector(
            newContent,
            `${this.tagName}[form-id="${this.getAttribute("form-id")}"]`
          ),
          newVariant = JSON.parse(
            newVariantPicker.querySelector("script[data-variant]")
              ?.textContent || "{}"
          );
        if (
          (__privateSet(this, _selectedVariant, newVariant),
          (__privateGet(this, _form).id.value = __privateGet(
            this,
            _selectedVariant
          )?.id),
          __privateGet(this, _form).id.dispatchEvent(
            new Event("change", { bubbles: !0 })
          ),
          this.updateUrl && __privateGet(this, _selectedVariant)?.id)
        ) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set(
            "variant",
            __privateGet(this, _selectedVariant).id
          ),
            window.history.replaceState(
              { path: newUrl.toString() },
              "",
              newUrl.toString()
            );
        }
      }
      __privateGet(this, _form).dispatchEvent(
        new CustomEvent("product:rerender", {
          detail: { htmlFragment: newContent, productChange },
        })
      ),
        productChange ||
          __privateGet(this, _form).dispatchEvent(
            new CustomEvent("variant:change", {
              bubbles: !0,
              detail: {
                formId: __privateGet(this, _form).id,
                variant: __privateGet(this, _selectedVariant),
                previousVariant,
              },
            })
          ),
        Shopify?.PaymentButton?.init();
    }
  };
(_preloadedHtml = new WeakMap()),
  (_delegate = new WeakMap()),
  (_intersectionObserver = new WeakMap()),
  (_form = new WeakMap()),
  (_selectedVariant = new WeakMap()),
  (_VariantPicker_instances = new WeakSet()),
  (getActiveOptionValues_fn = function () {
    return Array.from(__privateGet(this, _form).elements)
      .filter((item) => item.matches("input[data-option-position]:checked"))
      .sort(
        (a, b) =>
          parseInt(a.getAttribute("data-option-position")) -
          parseInt(b.getAttribute("data-option-position"))
      )
      .map((input) => input.value);
  }),
  (getOptionValuesFromOption_fn = function (input) {
    return [
      input,
      ...Array.from(__privateGet(this, _form).elements).filter((item) =>
        item.matches(
          `input[data-option-position]:not([name="${input.name}"]):checked`
        )
      ),
    ]
      .sort(
        (a, b) =>
          parseInt(a.getAttribute("data-option-position")) -
          parseInt(b.getAttribute("data-option-position"))
      )
      .map((input2) => input2.value);
  }),
  (onOptionChanged_fn = async function (event) {
    event.target.name.includes("option") &&
      this.selectCombination({
        optionValues: __privateMethod(
          this,
          _VariantPicker_instances,
          getActiveOptionValues_fn
        ).call(this),
        productChange: event.target.hasAttribute("data-product-url"),
      });
  }),
  (onOptionPreload_fn = function (event, target) {
    __privateMethod(
      this,
      _VariantPicker_instances,
      renderForCombination_fn
    ).call(
      this,
      __privateMethod(
        this,
        _VariantPicker_instances,
        getOptionValuesFromOption_fn
      ).call(this, target.control)
    );
  }),
  (onIntersection_fn = function (entries) {
    const prerenderOptions = () => {
      Array.from(__privateGet(this, _form).elements)
        .filter((item) =>
          item.matches("input[data-option-position]:not(:checked)")
        )
        .forEach((input) => {
          __privateMethod(
            this,
            _VariantPicker_instances,
            renderForCombination_fn
          ).call(
            this,
            __privateMethod(
              this,
              _VariantPicker_instances,
              getOptionValuesFromOption_fn
            ).call(this, input)
          );
        });
    };
    entries[0].isIntersecting &&
      (window.requestIdleCallback
        ? window.requestIdleCallback(prerenderOptions, { timeout: 2e3 })
        : prerenderOptions());
  }),
  (renderForCombination_fn = async function (optionValues) {
    const optionValuesAsString = optionValues.join(","),
      hashKey = __privateMethod(
        this,
        _VariantPicker_instances,
        createHashKeyForHtml_fn
      ).call(this, optionValuesAsString);
    let productUrl = `${Shopify.routes.root}products/${this.productHandle}`;
    for (const optionValue of optionValues) {
      const inputForOptionValue = Array.from(
        __privateGet(this, _form).elements
      ).find((item) => item.matches(`input[value="${optionValue}"]`));
      if (inputForOptionValue?.dataset.productUrl) {
        productUrl = inputForOptionValue.dataset.productUrl;
        break;
      }
    }
    if (!__privateGet(_VariantPicker, _preloadedHtml).has(hashKey)) {
      const sectionQueryParam =
          this.getAttribute("context") === "quick_buy"
            ? ""
            : `&section_id=${this.getAttribute("section-id")}`,
        promise = new Promise(async (resolve) => {
          resolve(
            await (
              await fetch(
                `${productUrl}?option_values=${optionValuesAsString}${sectionQueryParam}`
              )
            ).text()
          );
        });
      __privateGet(_VariantPicker, _preloadedHtml).set(hashKey, {
        htmlPromise: promise,
        timestamp: Date.now(),
      }),
        __privateGet(_VariantPicker, _preloadedHtml).size > 100 &&
          __privateGet(_VariantPicker, _preloadedHtml).delete(
            Array.from(__privateGet(_VariantPicker, _preloadedHtml).keys())[0]
          );
    }
    return __privateGet(_VariantPicker, _preloadedHtml).get(hashKey)
      .htmlPromise;
  }),
  (createHashKeyForHtml_fn = function (optionValuesAsString) {
    return `${optionValuesAsString}-${this.getAttribute("section-id")}`;
  }),
  __privateAdd(_VariantPicker, _preloadedHtml, new Map());
var VariantPicker = _VariantPicker;
window.customElements.get("variant-picker") ||
  window.customElements.define("variant-picker", VariantPicker);
import { inView as inView4 } from "vendor";
var BaseMedia = class extends HTMLElement {
    static get observedAttributes() {
      return ["playing"];
    }
    connectedCallback() {
      (this._abortController = new AbortController()),
        this.hasAttribute("autoplay") &&
          inView4(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get playing() {
      return this.hasAttribute("playing");
    }
    get player() {
      return (this._playerProxy =
        this._playerProxy ||
        new Proxy(this._playerTarget(), {
          get: (target, prop) => async () => {
            (target = await target), this._playerHandler(target, prop);
          },
        }));
    }
    play() {
      this.playing || this.player.play();
    }
    pause() {
      this.playing && this.player.pause();
    }
    attributeChangedCallback(name, oldValue, newValue) {
      name === "playing" &&
        (oldValue === null && newValue === ""
          ? (this.dispatchEvent(new CustomEvent("media:play", { bubbles: !0 })),
            this.hasAttribute("group") &&
              Array.from(
                document.querySelectorAll(
                  `[group="${this.getAttribute("group")}"]`
                )
              )
                .filter((item) => item !== this)
                .forEach((itemToPause) => {
                  itemToPause.pause();
                }))
          : newValue === null &&
            this.dispatchEvent(
              new CustomEvent("media:pause", { bubbles: !0 })
            ));
    }
  },
  ModelMedia = class extends BaseMedia {
    connectedCallback() {
      super.connectedCallback(), this.player;
    }
    _playerTarget() {
      return new Promise((resolve) => {
        this.setAttribute("loaded", ""),
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: this._setupShopifyXr.bind(this),
            },
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: () => {
                const modelViewer = this.querySelector("model-viewer");
                modelViewer.addEventListener(
                  "shopify_model_viewer_ui_toggle_play",
                  () => this.setAttribute("playing", "")
                ),
                  modelViewer.addEventListener(
                    "shopify_model_viewer_ui_toggle_pause",
                    () => this.removeAttribute("playing")
                  ),
                  this.setAttribute("can-play", ""),
                  resolve(
                    new window.Shopify.ModelViewerUI(modelViewer, {
                      focusOnPlay: !0,
                    })
                  );
              },
            },
          ]);
      });
    }
    _playerHandler(target, prop) {
      target[prop]();
    }
    async _setupShopifyXr() {
      if (!window.ShopifyXR)
        document.addEventListener(
          "shopify_xr_initialized",
          this._setupShopifyXr.bind(this)
        );
      else {
        const models = (
          await ProductLoader.load(this.getAttribute("handle"))
        ).media.filter((media) => media.media_type === "model");
        window.ShopifyXR.addModels(models), window.ShopifyXR.setupXRElements();
      }
    }
  };
window.customElements.get("model-media") ||
  window.customElements.define("model-media", ModelMedia);
var onYouTubePromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = () => resolve();
  }),
  VideoMedia = class extends BaseMedia {
    static activeInstances = new Set(); // Hier speichern wir alle aktiven Video-Instanzen

    connectedCallback() {
      super.connectedCallback();
      this.hasAttribute("autoplay") ||
        this.addEventListener("click", this.play, {
          once: !0,
          signal: this._abortController.signal,
        });
      this.hasAttribute("show-play-button") &&
        !this.shadowRoot &&
        this.attachShadow({ mode: "open" }).appendChild(
          document.createRange().createContextualFragment(`
        <slot></slot>
        
        <svg part="play-button" fill="none" width="24" height="24" viewBox="0 0 48 48">
          <path d="M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24s10.745 24 24 24 24-10.745 24-24Z" fill="rgb(var(--button-background-primary))"/>
          <path d="M18.578 32.629a.375.375 0 0 1-.578-.316V15.687c0-.297.328-.476.578-.316l12.931 8.314c.23.147.23.483 0 .63L18.578 32.63Z" fill="rgb(var(--button-text-primary))"/>
          <path d="M24 .5C36.979.5 47.5 11.021 47.5 24S36.979 47.5 24 47.5.5 36.979.5 24 11.021.5 24 .5Z" stroke="rgb(var(--button-text-primary))" stroke-opacity=".25"/>
        </svg>
      `)
        );
    }

    // Methode zum Stoppen aller anderen Videos
    stopOtherVideos() {
      VideoMedia.activeInstances.forEach((instance) => {
        if (instance !== this && instance.hasAttribute("playing")) {
          instance.pause();
        }
      });
    }

    play({ restart = !1 } = {}) {
      this.stopOtherVideos(); // Stoppe andere Videos bevor dieses startet
      restart &&
        !this.hasAttribute("host") &&
        (this.querySelector("video").currentTime = 0);
      super.play();
    }

    pause() {
      super.pause();
    }

    _playerTarget() {
      if (this.hasAttribute("host")) {
        return (
          this.setAttribute("loaded", ""),
          new Promise(async (resolve) => {
            const templateElement = this.querySelector("template");
            templateElement &&
              templateElement.replaceWith(
                templateElement.content.firstElementChild.cloneNode(!0)
              );
            const muteVideo =
                this.hasAttribute("autoplay") ||
                window.matchMedia("screen and (max-width: 999px)").matches,
              script = document.createElement("script");

            if (this.getAttribute("host") === "youtube") {
              (!window.YT || !window.YT.Player) &&
                ((script.src = "https://www.youtube.com/iframe_api"),
                document.head.appendChild(script),
                await new Promise((resolve2) => {
                  script.onload = resolve2;
                }));
              await onYouTubePromise;
              this.setAttribute("can-play", "");

              const player = new YT.Player(this.querySelector("iframe"), {
                events: {
                  onReady: () => {
                    muteVideo && player.mute();
                    VideoMedia.activeInstances.add(this); // Füge Instanz hinzu
                    resolve(player);
                  },
                  onStateChange: (event) => {
                    event.data === YT.PlayerState.PLAYING
                      ? this.setAttribute("playing", "")
                      : (event.data === YT.PlayerState.ENDED ||
                          event.data === YT.PlayerState.PAUSED) &&
                        this.removeAttribute("playing");
                  },
                },
              });
            }

            if (this.getAttribute("host") === "vimeo") {
              (!window.Vimeo || !window.Vimeo.Player) &&
                ((script.src = "https://player.vimeo.com/api/player.js"),
                document.head.appendChild(script),
                await new Promise((resolve2) => {
                  script.onload = resolve2;
                }));

              const player = new Vimeo.Player(this.querySelector("iframe"));
              muteVideo && player.setMuted(!0);
              this.setAttribute("can-play", "");
              VideoMedia.activeInstances.add(this); // Füge Instanz hinzu

              player.on("play", () => {
                this.setAttribute("playing", "");
              });
              player.on("pause", () => this.removeAttribute("playing"));
              player.on("ended", () => this.removeAttribute("playing"));
              resolve(player);
            }
          })
        );
      } else {
        const previewVideo = this.querySelector(".ds-product-video__preview");
        previewVideo?.pause();
        previewVideo?.remove();
        const templateElement = this.querySelector("template");
        templateElement &&
          templateElement.replaceWith(
            templateElement.content.firstElementChild.cloneNode(!0)
          );
        const videoElement = this.querySelector(
          ".ds-product-video__full, video"
        );
        this.setAttribute("loaded", "");
        this.setAttribute("can-play", "");
        VideoMedia.activeInstances.add(this); // Füge Instanz hinzu

        videoElement.addEventListener("play", () => {
          this.stopOtherVideos(); // Stoppe andere Videos bevor dieses startet
          this.setAttribute("playing", "");
          this.removeAttribute("suspended");
        });
        videoElement.addEventListener("pause", () => {
          !videoElement.seeking &&
            videoElement.paused &&
            this.removeAttribute("playing");
        });

        return videoElement;
      }
    }

    disconnectedCallback() {
      VideoMedia.activeInstances.delete(this); // Entferne Instanz wenn Element entfernt wird
      super.disconnectedCallback?.();
    }

    _playerHandler(target, prop) {
      this.getAttribute("host") === "youtube"
        ? prop === "play"
          ? target.playVideo()
          : target.pauseVideo()
        : prop === "play" && !this.hasAttribute("host")
        ? target.play().catch((error) => {
            if (error.name === "NotAllowedError") {
              this.setAttribute("suspended", "");
              target.controls = !0;
              const replacementImageSrc =
                target.previousElementSibling?.currentSrc;
              replacementImageSrc && (target.poster = replacementImageSrc);
            }
          })
        : target[prop]();
    }
  };

window.customElements.get("video-media") ||
  window.customElements.define("video-media", VideoMedia);
import { timeline as timeline6 } from "vendor";
var AnimatedDetails = class extends HTMLDetailsElement {
    constructor() {
      super(),
        (this.summaryElement = this.firstElementChild),
        (this.contentElement = this.lastElementChild),
        (this._open = this.hasAttribute("open")),
        this.summaryElement.addEventListener(
          "click",
          this._onSummaryClicked.bind(this)
        ),
        Shopify.designMode &&
          (this.addEventListener(
            "shopify:block:select",
            () => (this.open = !0)
          ),
          this.addEventListener(
            "shopify:block:deselect",
            () => (this.open = !1)
          ));
    }
    set open(value) {
      value !== this._open &&
        ((this._open = value),
        this.isConnected
          ? this._transition(value)
          : value
          ? this.setAttribute("open", "")
          : this.removeAttribute("open"));
    }
    get open() {
      return this._open;
    }
    _onSummaryClicked(event) {
      event.preventDefault(), (this.open = !this.open);
    }
    _transition(value) {}
  },
  AccordionDisclosure = class extends AnimatedDetails {
    async _transition(value) {
      (this.style.overflow = "hidden"),
        value
          ? (this.setAttribute("open", ""),
            await timeline6([
              [
                this,
                {
                  height: [
                    `${this.summaryElement.clientHeight}px`,
                    `${this.scrollHeight}px`,
                  ],
                },
                { duration: 0.25, easing: "ease" },
              ],
              [
                this.contentElement,
                {
                  opacity: [0, 1],
                  transform: ["translateY(0)", "translateY(-4px)"],
                },
                { duration: 0.15, at: "-0.1" },
              ],
            ]).finished)
          : (await timeline6([
              [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
              [
                this,
                {
                  height: [
                    `${this.clientHeight}px`,
                    `${this.summaryElement.clientHeight}px`,
                  ],
                },
                { duration: 0.25, at: "<", easing: "ease" },
              ],
            ]).finished,
            this.removeAttribute("open")),
        (this.style.height = "auto"),
        (this.style.overflow = "visible");
    }
  };
window.customElements.get("accordion-disclosure") ||
  window.customElements.define("accordion-disclosure", AccordionDisclosure, {
    extends: "details",
  });
import { animate as animate8 } from "vendor";
var Tabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super(),
      this.shadowRoot ||
        this.attachShadow({ mode: "open" }).appendChild(
          this.querySelector("template").content.cloneNode(!0)
        ),
      Shopify.designMode &&
        this.addEventListener(
          "shopify:block:select",
          (event) => (this.selectedIndex = this.buttons.indexOf(event.target))
        ),
      this.addEventListener("keydown", this._handleKeyboard);
  }
  connectedCallback() {
    (this._abortController = new AbortController()),
      (this.buttons = Array.from(
        this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(),
        (item) =>
          (item.matches("button") && item) || item.querySelector("button")
      )),
      (this.panels = Array.from(
        this.shadowRoot.querySelector('slot[name="content"]').assignedNodes()
      )),
      this.buttons.forEach((button, index) =>
        button.addEventListener("click", () => (this.selectedIndex = index), {
          signal: this._abortController.signal,
        })
      ),
      (this.selectedIndex = this.selectedIndex),
      this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration")
      ? parseFloat(this.getAttribute("animation-duration"))
      : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute(
      "selected-index",
      Math.min(Math.max(index, 0), this.buttons.length - 1).toString()
    ),
      this.style.setProperty("--selected-index", this.selectedIndex.toString()),
      this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) =>
      button.setAttribute(
        "aria-selected",
        index === parseInt(newValue) ? "true" : "false"
      )
    ),
      name === "selected-index" &&
        oldValue !== null &&
        oldValue !== newValue &&
        this._transition(
          this.panels[parseInt(oldValue)],
          this.panels[parseInt(newValue)]
        );
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID
      ? crypto.randomUUID()
      : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab"),
        button.setAttribute(
          "aria-controls",
          `tab-panel-${componentID}-${index}`
        ),
        (button.id = `tab-${componentID}-${index}`);
    }),
      this.panels.forEach((panel, index) => {
        panel.setAttribute("role", "tabpanel"),
          panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`),
          (panel.id = `tab-panel-${componentID}-${index}`),
          (panel.hidden = index !== this.selectedIndex);
      });
  }
  _handleKeyboard(event) {
    this.buttons.indexOf(document.activeElement) === -1 ||
      !["ArrowLeft", "ArrowRight"].includes(event.key) ||
      (event.key === "ArrowLeft"
        ? (this.selectedIndex =
            (this.selectedIndex - 1 + this.buttons.length) %
            this.buttons.length)
        : (this.selectedIndex =
            (this.selectedIndex + 1 + this.buttons.length) %
            this.buttons.length),
      this.buttons[this.selectedIndex].focus());
  }
  async _transition(fromPanel, toPanel) {
    await animate8(
      fromPanel,
      { opacity: [1, 0] },
      { duration: this.animationDuration }
    ).finished,
      (fromPanel.hidden = !0),
      (toPanel.hidden = !1),
      await animate8(
        toPanel,
        { opacity: [0, 1] },
        { duration: this.animationDuration }
      ).finished;
  }
};
window.customElements.get("x-tabs") ||
  window.customElements.define("x-tabs", Tabs);
import { animate as animate9 } from "vendor";
var PredictiveSearch = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(
      document
        .createRange()
        .createContextualFragment('<slot name="idle"></slot>')
    );
  }
  connectedCallback() {
    (this._searchForm = this.closest("form")),
      (this._queryInput = this._searchForm.elements.q),
      this._searchForm.addEventListener(
        "submit",
        this._onFormSubmitted.bind(this)
      ),
      this._searchForm.addEventListener(
        "reset",
        this._onSearchCleared.bind(this)
      ),
      this._queryInput.addEventListener(
        "input",
        debounce(this._onInputChanged.bind(this), this.autoCompleteDelay)
      );
  }
  get autoCompleteDelay() {
    return 280;
  }
  supportsPredictiveApi() {
    return JSON.parse(document.getElementById("shopify-features").innerHTML)
      .predictiveSearch;
  }
  _onInputChanged() {
    const query = this._queryInput.value;
    if (query === "") return this._onSearchCleared();
    this._abortController?.abort(),
      (this._abortController = new AbortController());
    try {
      return this.supportsPredictiveApi()
        ? this._doPredictiveSearch()
        : this._doFallbackSearch();
    } catch (e) {
      if (e.name !== "AbortError") throw e;
    }
  }
  _onFormSubmitted(event) {
    if (this._queryInput.value === "") return event.preventDefault();
  }
  async _doPredictiveSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${encodeURIComponent(
        this._queryInput.value
      )}&section_id=${this.getAttribute("data-fetch-section-id") || this.getAttribute(
        "section-id"
      )}&resources[type]=product,page,article&resources[limit]=10&resources[limit_scope]=each`;
    const fetchUrl = `${window.Shopify.routes.root}search/suggest?${queryParams}`;
    try {
        const nodeElement = new DOMParser().parseFromString(
            await (await cachedFetch(fetchUrl, { signal: this._abortController.signal })).text(),
            "text/html"
          );
        const results = nodeElement.querySelector('[slot="results"]');
        if (results) {
          this.querySelector('[slot="results"]').replaceWith(document.importNode(results, true));
        }
        return this._transitionToSlot("results");
    } catch (error) {
        if (error.name === 'AbortError') {
            return;
        }
        this._transitionToSlot("idle");
    }
  }
  async _doFallbackSearch() {
    await this._transitionToSlot("loading");
    const queryParams = `q=${encodeURIComponent(
        this._queryInput.value
      )}&section_id=${this.getAttribute("data-fetch-section-id") || this.getAttribute(
        "section-id"
      )}&resources[limit]=10&resources[limit_scope]=each`;
      const fetchUrl = `${window.Shopify.routes.root}search?${queryParams}`;
    const nodeElement = new DOMParser().parseFromString(
        await (
          await cachedFetch(
            fetchUrl,
            { signal: this._abortController.signal }
          )
        ).text(),
        "text/html"
      );
    const results = nodeElement.querySelector('[slot="results"]');
    if (results) {
      this.querySelector('[slot="results"]').replaceWith(document.importNode(results, true));
    }
    return this._transitionToSlot("results");
  }
  _onSearchCleared() {
    return (
      this._abortController?.abort(),
      this._queryInput.focus(),
      this._transitionToSlot("idle")
    );
  }
  async _transitionToSlot(toSlotName) {
    if (this.shadowRoot.firstElementChild.name !== toSlotName)
      return (
        await animate9(
          this.shadowRoot.firstElementChild.assignedNodes(),
          { opacity: [1, 0] },
          { duration: 0.1 }
        ).finished,
        this.shadowRoot.firstElementChild.setAttribute("name", toSlotName),
        animate9(
          this.shadowRoot.firstElementChild.assignedNodes(),
          { opacity: [0, 1], transform: ["translateY(5px)", "translateY(0)"] },
          { duration: 0.1 }
        ).finished
      );
  }
};
window.customElements.get("predictive-search") ||
  window.customElements.define("predictive-search", PredictiveSearch);
var SearchDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return !1;
  }
  get openFrom() {
    return window.matchMedia(`${window.themeVariables.breakpoints["sm-max"]}`)
      .matches
      ? "top"
      : this.getAttribute("open-from") || "right";
  }
};
window.customElements.get("search-drawer") ||
  window.customElements.define("search-drawer", SearchDrawer);
import { animate as animate10, inView as inView5 } from "vendor";
var _SectionHeader_instances,
  reveal_fn2,
  SectionHeader = class extends HTMLElement {
    constructor() {
      super(...arguments), __privateAdd(this, _SectionHeader_instances);
    }
    connectedCallback() {
      window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
        inView5(
          this,
          __privateMethod(this, _SectionHeader_instances, reveal_fn2).bind(
            this
          ),
          { margin: "0px 0px -100px 0px" }
        );
    }
  };
(_SectionHeader_instances = new WeakSet()),
  (reveal_fn2 = function () {
    const heading = this.querySelector('h2[reveal-on-scroll="true"]'),
      headingKeyframe = getHeadingKeyframe(heading);
    animate10(...headingKeyframe);
  }),
  window.customElements.get("section-header") ||
    window.customElements.define("section-header", SectionHeader);
var MarqueeText = class extends HTMLElement {
  constructor() {
    super(),
      window.ResizeObserver &&
        new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
  }
  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5),
      contentWidth = entries[0].contentRect.width,
      slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / 1225;
    this.style.setProperty(
      "--marquee-animation-duration",
      `${(
        (scrollingSpeed *
          slowFactor *
          entries[0].target.querySelector("span").clientWidth) /
        contentWidth
      ).toFixed(3)}s`
    );
  }
};
window.customElements.get("marquee-text") ||
  window.customElements.define("marquee-text", MarqueeText);
import { timeline as timeline7 } from "vendor";
var AnnouncementBar = class extends EffectCarousel {
  _transitionTo(fromSlide, toSlide) {
    timeline7([
      [
        fromSlide,
        {
          transform: ["translateY(0)", "translateY(-5px)"],
          opacity: [1, 0],
          visibility: ["visible", "hidden"],
        },
        { duration: 0.2 },
      ],
      [
        toSlide,
        {
          transform: ["translateY(5px)", "translateY(0)"],
          opacity: [0, 1],
          visibility: ["hidden", "visible"],
        },
        { duration: 0.2 },
      ],
    ]);
  }
};
window.customElements.get("announcement-bar") ||
  window.customElements.define("announcement-bar", AnnouncementBar);
var SplitCursor = class extends HTMLElement {
  connectedCallback() {
    (this._parentSection = this.closest(".shopify-section")),
      (this._dragging = !1),
      (this._offsetX = this._currentX = 0),
      this._parentSection.addEventListener(
        "pointerdown",
        this._onPointerDown.bind(this)
      ),
      this._parentSection.addEventListener(
        "pointermove",
        this._onPointerMove.bind(this)
      ),
      this._parentSection.addEventListener(
        "pointerup",
        this._onPointerUp.bind(this)
      ),
      this.addEventListener("keydown", this._onKeyDown.bind(this)),
      this._recalculateOffset(),
      window.addEventListener("resize", this._recalculateOffset.bind(this));
  }
  get minOffset() {
    return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
  }
  get maxOffset() {
    return this.offsetParent.clientWidth + this.minOffset;
  }
  _onPointerDown(event) {
    (event.target === this || this.contains(event.target)) &&
      ((this._initialX = event.clientX - this._offsetX), (this._dragging = !0));
  }
  _onPointerMove(event) {
    this._dragging &&
      ((this._currentX = Math.min(
        Math.max(event.clientX - this._initialX, this.minOffset),
        this.maxOffset
      )),
      (this._offsetX = this._currentX),
      this._updatePosition());
  }
  _onPointerUp() {
    this._dragging = !1;
  }
  _onKeyDown(event) {
    const currentValue = Number(this.getAttribute("aria-valuenow")) || 0;
    let nextValue = currentValue;
    switch (event.key) {
      case "ArrowLeft":
      case "ArrowDown":
        nextValue -= 2;
        break;
      case "ArrowRight":
      case "ArrowUp":
        nextValue += 2;
        break;
      case "PageDown":
        nextValue -= 10;
        break;
      case "PageUp":
        nextValue += 10;
        break;
      case "Home":
        nextValue = 0;
        break;
      case "End":
        nextValue = 100;
        break;
      default:
        return;
    }
    event.preventDefault();
    this._setPercentage(nextValue);
  }
  _setPercentage(value) {
    const percentage = Math.min(Math.max(value, 0), 100);
    this._currentX = this.minOffset + (this.maxOffset - this.minOffset) * percentage / 100;
    this._offsetX = this._currentX;
    this._updatePosition();
  }
  _updatePosition() {
    this._parentSection.style.setProperty(
      "--clip-path-offset",
      `${this._currentX.toFixed(1)}px`
    );
    const range = this.maxOffset - this.minOffset;
    const percentage = range > 0
      ? Math.round((this._currentX - this.minOffset) / range * 100)
      : 0;
    this.setAttribute("aria-valuenow", String(Math.min(Math.max(percentage, 0), 100)));
  }
  _recalculateOffset() {
    const currentValue = Number(this.getAttribute("aria-valuenow"));
    this._setPercentage(Number.isFinite(currentValue) ? currentValue : 50);
  }
};
window.customElements.get("split-cursor") ||
  window.customElements.define("split-cursor", SplitCursor);
var InfoPopup = class extends HTMLElement {
  connectedCallback() {
    this._button = this.querySelector(".ds-info-popup-trigger");
    this._popup = this.querySelector(".ds-info-popup-body");
    if (!this._button || !this._popup) return;
    this._onButtonClick = () => this.toggle(this._button.getAttribute("aria-expanded") !== "true");
    this._onKeyDown = (event) => {
      if (event.key === "Escape" && this._button.getAttribute("aria-expanded") === "true") {
        event.preventDefault();
        this.toggle(false);
        this._button.focus();
      }
    };
    this._onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.toggle(false);
    };
    this._button.addEventListener("click", this._onButtonClick);
    this.addEventListener("keydown", this._onKeyDown);
    document.addEventListener("click", this._onDocumentClick);
  }
  disconnectedCallback() {
    this._button?.removeEventListener("click", this._onButtonClick);
    this.removeEventListener("keydown", this._onKeyDown);
    document.removeEventListener("click", this._onDocumentClick);
  }
  toggle(open) {
    if (!this._button || !this._popup) return;
    if (open) {
      document.querySelectorAll("info-popup .ds-info-popup-trigger[aria-expanded='true']").forEach((button) => {
        if (button !== this._button) button.closest("info-popup")?.toggle(false);
      });
    }
    this._button.setAttribute("aria-expanded", String(open));
    this._popup.hidden = !open;
  }
};
window.customElements.get("info-popup") ||
  window.customElements.define("info-popup", InfoPopup);
import { timeline as timeline8, inView as inView6 } from "vendor";
var CollectionList = class extends HTMLElement {
  connectedCallback() {
    window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
      inView6(this, this._reveal.bind(this), { margin: "-100px" });
  }
  _reveal() {
    const toReveal = Array.from(this.querySelectorAll("[reveal-js]"));
    timeline8([
      [toReveal, { opacity: 1 }, { duration: 0 }],
      [
        toReveal.map((item) => item.querySelector("img, svg")),
        { opacity: [0, 1], transform: ["scale(1.03)", "auto"] },
        { duration: 0.2 },
      ],
      [
        toReveal.map((item) =>
          item.querySelector(".collection-card__content-wrapper")
        ),
        { opacity: [0, 1] },
        { duration: 0.2 },
      ],
    ]);
  }
};
window.customElements.get("collection-list") ||
  window.customElements.define("collection-list", CollectionList);
import { Delegate as Delegate5 } from "vendor";
var AccountLogin = class extends HTMLElement {
  connectedCallback() {
    (this.recoverForm = this.querySelector("#recover")),
      (this.loginForm = this.querySelector("#login")),
      window.location.hash === "#recover" && this._switchForms(),
      new Delegate5(this).on(
        "click",
        '[href="#recover"], [href="#login"]',
        this._switchForms.bind(this)
      );
  }
  _switchForms(event) {
    event && event.preventDefault(),
      (this.recoverForm.hidden = !this.recoverForm.hidden),
      (this.loginForm.hidden = !this.loginForm.hidden);
  }
};
window.customElements.get("account-login") ||
  window.customElements.define("account-login", AccountLogin);
import {
  animate as animate11,
  timeline as timeline9,
  stagger as stagger5,
  Delegate as Delegate6,
} from "vendor";
var reduceMenuAnimation = window.themeVariables.settings.reduceMenuAnimation,
  StoreHeader = class extends HTMLElement {
    connectedCallback() {
      this.hasAttribute("hide-on-scroll") &&
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
        ((this._lastScrollTop = 0),
        (this._accumulatedScroll = 0),
        (this._isVisible = !0),
        (this._hasSwitchedToSticky = !1),
        window.addEventListener("scroll", throttle(this._onScroll.bind(this)))),
        this.addEventListener("toggle", this._checkTransparency.bind(this), {
          capture: !0,
        }),
        window.addEventListener("pageshow", (event) => {
          event.persisted &&
            (this.classList.remove("is-filled"),
            this._setupTransparentHeader());
        }),
        this._setupTransparentHeader(),
        this.hasAttribute("sticky") &&
          Shopify.designMode &&
          (document.addEventListener(
            "shopify:section:load",
            this._setupTransparentHeader.bind(this)
          ),
          document.addEventListener(
            "shopify:section:unload",
            this._setupTransparentHeader.bind(this)
          ),
          document.addEventListener(
            "shopify:section:reorder",
            this._setupTransparentHeader.bind(this)
          ));
    }
    async hide() {
      this._isVisible &&
        ((this._isVisible = !1),
        document.documentElement.style.setProperty("--header-is-visible", "0"),
        await animate11(
          this,
          { transform: ["translateY(0)", "translateY(-100%)"] },
          { duration: 0.2, easing: "ease" }
        ).finished,
        (this.closest(".shopify-section").style.visibility = "hidden"));
    }
    show() {
      this._isVisible ||
        ((this.closest(".shopify-section").style.visibility = "visible"),
        document.documentElement.style.setProperty("--header-is-visible", "1"),
        animate11(
          this,
          { transform: ["translateY(-100%)", "translateY(0)"] },
          { duration: 0.2, easing: "ease" }
        ),
        (this._accumulatedScroll = 0),
        (this._isVisible = !0));
    }
    _onScroll() {
      window.scrollY < 0 ||
        ((this._accumulatedScroll = Math.max(
          0,
          this._accumulatedScroll + (window.scrollY - this._lastScrollTop)
        )),
        window.scrollY < this._lastScrollTop
          ? this.show()
          : this._accumulatedScroll >
              parseInt(this.getAttribute("hide-on-scroll")) &&
            this.querySelectorAll("[open]").length === 0 &&
            this.hide(),
        (this._lastScrollTop = window.scrollY));
    }
    _checkTransparency() {
      let hasFallbackScrollDetection = !1;
      CSS.supports("selector(:has(> *))") &&
      this.hasAttribute("sticky") &&
      !this.hasAttribute("hide-on-scroll") &&
      this.hasAttribute("allow-transparency")
        ? this.querySelectorAll("[open]").length > 0
          ? this.classList.add("is-filled")
          : window.scrollY >= 500 && !this._hasSwitchedToSticky
          ? ((this._hasSwitchedToSticky = !0),
            this.classList.add("is-filled"),
            animate11(
              this,
              { transform: ["translateY(-100%)", "translateY(0)"] },
              { duration: 0.15, easing: "ease" }
            ))
          : window.scrollY < 500 &&
            (this._hasSwitchedToSticky
              ? ((this._hasSwitchedToSticky = !1),
                animate11(
                  this,
                  { transform: ["translateY(0)", "translateY(-100%)"] },
                  { duration: 0.15, easing: "ease" }
                ).finished.then(() => {
                  (this.style.transform = null),
                    this.classList.remove("is-filled");
                }))
              : this.getAnimations().length === 0 &&
                this.classList.remove("is-filled"))
        : ((hasFallbackScrollDetection = window.scrollY > 20),
          this.classList.toggle(
            "is-filled",
            !this.hasAttribute("allow-transparency") ||
              this.querySelectorAll("[open]").length > 0 ||
              hasFallbackScrollDetection
          ));
    }
    _setupTransparentHeader() {
      document.querySelector(
        ".shopify-section:first-child [allow-transparent-header]"
      )
        ? (this.setAttribute("allow-transparency", ""),
          this.addEventListener(
            "mouseenter",
            this._checkTransparency.bind(this)
          ),
          this.addEventListener(
            "mouseleave",
            this._checkTransparency.bind(this)
          ),
          this.hasAttribute("sticky") &&
            window.addEventListener(
              "scroll",
              throttle(this._checkTransparency.bind(this))
            ),
          this._checkTransparency())
        : this.removeAttribute("allow-transparency");
    }
  },
  DropdownDisclosure = class _DropdownDisclosure extends AnimatedDetails {
    constructor() {
      super(),
        (this._detectClickOutsideListener =
          this._detectClickOutside.bind(this)),
        (this._detectEscKeyboardListener = this._detectEscKeyboard.bind(this)),
        (this._detectFocusOutListener = this._detectFocusOut.bind(this)),
        (this._detectHoverListener = this._detectHover.bind(this)),
        (this._hoverTimer = null),
        this.addEventListener(
          "mouseover",
          this._detectHoverListener.bind(this)
        ),
        this.addEventListener("mouseout", this._detectHoverListener.bind(this));
    }
    get trigger() {
      return window.matchMedia("screen and (pointer: fine)").matches
        ? this.getAttribute("trigger")
        : "click";
    }
    get mouseOverDelayTolerance() {
      return 250;
    }
    _onSummaryClicked(event) {
      this.trigger === "hover"
        ? event.detail === 0
          ? super._onSummaryClicked(event)
          : (event.preventDefault(),
            event.currentTarget.hasAttribute("data-url") &&
              (window.location.href =
                event.currentTarget.getAttribute("data-url")))
        : super._onSummaryClicked(event);
    }
    async _transition(value) {
      if (value) {
        this.setAttribute("open", ""),
          document.addEventListener("click", this._detectClickOutsideListener),
          document.addEventListener("keydown", this._detectEscKeyboardListener),
          document.addEventListener("focusout", this._detectFocusOutListener);
        const openSiblings = Array.from(
          this.closest("ul").querySelectorAll("[open]")
        ).filter((item) => item !== this);
        openSiblings.forEach((sibling) => (sibling.open = !1)),
          await this._transitionIn(openSiblings.length > 0);
      } else
        document.removeEventListener("click", this._detectClickOutsideListener),
          document.removeEventListener(
            "keydown",
            this._detectEscKeyboardListener
          ),
          document.removeEventListener(
            "focusout",
            this._detectFocusOutListener
          ),
          await this._transitionOut(),
          this.removeAttribute("open");
    }
    _transitionIn(hasOpenSiblings = !1) {
      const timelineSequence = [
        [this.contentElement, { opacity: 1 }, { duration: 0.2 }],
      ];
      return (
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
          !reduceMenuAnimation &&
          timelineSequence.push([
            this.contentElement.querySelectorAll(":scope > ul > li"),
            {
              opacity: [0, 1],
              transform: ["translateY(-10px)", "translateY(0)"],
            },
            { delay: stagger5(0.025), at: "-0.1", duration: 0.2 },
          ]),
        timeline9(timelineSequence, { delay: hasOpenSiblings > 0 ? 0.1 : 0 })
          .finished
      );
    }
    _transitionOut() {
      return timeline9([
        [this.contentElement, { opacity: 0 }, { duration: 0.2 }],
      ]).finished;
    }
    _detectClickOutside(event) {
      this.trigger === "click" &&
        !this.contains(event.target) &&
        !(event.target.closest("details") instanceof _DropdownDisclosure) &&
        (this.open = !1);
    }
    _detectHover(event) {
      this.trigger === "hover" &&
        (event.type === "mouseover"
          ? ((this.open = !0), clearTimeout(this._hoverTimer))
          : (this._hoverTimer = setTimeout(
              () => (this.open = !1),
              this.mouseOverDelayTolerance
            )));
    }
    _detectEscKeyboard(event) {
      if (event.code === "Escape") {
        const targetMenu = event.target.closest("details[open]");
        targetMenu && (targetMenu.open = !1);
      }
    }
    _detectFocusOut(event) {
      event.relatedTarget &&
        !this.contains(event.relatedTarget) &&
        (this.open = !1);
    }
  },
  MegaMenuDisclosure = class extends DropdownDisclosure {
    constructor() {
      super(),
        this.addEventListener("pointerover", this._preloadImages.bind(this));
    }
    get mouseOverDelayTolerance() {
      return 500;
    }
    _transitionIn(hasOpenSiblings) {
      const timelineSequence = [
          [this.contentElement, { opacity: 1 }, { duration: 0.2 }],
          "mega-menu",
        ],
        contentDelay = hasOpenSiblings ? 0.1 : 0;
      return (
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
          !reduceMenuAnimation &&
          (this.contentElement
            .querySelectorAll(".mega-menu__promo")
            .forEach((promo) => {
              timelineSequence.push(
                [
                  promo,
                  { opacity: [0, 1] },
                  { duration: 0.25, delay: contentDelay, at: "mega-menu" },
                ],
                "mega-menu-promo"
              );
            }),
          this.contentElement
            .querySelectorAll(".mega-menu__nav > li")
            .forEach((column) => {
              timelineSequence.push([
                column.querySelectorAll(":scope > :first-child, :scope li"),
                {
                  opacity: [0, 1],
                  transform: ["translateY(-10px)", "translateY(0)"],
                },
                {
                  easing: "ease",
                  delay: stagger5(0.025, { start: contentDelay }),
                  at: "mega-menu",
                  duration: 0.2,
                },
              ]);
            })),
        timeline9(timelineSequence).finished
      );
    }
    _preloadImages() {
      Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach(
        (image) => image.setAttribute("loading", "eager")
      );
    }
  },
  MegaMenuPromoCarousel = class extends EffectCarousel {
    connectedCallback() {
      super.connectedCallback(),
        this.nextElementSibling &&
          this.addEventListener("carousel:select", (event) =>
            this._updateControlsColor(event.detail.slide)
          ),
        this._updateControlsColor(this.items[this.selectedIndex]);
    }
    _updateControlsColor(slide) {
      if (!this.nextElementSibling) return;
      const extractFrom = slide.classList.contains("content-over-media")
        ? slide
        : slide.firstElementChild;
      this.nextElementSibling.style.setProperty(
        "--text-color",
        extractFrom.style.getPropertyValue("--text-color")
      );
    }
  },
  NavigationDrawer = class extends Drawer {
    constructor() {
      super(),
        new Delegate6(this).on(
          "click",
          "button[data-panel]",
          this._onPanelButtonClick.bind(this)
        ),
        (this._isTransitioning = !1),
        this.addEventListener("dialog:after-hide", () => {
          this.reinitializeDrawer();
        });
    }
    get openFrom() {
      return window.matchMedia("(max-width: 699px)").matches
        ? this.getAttribute("mobile-opening")
        : super.openFrom;
    }
    get _shouldSlideFromLeft() {
      return this.id === "header-sidebar-menu" && this.openFrom === "left";
    }
    get _hiddenSideTransform() {
      return document.dir === "rtl" ? "translateX(100%)" : "translateX(-100%)";
    }
    _showTransition(animate19 = !0) {
      if (!this._shouldSlideFromLeft || reduceDrawerAnimation)
        return super._showTransition(animate19);
      this._setInitialPosition();
      const content = this.shadowRoot.querySelector('[part="content"]'),
        overlay = this.shadowRoot.querySelector('[part="overlay"]'),
        closeButton = this.shadowRoot.querySelector(
          '[part="outside-close-button"]'
        ),
        animationControls = motionTimeline([
          [
            this,
            { opacity: 1, visibility: "visible" },
            { duration: 0 },
          ],
          [overlay, { opacity: [0, 1] }, { duration: 0.3 }],
          [
            content,
            {
              transform: [this._hiddenSideTransform, "translateX(0%)"],
            },
            { at: "<", duration: 0.4, easing: [0.16, 1, 0.3, 1] },
          ],
          [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
        ]);
      return (
        animate19 ? animationControls.play() : animationControls.finish(),
        animationControls.finished.then(() =>
          this.classList.add("show-close-cursor")
        )
      );
    }
    _hideTransition() {
      if (!this._shouldSlideFromLeft || reduceDrawerAnimation)
        return super._hideTransition();
      const content = this.shadowRoot.querySelector('[part="content"]'),
        overlay = this.shadowRoot.querySelector('[part="overlay"]'),
        closeButton = this.shadowRoot.querySelector(
          '[part="outside-close-button"]'
        ),
        animationControls = motionTimeline([
          [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
          [overlay, { opacity: [null, 0] }, { at: "<", duration: 0.3 }],
          [
            content,
            {
              transform: ["translateX(0%)", this._hiddenSideTransform],
            },
            { at: "<", duration: 0.4, easing: [0.7, 0, 0.84, 0] },
          ],
        ]);
      return animationControls.finished.then(() => {
        this.style.opacity = "0";
        this.style.visibility = "hidden";
        this.classList.remove("show-close-cursor");
      });
    }
    switchToPanel(panelIndex, linkListIndex = null) {
      const panels = this.querySelectorAll(".panel");
      let panelToHideTransform,
        panelToShowTransform,
        panelToHide =
          linkListIndex !== null
            ? panels[parseInt(panelIndex) - 1]
            : panels[parseInt(panelIndex) + 1],
        panelToShow = panels[panelIndex],
        linkLists = panelToShow.querySelectorAll(".panel__wrapper"),
        timelineSequence = [];
      document.dir === "rtl"
        ? ((panelToHideTransform =
            linkListIndex !== null
              ? ["translateX(0%)", "translateX(100%)"]
              : ["translateX(0%)", "translateX(-100%)"]),
          (panelToShowTransform =
            linkListIndex !== null
              ? ["translateX(-100%)", "translateX(0%)"]
              : ["translateX(100%)", "translateX(0%)"]))
        : ((panelToHideTransform =
            linkListIndex !== null
              ? ["translateX(0%)", "translateX(-100%)"]
              : ["translateX(0%)", "translateX(100%)"]),
          (panelToShowTransform =
            linkListIndex !== null
              ? ["translateX(100%)", "translateX(0%)"]
              : ["translateX(-100%)", "translateX(0%)"])),
        timelineSequence.push(
          [
            panelToHide,
            {
              transform: panelToHideTransform,
              opacity: [1, 0],
              visibility: ["visible", "hidden"],
            },
            {
              duration: 0.3,
              opacity: { at: "+0.3" },
              transform: { at: "+0.3" },
            },
          ],
          "panelHidden",
          [
            panelToShow,
            {
              opacity: [0, 1],
              visibility: ["hidden", "visible"],
              transform: panelToShowTransform,
            },
            { at: "<", transform: { duration: 0.3 } },
          ]
        ),
        linkListIndex !== null &&
          timelineSequence.push(this.switchLinkList(linkLists, linkListIndex)),
        timeline9(timelineSequence);
    }
    showPanel(panelIndex, linkListIndex = null) {
      const panels = this.querySelectorAll(".panel");
      let timelineSequence = [],
        panelToShow = panels[panelIndex],
        linkLists = panelToShow.querySelectorAll(".panel__wrapper");
      !panelToShow.hasAttribute("open") &&
        !this._isTransitioning &&
        ((this._isTransitioning = !0),
        timelineSequence.push(
          [
            this,
            {
              width: [
                this.offsetWidth + "px",
                (this.offsetWidth -
                  parseInt(
                    window.getComputedStyle(this).getPropertyValue("padding")
                  )) *
                  2 +
                  "px",
              ],
            },
            { duration: 0.2 },
          ],
          [
            panelToShow,
            { opacity: [0, 1], visibility: ["hidden", "visible"] },
            { at: "<" },
          ]
        ),
        timelineSequence.push(this.switchLinkList(linkLists, linkListIndex))),
        this.previousLinkIndex &&
          this.previousLinkIndex !== linkListIndex &&
          timelineSequence.push([
            linkLists[this.previousLinkIndex],
            { opacity: [1, 0], visibility: ["visible", "hidden"] },
            { duration: 0.2 },
          ]),
        timeline9(timelineSequence).finished.then(() => {
          this.previousLinkIndex &&
            this.previousLinkIndex !== linkListIndex &&
            linkLists[this.previousLinkIndex].removeAttribute("style"),
            panelToShow.hasAttribute("open") &&
              this.previousLinkIndex !== linkListIndex &&
              timeline9([this.switchLinkList(linkLists, linkListIndex)]),
            (this.previousLinkIndex = linkListIndex),
            panelToShow.setAttribute("open", ""),
            (this._isTransitioning = !1);
        });
    }
    switchLinkList(linkLists, linkListIndex) {
      return (
        Array.from(linkLists).forEach((item) => {
          item.setAttribute("hidden", "");
        }),
        linkLists[linkListIndex].removeAttribute("hidden"),
        [
          linkLists[linkListIndex].querySelectorAll("li"),
          {
            opacity: [0, 1],
            visibility: ["hidden", "visible"],
            transform: ["translateY(-10px)", "translateY(0)"],
          },
          {
            easing: "ease",
            duration: 0.2,
            at: "-0.15",
            delay: stagger5(0.025, { start: 0.1 }),
          },
        ]
      );
    }
    reinitializeDrawer() {
      if (
        this.hasAttribute("mega-menu") &&
        window.matchMedia("(min-width:1150px)").matches
      )
        this.style.removeProperty("width"), this.setExpanded();
      else {
        const firstPanel = this.querySelector(".panel:first-child");
        (firstPanel.style.opacity = "1"),
          (firstPanel.style.visibility = "visible"),
          (firstPanel.style.transform = "translateX(0%)");
      }
      Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach(
        (item) => {
          this.hasAttribute("mega-menu") && item.removeAttribute("open"),
            (item.style.opacity = "0"),
            (item.style.visibility = "hidden"),
            Array.from(item.querySelectorAll(".panel__wrapper")).forEach(
              (list) => list.setAttribute("hidden", "")
            );
        }
      );
    }
    setExpanded(target) {
      Array.from(this.querySelectorAll("button[data-panel]")).forEach(
        (item) => {
          item.setAttribute("aria-expanded", "false");
        }
      ),
        target && target.setAttribute("aria-expanded", "true");
    }
    _onPanelButtonClick(event, target) {
      this.hasAttribute("mega-menu") &&
      window.matchMedia("(min-width:1150px)").matches
        ? (this.setExpanded(target),
          this.showPanel(...target.getAttribute("data-panel").split("-")))
        : this.switchToPanel(...target.getAttribute("data-panel").split("-"));
    }
  };
window.customElements.get("store-header") ||
  window.customElements.define("store-header", StoreHeader),
  window.customElements.get("dropdown-disclosure") ||
    window.customElements.define("dropdown-disclosure", DropdownDisclosure, {
      extends: "details",
    }),
  window.customElements.get("mega-menu-disclosure") ||
    window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure, {
      extends: "details",
    }),
  window.customElements.get("mega-menu-promo-carousel") ||
    window.customElements.define(
      "mega-menu-promo-carousel",
      MegaMenuPromoCarousel
    ),
  window.customElements.get("navigation-drawer") ||
    window.customElements.define("navigation-drawer", NavigationDrawer);
import { animate as motionAnimate3, scroll } from "vendor";
var FeatureChart = class extends HTMLElement {
  connectedCallback() {
    if (
      ((this.viewButtonElement = this.querySelector(
        '[data-action="toggle-rows"]'
      )),
      (this.featureChartTable = this.querySelector(".feature-chart__table")),
      (this.featureChartRows = Array.from(this.featureChartTable.childNodes)),
      (this.featureProductRow = this.querySelector(
        ".feature-chart__table-row--product"
      )),
      (this.featureChartSticky = this.querySelector(
        ".feature-chart__table-row--sticky"
      )),
      this.viewButtonElement &&
        this.viewButtonElement.addEventListener(
          "click",
          this._toggleRows.bind(this)
        ),
      this.featureChartSticky)
    ) {
      (this.featureChartSticky.style.width = `${this.featureChartTable.scrollWidth}px`),
        this.featureChartTable.addEventListener("scroll", (event) => {
          this.featureChartSticky.style.marginLeft =
            -1 * event.target.scrollLeft + "px";
        }),
        new ResizeObserver((entries) => {
          this.featureChartSticky.style.width = `${entries[0].contentRect.width}px`;
        }).observe(this.featureChartTable);
      const offset = getComputedStyle(this).scrollPaddingTop;
      scroll(
        ({ y }) => {
          y.current >=
            y.targetOffset + this.featureProductRow.clientHeight / 2 &&
          y.progress < 0.85
            ? this.featureChartSticky.classList.add("is-visible")
            : this.featureChartSticky.classList.remove("is-visible");
        },
        {
          target: this.featureChartTable,
          offset: [`${offset} start`, `end ${offset}`],
        }
      );
    }
  }
  _toggleRows() {
    this.classList.contains("is-expanded")
      ? this._hideRows()
      : this._showRows();
  }
  async _showRows() {
    const fromHeight = this.featureChartTable.clientHeight;
    this.featureChartRows.forEach((row) => {
      row.hidden = !1;
    }),
      (this.viewButtonElement.querySelector(
        ".feature-chart__toggle-text"
      ).innerText = this.viewButtonElement.getAttribute("data-view-less")),
      this.classList.add("is-expanded"),
      await motionAnimate3(this.featureChartTable, {
        height: [`${fromHeight}px`, `${this.featureChartTable.clientHeight}px`],
      }).finished,
      (this.featureChartTable.style.height = "auto");
  }
  async _hideRows() {
    let fromHeight = this.featureChartTable.clientHeight,
      toHeight = 0;
    this.featureChartRows
      .slice(0, parseInt(this.getAttribute("max-rows")))
      .forEach((row) => {
        toHeight += row.clientHeight;
      }),
      (this.viewButtonElement.querySelector(
        ".feature-chart__toggle-text"
      ).innerText = this.viewButtonElement.getAttribute("data-view-more")),
      this.classList.remove("is-expanded"),
      await motionAnimate3(this.featureChartTable, {
        height: [`${fromHeight}px`, `${toHeight}px`],
      }).finished,
      this.featureChartRows
        .slice(parseInt(this.getAttribute("max-rows")))
        .forEach((row) => (row.hidden = !0)),
      (this.featureChartTable.style.height = "auto");
  }
};
window.customElements.get("feature-chart") ||
  window.customElements.define("feature-chart", FeatureChart);
import {
  scroll as scroll2,
  timeline as timeline10,
  animate as animate12,
  inView as inView7,
} from "vendor";
var ImageBanner = class extends HTMLElement {
  connectedCallback() {
    this.parallax &&
      window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
      this._setupParallax(),
      inView7(this, async () => {
        await imageLoaded(
          Array.from(
            this.querySelectorAll(
              ":scope > :is(img, video, iframe, svg, video-media)"
            )
          )
        );
        const headings = Array.from(
          this.querySelectorAll('[reveal-on-scroll="true"]')
        );
        timeline10([
          [this, { opacity: [0, 1] }, { duration: 0.25 }],
          ...headings.map((heading) => [...getHeadingKeyframe(heading)]),
        ]);
      });
  }
  get parallax() {
    return this.hasAttribute("parallax")
      ? parseFloat(this.getAttribute("parallax"))
      : !1;
  }
  _setupParallax() {
    const media = Array.from(
        this.querySelectorAll(
          ":scope > :is(img, video, iframe, svg, video-media, picture)"
        )
      ),
      [scale, translate] = [
        1 + this.parallax,
        (this.parallax * 100) / (1 + this.parallax),
      ];
    scroll2(
      animate12(
        media,
        {
          transform: [
            `scale(${scale}) translateY(-${translate}%)`,
            `scale(${scale}) translateY(0)`,
          ],
        },
        { easing: "linear" }
      ),
      { target: this, offset: ["start end", "end start"] }
    );
  }
};
window.customElements.get("image-banner") ||
  window.customElements.define("image-banner", ImageBanner);
var ImageLinkBlocks = class extends HTMLElement {
  connectedCallback() {
    (this.items = Array.from(this.children)),
      new ScrollArea(this),
      this.addEventListener("control:prev", this._prev),
      this.addEventListener("control:next", this._next);
  }
  _prev() {
    this.scrollBy({
      left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth,
      behavior: "smooth",
    });
  }
  _next() {
    this.scrollBy({
      left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth,
      behavior: "smooth",
    });
  }
};
window.customElements.get("image-link-blocks") ||
  window.customElements.define("image-link-blocks", ImageLinkBlocks);
import {
  animate as animate13,
  timeline as timeline11,
  inView as inView8,
} from "vendor";
var ImagesWithTextScrolling = class extends HTMLElement {
  connectedCallback() {
    inView8(this, this._reveal.bind(this)),
      this.hasAttribute("scrolling-experience") &&
        ((this._imageToTransitionItems = Array.from(
          this.querySelectorAll(
            ".images-scrolling-desktop__media-wrapper > :not(:first-child)"
          )
        )),
        (this._mainImage = this.querySelector(
          ".images-scrolling-desktop__media-wrapper > :first-child"
        )),
        (this._contentItems = Array.from(
          this.querySelectorAll(".images-scrolling__content")
        )),
        this._imageToTransitionItems.length > 0 &&
          window.addEventListener(
            "scroll",
            throttle(this._onScroll.bind(this))
          ));
  }
  _reveal() {
    Array.from(this.querySelectorAll('[reveal-on-scroll="true"]')).forEach(
      (heading) => {
        animate13(...getHeadingKeyframe(heading));
      }
    );
  }
  _onScroll() {
    const imageRect = this._mainImage.getBoundingClientRect(),
      imageBottom = imageRect.bottom,
      imageEffect = this.getAttribute("scrolling-experience");
    for (const [index, contentItem] of this._contentItems.entries()) {
      const contentItemRect = contentItem.getBoundingClientRect(),
        image = this._imageToTransitionItems[index - 1],
        content = this._contentItems[index];
      if (
        contentItemRect.top < imageBottom - imageRect.height * 0.1 &&
        contentItemRect.bottom > imageBottom
      ) {
        image &&
          !image.classList.contains("is-visible") &&
          (image.classList.add("is-visible"),
          imageEffect === "fade"
            ? timeline11([
                [image, { opacity: [null, 1] }, { duration: 0.2 }],
                [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
              ])
            : timeline11([
                [
                  image,
                  {
                    opacity: [null, 1],
                    clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"],
                  },
                  {
                    duration: 0.35,
                    easing: [0.99, 0.01, 0.5, 0.94],
                    opacity: { duration: 0 },
                  },
                ],
                [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
              ]));
        break;
      }
      if (contentItemRect.top > imageBottom - imageRect.height * 0.1) {
        image &&
          image.classList.contains("is-visible") &&
          (image.classList.remove("is-visible"),
          imageEffect === "fade"
            ? timeline11([
                [image, { opacity: [null, 0] }, { duration: 0.2 }],
                [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
              ])
            : timeline11([
                [
                  image,
                  {
                    opacity: [null, 1],
                    clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"],
                  },
                  {
                    duration: 0.35,
                    easing: [0.99, 0.01, 0.5, 0.94],
                    opacity: { duration: 0 },
                  },
                ],
                [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
              ]));
        break;
      }
    }
  }
};
window.customElements.get("images-with-text-scrolling") ||
  window.customElements.define(
    "images-with-text-scrolling",
    ImagesWithTextScrolling
  );
import { animate as animate14, inView as inView9 } from "vendor";
var ImpactText = class extends HTMLElement {
  connectedCallback() {
    window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
      inView9(this, ({ target }) => this._onBecameVisible(target), {
        margin: "-100px",
      });
  }
  async _onBecameVisible(target) {
    if (
      (animate14(
        target,
        { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] },
        { duration: 0.3 }
      ),
      this.hasAttribute("count-up"))
    ) {
      const itemToSearch =
          this.childElementCount === 0 ? this : this.firstElementChild,
        matches = itemToSearch.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
      if (!matches) return;
      itemToSearch.innerHTML = itemToSearch.textContent.replace(
        /\d+(?:[,. ]\d+)*/,
        `<span>${matches[0]}</span>`
      );
      const numberSpan = itemToSearch.querySelector("span");
      (numberSpan.style.textAlign =
        matches[0] === matches.input ? null : "end"),
        itemToSearch.classList.contains("text-gradient") ||
          ((numberSpan.style.display = "inline-block"),
          (numberSpan.style.minWidth = `${numberSpan.clientWidth}px`));
      const toReplace = matches[0].replace(/[,\. ]+/, ""),
        charactersMatches = [...matches[0].matchAll(/[,\. ]+/g)];
      await animate14(
        (progress) => {
          let formattedString = Math.round(
            progress * parseInt(toReplace)
          ).toString();
          charactersMatches.forEach((character) => {
            formattedString.length >= matches[0].length - character.index &&
              (formattedString =
                formattedString.slice(0, character.index) +
                character[0] +
                formattedString.slice(character.index));
          }),
            (numberSpan.textContent =
              progress === 1 ? matches[0] : formattedString);
        },
        {
          duration: parseFloat(this.getAttribute("count-up")),
          easing: [0.16, 1, 0.3, 1],
        }
      ).finished,
        (numberSpan.style.minWidth = null);
    }
  }
};
window.customElements.get("impact-text") ||
  window.customElements.define("impact-text", ImpactText);
import { timeline as timeline12, inView as inView10 } from "vendor";
var MediaGrid = class extends HTMLElement {
  connectedCallback() {
    (this.items = Array.from(this.children)),
      window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
        inView10(this, this._onBecameVisible.bind(this));
  }
  _onBecameVisible() {
    const contentElements = this.querySelectorAll(
      ".content-over-media > :not(img, video, iframe, svg, video-media, native-video, external-video)"
    );
    timeline12([
      [
        this.items,
        { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] },
        { duration: 0.3 },
      ],
      [contentElements, { opacity: [0, 1] }, { duration: 0.2, at: "+0.1" }],
    ]);
  }
};
window.customElements.get("media-grid") ||
  window.customElements.define("media-grid", MediaGrid);
import {
  animate as animate15,
  timeline as timeline13,
  inView as inView11,
} from "vendor";
var reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: no-preference)"
  ).matches,
  MediaWithText = class extends HTMLElement {
    connectedCallback() {
      reduceMotion &&
        Array.from(this.querySelectorAll(".media-with-text__item")).forEach(
          (item) => {
            inView11(item, (observer) => this.reveal(observer.target));
          }
        );
    }
    reveal(item) {
      const media = item.querySelector(".media-with-text__media");
      imageLoaded(media.querySelector("img")).then(() => {
        timeline13([
          [media, { opacity: [0, 1] }, { duration: 0.3 }],
          [
            media.querySelector("img, video-media"),
            { transform: ["scale(1.05)", "scale(1)"] },
            { duration: 0.3, at: "<" },
          ],
        ]);
      }),
        animate15(
          item.querySelector(".media-with-text__content > .prose"),
          { opacity: [0, 1] },
          { duration: 0.2, delay: 0.3 }
        );
    }
  };
window.customElements.get("media-with-text") ||
  window.customElements.define("media-with-text", MediaWithText);
import {
  timeline as timeline14,
  animate as animate16,
  stagger as stagger6,
  inView as inView12,
} from "vendor";
var MultipleImagesWithText = class extends HTMLElement {
    constructor() {
      super(),
        (this._imageCarousel = this.querySelector(
          "multiple-images-with-text-image-list"
        )),
        (this._contentCarousel = this.querySelector(
          "multiple-images-with-text-content-list"
        )),
        this.addEventListener("control:prev", () => {
          this._imageCarousel.previous(), this._contentCarousel.previous();
        }),
        this.addEventListener("control:next", () => {
          this._imageCarousel.next(), this._contentCarousel.next();
        }),
        Shopify.designMode &&
          this.addEventListener("shopify:block:select", (event) => {
            event.target.hasAttribute("image-id") &&
              this._imageCarousel.select(
                this._imageCarousel.items.findIndex(
                  (item) => item.id === event.target.getAttribute("image-id")
                )
              );
          });
    }
  },
  MultipleImagesWithTextImageList = class extends EffectCarousel {
    constructor() {
      super(), inView12(this, this._reveal.bind(this));
    }
    async _reveal() {
      await imageLoaded(this.querySelectorAll("img")),
        this.getAttribute("layout") === "stacked"
          ? timeline14(
              [
                [this.lastElementChild, { transform: "rotate(0deg)" }],
                [
                  this.lastElementChild?.previousElementSibling,
                  { transform: "rotate(2deg)" },
                  { at: "<" },
                ],
                [
                  this.lastElementChild?.previousElementSibling
                    ?.previousElementSibling,
                  { transform: "rotate(-2deg)" },
                  { at: "<" },
                ],
              ],
              {
                defaultOptions: {
                  duration: 0.15,
                  easing: [0.26, 0.02, 0.27, 0.97],
                },
              }
            )
          : this.getAttribute("layout") === "collage"
          ? timeline14([
              [
                this.children,
                {
                  opacity: 1,
                  transform: ["translateY(15px)", "translateY(0)"],
                },
                { duration: 0.3, delay: stagger6(0.1) },
              ],
            ])
          : timeline14([
              [
                this.children,
                {
                  opacity: 1,
                  transform: "rotate(var(--image-rotation, 0deg))",
                },
                { duration: 0.3, delay: stagger6(0.1) },
              ],
            ]);
    }
    _transitionTo(fromSlide, toSlide, { direction, animate: animate19 }) {
      if (this.getAttribute("layout") !== "stacked") return;
      const transitionSpeed = 0.2;
      if (direction === "next") {
        const fromSlideTransform =
          getComputedStyle(fromSlide).getPropertyValue("transform");
        return timeline14(
          [
            [
              fromSlide,
              { opacity: 0, transform: "rotate(5deg) translate(40px, 10px)" },
              { duration: transitionSpeed },
            ],
            [
              toSlide,
              { zIndex: 1 },
              { duration: transitionSpeed, zIndex: { easing: "step-start" } },
            ],
            [
              fromSlide,
              { opacity: 1, transform: fromSlideTransform, zIndex: -1 },
              {
                duration: transitionSpeed,
                at: "<",
                zIndex: { easing: "step-start" },
              },
            ],
            [
              toSlide.previousElementSibling,
              { zIndex: 0 },
              { at: "<", easing: "step-start" },
            ],
          ],
          { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }
        ).finished;
      } else {
        const toSlideTransform =
          getComputedStyle(toSlide).getPropertyValue("transform");
        return timeline14(
          [
            [
              toSlide,
              {
                opacity: 0,
                transform: "rotate(-5deg) translate(-40px, -10px)",
              },
              { duration: transitionSpeed },
            ],
            this.items.length >= 3 && [
              fromSlide.previousElementSibling || this.lastElementChild,
              { zIndex: -1 },
              { easing: "step-start" },
            ],
            [
              toSlide,
              { opacity: 1, transform: toSlideTransform, zIndex: 1 },
              {
                duration: transitionSpeed,
                at: this.items.length >= 3 ? "<" : "+0",
                zIndex: { easing: "step-start" },
              },
            ],
            [
              fromSlide,
              { zIndex: 0 },
              {
                duration: transitionSpeed,
                at: "<",
                zIndex: { easing: "step-start" },
              },
            ],
          ].filter(Boolean),
          { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }
        ).finished;
      }
    }
  },
  MultipleImagesWithTextContentList = class extends EffectCarousel {
    constructor() {
      super(), inView12(this, this._reveal.bind(this));
    }
    _reveal() {
      animate16(
        ...getHeadingKeyframe(this.querySelector('[reveal-on-scroll="true"]'))
      );
    }
    _transitionTo(
      fromSlide,
      toSlide,
      { direction = "next", animate: animate19 = !0 } = {}
    ) {
      return (
        fromSlide.classList.remove("is-selected"),
        toSlide.classList.add("is-selected"),
        timeline14(
          [
            [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] }],
            [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }],
            [
              ...getHeadingKeyframe(
                toSlide.querySelector('[reveal-on-scroll="true"]'),
                { at: "<" }
              ),
            ],
          ],
          {
            duration: animate19
              ? parseFloat(this.getAttribute("fade-speed") || 0.5)
              : 0,
          }
        ).finished
      );
    }
  };
window.customElements.get("multiple-images-with-text") ||
  window.customElements.define(
    "multiple-images-with-text",
    MultipleImagesWithText
  ),
  window.customElements.get("multiple-images-with-text-image-list") ||
    window.customElements.define(
      "multiple-images-with-text-image-list",
      MultipleImagesWithTextImageList
    ),
  window.customElements.get("multiple-images-with-text-content-list") ||
    window.customElements.define(
      "multiple-images-with-text-content-list",
      MultipleImagesWithTextContentList
    );
var NewsletterPopup = class extends Drawer {
  connectedCallback() {
    super.connectedCallback(),
      this.shouldAppearAutomatically &&
        setTimeout(() => this.show(), this.apparitionDelay);
  }
  get initialFocus() {
    return !1;
  }
  get shouldAppendToBody() {
    return !1;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppearAutomatically() {
    return !(
      localStorage.getItem("theme:popup-filled") === "true" ||
      (this.hasAttribute("only-once") &&
        localStorage.getItem("theme:popup-appeared") === "true")
    );
  }
  _setInitialPosition() {
    (this.style.top = null),
      (this.style.bottom = "0px"),
      (this.style.left = document.dir === "ltr" ? null : "0px"),
      (this.style.right = document.dir === "rtl" ? "auto" : "0px");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue),
      name === "open" &&
        this.open &&
        localStorage.setItem("theme:popup-appeared", "true");
  }
};
window.customElements.get("newsletter-popup") ||
  window.customElements.define("newsletter-popup", NewsletterPopup);
import {
  timeline as timeline15,
  animate as animate17,
  inView as inView13,
} from "vendor";
var reduceMotion2 = window.matchMedia(
    "(prefers-reduced-motion: no-preference)"
  ).matches,
  PressCarousel = class extends EffectCarousel {
    constructor() {
      super(), reduceMotion2 && inView13(this, this._reveal.bind(this));
    }
    _reveal() {
      animate17(
        this.selectedSlide.querySelector(".blockquote"),
        { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] },
        { duration: 0.2 }
      );
    }
    async _transitionTo(fromSlide, toSlide, options = {}) {
      await timeline15([
        [
          fromSlide.querySelectorAll(".press__logo, .press__author"),
          { opacity: [null, 0] },
          { duration: 0.2 },
        ],
        [
          fromSlide.querySelector(".blockquote"),
          {
            opacity: [null, 0],
            ...(reduceMotion2 && { transform: [null, "translateY(-10px)"] }),
          },
          { duration: 0.2, at: "<" },
        ],
      ]).finished,
        fromSlide.classList.remove("is-selected"),
        toSlide.classList.add("is-selected"),
        await timeline15([
          [
            toSlide.querySelectorAll(".press__logo, .press__author"),
            { opacity: [0, 1] },
            { duration: 0.2 },
          ],
          [
            toSlide.querySelector(".blockquote"),
            {
              opacity: [0, 1],
              ...(reduceMotion2 && {
                transform: ["translateY(10px)", "translateY(0px)"],
              }),
            },
            { duration: 0.2, at: "<" },
          ],
        ]).finished;
    }
  };
window.customElements.get("press-carousel") ||
  window.customElements.define("press-carousel", PressCarousel);
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super(), (this._isLoaded = !1);
  }
  connectedCallback() {
    this._loadRecommendations();
  }
  async _loadRecommendations() {
    if (this._isLoaded) return;
    this._isLoaded = !0;
    const section = this.closest(".shopify-section"),
      intent = this.getAttribute("intent") || "related",
      url = `${
        Shopify.routes.root
      }recommendations/products?product_id=${this.getAttribute(
        "product"
      )}&limit=${
        this.getAttribute("limit") || 4
      }&section_id=${section.id.replace(
        "shopify-section-",
        ""
      )}&intent=${intent}`,
      response = await fetch(url, { priority: "low" }),
      tempDiv = new DOMParser().parseFromString(
        await response.text(),
        "text/html"
      ),
      productRecommendationsElement = tempDiv.querySelector(
        "product-recommendations"
      );
    productRecommendationsElement.childElementCount > 0
      ? this.replaceChildren(
          ...document.importNode(productRecommendationsElement, !0).childNodes
        )
      : this.hasAttribute("remove-section")
      ? section.remove()
      : this.remove();
  }
};
window.customElements.get("product-recommendations") ||
  window.customElements.define(
    "product-recommendations",
    ProductRecommendations
  );
var _isLoaded,
  _RecentlyViewedProducts_instances,
  searchQueryString_get,
  loadProducts_fn,
  RecentlyViewedProducts = class extends HTMLElement {
    constructor() {
      super(...arguments),
        __privateAdd(this, _RecentlyViewedProducts_instances),
        __privateAdd(this, _isLoaded, !1);
    }
    connectedCallback() {
      "requestIdleCallback" in window
        ? requestIdleCallback(
            __privateMethod(
              this,
              _RecentlyViewedProducts_instances,
              loadProducts_fn
            ).bind(this),
            { timeout: 1500 }
          )
        : __privateMethod(
            this,
            _RecentlyViewedProducts_instances,
            loadProducts_fn
          ).call(this);
    }
  };
(_isLoaded = new WeakMap()),
  (_RecentlyViewedProducts_instances = new WeakSet()),
  (searchQueryString_get = function () {
    const items = new Set(
      JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]")
    );
    return (
      this.hasAttribute("exclude-id") &&
        items.delete(parseInt(this.getAttribute("exclude-id"))),
      Array.from(items.values(), (item) => `id:${item}`)
        .slice(0, parseInt(this.getAttribute("products-count")))
        .join(" OR ")
    );
  }),
  (loadProducts_fn = async function () {
    if (__privateGet(this, _isLoaded)) return;
    __privateSet(this, _isLoaded, !0);
    const section = this.closest(".shopify-section"),
      url = `${Shopify.routes.root}search?type=product&q=${__privateGet(
        this,
        _RecentlyViewedProducts_instances,
        searchQueryString_get
      )}&section_id=${extractSectionId(section)}`,
      response = await fetch(url, { priority: "low" }),
      tempDiv = new DOMParser().parseFromString(
        await response.text(),
        "text/html"
      ),
      recentlyViewedProductsElement = tempDiv.querySelector(
        "recently-viewed-products"
      );
    recentlyViewedProductsElement.childElementCount > 0
      ? this.replaceChildren(
          ...document.importNode(recentlyViewedProductsElement, !0).childNodes
        )
      : section.remove();
  }),
  window.customElements.get("recently-viewed-products") ||
    window.customElements.define(
      "recently-viewed-products",
      RecentlyViewedProducts
    );
import {
  scroll as scroll3,
  timeline as timeline16,
  ScrollOffset,
  inView as inView14,
} from "vendor";
var RevealedImage = class extends HTMLElement {
  connectedCallback() {
    const scrollTracker = this.querySelector(".revealed-image__scroll-tracker"),
      scroller = this.querySelector(".revealed-image__scroller");
    (scrollTracker.style.height = `${scroller.clientHeight}px`),
      new ResizeObserver(
        (entries) =>
          (scrollTracker.style.height = `${entries[0].contentRect.height}px`)
      ).observe(scroller),
      scroll3(
        timeline16([
          [
            this.querySelectorAll(
              ".revealed-image__image-clipper, .revealed-image__content--inside"
            ),
            {
              clipPath: [
                "inset(37% 37% 41% 37%)",
                "inset(calc(var(--sticky-area-height) / 2) 0)",
              ],
            },
            { easing: "ease-in" },
          ],
          [
            this.querySelectorAll("img, svg"),
            {
              transform: [
                "translate(-10%, -1.5%) scale(1.4)",
                "translate(0, 0) scale(1)",
              ],
            },
            { easing: "ease-in", at: "<" },
          ],
          [
            this.querySelectorAll(".revealed-image__content"),
            { opacity: [0, 1, 1] },
            { offset: [0, 0.25, 1], at: "<" },
          ],
        ]),
        { target: scrollTracker, offset: ScrollOffset.All }
      ),
      inView14(
        this,
        () => (
          (this.style.visibility = "visible"),
          () => {
            this.style.visibility = "hidden";
          }
        ),
        { margin: "200px" }
      );
  }
};
window.customElements.get("revealed-image") ||
  window.customElements.define("revealed-image", RevealedImage);
import { animate as animate18, scroll as scroll4 } from "vendor";
var ScrollingText = class extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches)
      if (window.ScrollTimeline) {
        const timeline18 = new ViewTimeline({ subject: this, axis: "block" });
        this.animate(
          {
            transform: [
              "translateX(calc(var(--transform-logical-flip) * 50vw))",
              "translateX(calc(var(--transform-logical-flip) * 50vw - 10%))",
            ],
          },
          {
            timeline: timeline18,
            rangeStart: "cover 0%",
            rangeEnd: "cover 100%",
          }
        );
      } else
        scroll4(
          animate18(this, {
            transform: [
              "translateX(calc(var(--transform-logical-flip) * 50vw))",
              "translateX(calc(var(--transform-logical-flip) * 50vw - 10%))",
            ],
          }),
          { target: this, offset: ["start end", "end start"] }
        );
  }
};
window.customElements.get("scrolling-text") ||
  window.customElements.define("scrolling-text", ScrollingText);
var ShopTheLookDots = class extends HTMLElement {
  connectedCallback() {
    (this._abortController = new AbortController()),
      Array.from(this.children).forEach((dots) => {
        document
          .getElementById(dots.getAttribute("aria-controls"))
          .addEventListener(
            "carousel:change",
            (event) => this._onDotClicked(event),
            { signal: this._abortController.signal }
          );
      });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  _onDotClicked(event) {
    Array.from(
      this.querySelectorAll(`button:nth-child(${event.detail.index + 1})`)
    ).forEach((button) => button.click());
  }
};
window.customElements.get("shop-the-look-dots") ||
  window.customElements.define("shop-the-look-dots", ShopTheLookDots);
import {
  animate as motionAnimate4,
  timeline as timeline17,
  inView as inView15,
} from "vendor";
var Slideshow = class extends HTMLElement {
    constructor() {
      super(), this.addEventListener("carousel:select", this._onSlideSelected);
    }
    async _onSlideSelected(event) {
      const slideStyles = getComputedStyle(event.detail.slide);
      if (
        (this.style.setProperty(
          "--slideshow-controls-background",
          slideStyles.getPropertyValue("--slideshow-slide-controls-background")
        ),
        this.style.setProperty(
          "--slideshow-controls-color",
          slideStyles.getPropertyValue("--slideshow-slide-controls-color")
        ),
        !this.classList.contains("slideshow--boxed"))
      )
        return;
      const backgroundElement = this.querySelector(
          ".slideshow__slide-background"
        ),
        background = slideStyles.getPropertyValue(
          "--slideshow-slide-background"
        );
      (backgroundElement.style.background = background),
        await motionAnimate4(
          backgroundElement,
          { opacity: [0, 1] },
          { duration: 0.2 }
        ).finished,
        this.style.setProperty("--slideshow-background", background),
        motionAnimate4(backgroundElement, { opacity: 0 }, { duration: 0 });
    }
  },
  SlideshowCarousel = class extends EffectCarousel {
    _pendingAnimationControls = [];
    constructor() {
      super(),
        this.addEventListener("carousel:select", this._onSlideSelected),
        this.hasAttribute("reveal-on-scroll") &&
          inView15(this, this._reveal.bind(this)),
        this.querySelector(".slideshow__cursor") &&
          this.addEventListener("tap", this._onSlideshowTap);
    }
    connectedCallback() {
      super.connectedCallback(),
        this._player &&
          this.hasAttribute("autoplay") &&
          (this._player.addEventListener("player:start", (event) => {
            const cursorRing = this.querySelector(
              ".slideshow__cursor-ring circle"
            );
            if (cursorRing) {
              const cursorRingAnimationControl = motionAnimate4(
                cursorRing,
                {
                  strokeDasharray: [
                    `0px, ${cursorRing.getTotalLength()}px`,
                    `${cursorRing.getTotalLength()}px, ${cursorRing.getTotalLength()}px`,
                  ],
                },
                { duration: event.detail.duration, easing: "linear" }
              );
              this._pendingAnimationControls.push(cursorRingAnimationControl);
            }
            Array.from(this.querySelectorAll(".numbered-dots__item")).forEach(
              (item) => {
                const circle = item.querySelector("circle:last-child");
                let circleAnimationControl = null;
                item.getAttribute("aria-current") === "true"
                  ? (circleAnimationControl = motionAnimate4(
                      circle,
                      {
                        strokeDasharray: [
                          `0px, ${circle.getTotalLength()}px`,
                          `${circle.getTotalLength()}px, ${circle.getTotalLength()}px`,
                        ],
                      },
                      { duration: event.detail.duration, easing: "linear" }
                    ))
                  : (circleAnimationControl = motionAnimate4(
                      circle,
                      {
                        strokeDasharray: `${circle.getTotalLength()}px, ${circle.getTotalLength()}px`,
                      },
                      { duration: 0, easing: "linear" }
                    )),
                  this._pendingAnimationControls.push(circleAnimationControl);
              }
            );
          }),
          this._player.addEventListener("player:pause", () => {
            this._pendingAnimationControls.forEach((control) =>
              control.pause()
            );
          }),
          this._player.addEventListener("player:resume", () => {
            this._pendingAnimationControls.forEach((control) => control.play());
          }));
    }
    get transitionType() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "fade"
        : this.getAttribute("transition");
    }
    async _reveal() {
      const selectedSlide = this.selectedSlide;
      await imageLoaded(selectedSlide.querySelectorAll("img")),
        (this.style.opacity = "1"),
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
          (this._reloaded ||
            timeline17([
              [selectedSlide, { zIndex: 1 }, { duration: 0 }],
              [
                selectedSlide.querySelectorAll("img, video-media"),
                { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] },
                { duration: 0.3 },
              ],
              "content",
              [
                selectedSlide.querySelectorAll(
                  '[data-sequence="subheading"], .button'
                ),
                { opacity: [0, 1] },
                { duration: 0.3, at: "content" },
              ],
              [
                ...getHeadingKeyframe(
                  selectedSlide.querySelector('[data-sequence="heading"]'),
                  { duration: 0.3, at: "content" }
                ),
              ],
              [
                selectedSlide.querySelector(".button"),
                { opacity: [0, 1] },
                { duration: 0.3, at: "content" },
              ],
              [
                this.querySelector(".slideshow__controls"),
                {
                  opacity: [0, 1],
                  transform: ["translateY(10px)", "translateY(0)"],
                },
                { duration: 0.3 },
              ],
            ]));
    }
    _onSlideshowTap(event) {
      event.target.matches("button, a[href], button :scope, a[href] :scope") ||
        !window.matchMedia("screen and (pointer: fine)").matches ||
        (event.detail.originalEvent.clientX > window.innerWidth / 2
          ? this.next()
          : this.previous());
    }
    async _transitionTo(
      fromSlide,
      toSlide,
      { direction, animate: animate19 = !0 } = {}
    ) {
      fromSlide.classList.remove("is-selected"),
        toSlide.classList.add("is-selected");
      let timelineControls = null;
      switch (this.transitionType) {
        case "fade":
          timelineControls = this._fade(fromSlide, toSlide, {
            animate: animate19,
          });
          break;
        case "fade_with_text":
          timelineControls = this._fadeWithText(fromSlide, toSlide, {
            animate: animate19,
          });
          break;
      }
      return animate19 || timelineControls.finish(), timelineControls.finished;
    }
    _fade(fromSlide, toSlide) {
      return timeline17([
        [
          fromSlide,
          { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 },
          { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } },
        ],
        [
          toSlide,
          { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 },
          {
            duration: 0.3,
            at: "<",
            easing: "ease-out",
            zIndex: { easing: "step-end" },
          },
        ],
      ]);
    }
    async _fadeWithText(fromSlide, toSlide) {
      return (
        motionAnimate4(
          fromSlide,
          { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 },
          { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } }
        ),
        await imageLoaded(toSlide.querySelectorAll("img")),
        motionAnimate4(
          toSlide,
          { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 },
          { duration: 0, zIndex: { easing: "step-end" } }
        ),
        timeline17([
          [
            toSlide.querySelectorAll("img, video-media"),
            { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] },
            { duration: 0.3, easing: "ease-out" },
          ],
          "content",
          [
            toSlide.querySelectorAll('[data-sequence="subheading"], .button'),
            { opacity: [0, 1] },
            { duration: 0.3, at: "content" },
          ],
          [
            ...getHeadingKeyframe(
              toSlide.querySelector('[data-sequence="heading"]'),
              { duration: 0.3, at: "content" }
            ),
          ],
        ])
      );
    }
    async _onSlideSelected(event) {
      if (
        (Array.from(this.querySelectorAll("video-media")).forEach((video) =>
          video.pause()
        ),
        event.detail.slide.getAttribute("data-slide-type") === "video")
      ) {
        const visibleVideo = Array.from(
          event.detail.slide.querySelectorAll("video-media")
        )
          .filter((video) => video.offsetParent !== null)
          .pop();
        if ((visibleVideo.play({ restart: !0 }), this.player)) {
          const video = visibleVideo.querySelector("video");
          isNaN(video.duration) &&
            (await new Promise((resolve) => {
              video.onloadedmetadata = () => resolve();
            })),
            this._player.setDuration(video.duration);
        }
      } else this._player?.setDuration(parseInt(this.getAttribute("autoplay")));
    }
  };
window.customElements.get("x-slideshow") ||
  window.customElements.define("x-slideshow", Slideshow),
  window.customElements.get("slideshow-carousel") ||
    window.customElements.define("slideshow-carousel", SlideshowCarousel);
import { Delegate as Delegate7 } from "vendor";
(() => {
  const delegateDocument = new Delegate7(document.documentElement);
  window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
    delegateDocument.on("click", 'a[href*="#"]', (event, target) => {
      if (
        event.defaultPrevented ||
        target.pathname !== window.location.pathname ||
        target.search !== window.location.search
      )
        return;
      const url = new URL(target.href);
      if (url.hash === "") return;
      const anchorElement = document.querySelector(url.hash);
      anchorElement &&
        (event.preventDefault(),
        anchorElement.scrollIntoView({ block: "start", behavior: "smooth" }));
    });
  const setScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    scrollbarWidth > 0 &&
      document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${scrollbarWidth}px`
      );
  };
  setScrollbarWidth(),
    window.addEventListener("resize", throttle(setScrollbarWidth));
})();
export {
  AccordionDisclosure,
  AccountLogin,
  AnimatedDetails,
  AnnouncementBar,
  BuyButtons,
  CartCount,
  CartDrawer,
  CartNote,
  CartNotificationDrawer,
  CollectionList,
  ConfirmButton,
  CopyButton,
  CountrySelector,
  CustomButton,
  CustomCursor,
  DialogElement,
  Drawer,
  DropdownDisclosure,
  EffectCarousel,
  FacetApplyButton,
  FacetDialog,
  FacetDrawer,
  FacetFloatingFilter,
  FacetForm,
  FacetLink,
  FacetSortBy,
  FeatureChart,
  FreeShippingBar,
  GestureArea,
  GiftCardRecipient,
  HeightObserver,
  ImageBanner,
  ImageLinkBlocks,
  ImagesWithTextScrolling,
  ImpactText,
  LineItem,
  LineItemQuantity,
  Listbox,
  MarqueeText,
  MediaCarousel,
  MediaGrid,
  MediaWithText,
  MegaMenuDisclosure,
  MegaMenuPromoCarousel,
  ModelMedia,
  MultipleImagesWithText,
  MultipleImagesWithTextContentList,
  MultipleImagesWithTextImageList,
  NavigationDrawer,
  NewsletterPopup,
  NextButton,
  PageDots,
  PillLoader,
  Player,
  Popover,
  PredictiveSearch,
  PressCarousel,
  PrevButton,
  PriceRange,
  PrivacyBar,
  ProductCard,
  ProductForm,
  ProductGallery,
  ProductLoader,
  ProductQuickAdd,
  ProductRecommendations,
  ProductRerender,
  ProductZoomButton,
  ProgressBar,
  QuantitySelector,
  QuickBuyDrawer,
  RecentlyViewedProducts,
  ResizableTextarea,
  RevealItems,
  RevealedImage,
  SafeSticky,
  ScrollArea,
  ScrollCarousel,
  ScrollProgress,
  ScrollShadow,
  ScrollingText,
  SearchDrawer,
  SectionHeader,
  ShareButton,
  ShippingEstimator,
  ShopTheLookDots,
  Slideshow,
  SlideshowCarousel,
  SplitCursor,
  SplitLines,
  StoreHeader,
  Tabs,
  VariantPicker,
  VideoMedia,
  cachedFetch,
  createMediaImg,
  debounce,
  deepQuerySelector,
  extractSectionId,
  fetchCart,
  generateSrcset,
  getHeadingKeyframe,
  imageLoaded,
  throttle,
  waitForEvent,
};
//# sourceMappingURL=/s/files/1/0428/9907/9322/t/30/assets/theme.js.map?v=1729762781
